//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AttachmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves attachments based on optional filters for OrderId, PatientId, and WorkflowId.
    Only returns attachments linked to orders that have a populated PatientId.
     * @param orderId (optional) Optional order identifier to filter attachments.
     * @param patientId (optional) Optional patient identifier to filter attachments.
     * @param workflowId (optional) Optional workflow identifier to filter attachments.
     * @return A collection of attachments matching the specified filters.
     */
    getAttachments(orderId?: number | null | undefined, patientId?: number | null | undefined, workflowId?: number | null | undefined): Observable<GetAttachmentsQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Attachment?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (patientId !== undefined && patientId !== null)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (workflowId !== undefined && workflowId !== null)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttachmentsQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttachmentsQueryResponse[]>;
        }));
    }

    protected processGetAttachments(response: HttpResponseBase): Observable<GetAttachmentsQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAttachmentsQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves information about the currently authenticated user.
     * @return Returns the authenticated user details.
     */
    getCurrentUser(): Observable<GetAuthenticatedUserQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Auth/CurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAuthenticatedUserQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAuthenticatedUserQueryResponse>;
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<GetAuthenticatedUserQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAuthenticatedUserQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Switches the currently authenticated user's active pharmacy context.
     * @param pharmacyId The ID of the pharmacy to switch to.
     * @return Returns the updated authenticated user context successfully.
     */
    switchPharmacy(pharmacyId: number): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Auth/SwitchPharmacy/{pharmacyId}";
        if (pharmacyId === undefined || pharmacyId === null)
            throw new globalThis.Error("The parameter 'pharmacyId' must be defined.");
        url_ = url_.replace("{pharmacyId}", encodeURIComponent("" + pharmacyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchPharmacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchPharmacy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processSwitchPharmacy(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Returned when the pharmacyId is invalid or malformed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Returned when the request lacks valid authentication credentials.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Returned when the authenticated user is not authorized to switch to the given pharmacy.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Returned when an unexpected server error occurs.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the authenticated user's grid settings by key.
     * @param key (optional) The unique key identifying the grid settings to retrieve.
     * @return Returns the user's grid settings successfully.
     */
    getGridSettings(key?: string | undefined): Observable<GetGridSettingsQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Auth/GridSettings?";
        if (key === null)
            throw new globalThis.Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGridSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGridSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGridSettingsQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGridSettingsQueryResponse[]>;
        }));
    }

    protected processGetGridSettings(response: HttpResponseBase): Observable<GetGridSettingsQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetGridSettingsQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Returned when the key parameter is invalid or malformed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Returned when the request lacks valid authentication credentials.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Returned when the authenticated user is not authorized to access the resource.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Returned when an unexpected server error occurs.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saves or updates the user’s grid settings for a specific page.
     * @param cmd The command containing grid settings data to save or update.
     * @return Returns when the grid settings have been saved successfully.
     */
    saveGridSettings(cmd: UpsertGridSettingsCommand): Observable<UpsertGridSettingsCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Auth/GridSettings/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveGridSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveGridSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertGridSettingsCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertGridSettingsCommandResponse>;
        }));
    }

    protected processSaveGridSettings(response: HttpResponseBase): Observable<UpsertGridSettingsCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpsertGridSettingsCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Returned when the request body is invalid or contains malformed data.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Returned when the request lacks valid authentication credentials.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Returned when the authenticated user is not authorized to perform the action.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Returned when an unexpected server error occurs.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the user's grid settings by ID.
     * @param id The ID of the grid settings entry to delete.
     * @return Returns when the grid settings have been deleted successfully.
     */
    deleteGridSettings(id: number): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Auth/GridSettings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteGridSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGridSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeleteGridSettings(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Returned when the request body is invalid or contains malformed data.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Returned when the request lacks valid authentication credentials.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Returned when the authenticated user is not authorized to perform the action.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Returned when an unexpected server error occurs.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the dashboard's system-level settings, such as how often it should automatically
    refresh. The frontend reads these once when the dashboard loads.
     * @return The dashboard settings.
     */
    getConfig(): Observable<DashboardConfigDto> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardConfigDto>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<DashboardConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardConfigDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the cards the current user is allowed to add in their current pharmacy. Used to build
    the "Customize tiles" panel. Cards the pharmacy has disabled, or that the user is not
    permitted to use, are already excluded.
     * @return The cards available to add.
     */
    getAvailableCards(): Observable<DashboardCardDto[]> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/cards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableCards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableCards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardCardDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardCardDto[]>;
        }));
    }

    protected processGetAvailableCards(response: HttpResponseBase): Observable<DashboardCardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardCardDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current user's saved layout for their current pharmacy: which cards are placed and
    where. Cards the user can no longer see are left out.
     * @return The saved layout.
     */
    getLayout(): Observable<GetUserDashboardLayoutResponse> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/layout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLayout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLayout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserDashboardLayoutResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserDashboardLayoutResponse>;
        }));
    }

    protected processGetLayout(response: HttpResponseBase): Observable<GetUserDashboardLayoutResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetUserDashboardLayoutResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saves the current user's layout for their current pharmacy. The frontend sends the full set
    of placed cards when the user clicks Save, and this replaces the saved layout (an empty set
    means every tile is turned off). Cards the user is not allowed to use are rejected.
     * @param command The full set of placed cards with positions and sizes.
     * @return Success, or an error if a card is not allowed or the layout is invalid.
     */
    saveLayout(command: SaveUserDashboardLayoutCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/layout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveLayout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveLayout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processSaveLayout(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current user's saved Follow Up tile preference for their current pharmacy: Auto or
    Custom mode, and — for Custom — the workflows they picked, in their chosen order. Selected
    workflows that have since been retired or removed are left out.
     * @return The saved preference.
     */
    getFollowUpTilePreference(): Observable<GetUserFollowUpTilePreferenceResponse> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/follow-up/preference";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFollowUpTilePreference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFollowUpTilePreference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserFollowUpTilePreferenceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserFollowUpTilePreferenceResponse>;
        }));
    }

    protected processGetFollowUpTilePreference(response: HttpResponseBase): Observable<GetUserFollowUpTilePreferenceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetUserFollowUpTilePreferenceResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saves the current user's Follow Up tile preference for their current pharmacy: the
    Auto/Custom mode and the full ordered Custom-mode workflow selection. Workflows the pharmacy
    does not have are rejected.
     * @param command The mode and the full Custom-mode workflow selection.
     * @return Success, or an error if a workflow is not allowed or the selection is invalid.
     */
    saveFollowUpTilePreference(command: SaveUserFollowUpTilePreferenceCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/follow-up/preference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFollowUpTilePreference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFollowUpTilePreference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processSaveFollowUpTilePreference(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Fetches the live data for the requested cards in one call, returned keyed by card. Only the
    cards the user is allowed to see are run; anything else is skipped.
     * @param query The cards to fetch data for.
     * @return The cards' data keyed by card, with an as-of stamp for how current it is.
     */
    getData(query: GetDashboardDataQuery): Observable<GetDashboardDataResponse> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDashboardDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDashboardDataResponse>;
        }));
    }

    protected processGetData(response: HttpResponseBase): Observable<GetDashboardDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDashboardDataResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets every dashboard card for a pharmacy with whether it is currently turned on, so a
    Pharmacy Administrator can see and edit that pharmacy's tile availability. An administrator
    can only view the pharmacies they administer.
     * @param pharmacyId The pharmacy to view.
     * @return The cards and their on/off state for the pharmacy.
     */
    getPharmacyCardAvailability(pharmacyId: number): Observable<DashboardCardAvailabilityDto[]> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/pharmacies/{pharmacyId}/cards";
        if (pharmacyId === undefined || pharmacyId === null)
            throw new globalThis.Error("The parameter 'pharmacyId' must be defined.");
        url_ = url_.replace("{pharmacyId}", encodeURIComponent("" + pharmacyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPharmacyCardAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPharmacyCardAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardCardAvailabilityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardCardAvailabilityDto[]>;
        }));
    }

    protected processGetPharmacyCardAvailability(response: HttpResponseBase): Observable<DashboardCardAvailabilityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardCardAvailabilityDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saves which cards are available for a pharmacy. The screen sends the full set of cards with
    each one's on/off setting; cards turned off here are hidden from every user at the pharmacy.
    Only a Pharmacy Administrator for that pharmacy may save.
     * @param pharmacyId The pharmacy to configure.
     * @param cards The full set of cards with the desired on/off setting for each.
     * @return Success, or an error if the pharmacy is not allowed or a card is unknown.
     */
    updatePharmacyCardAvailability(pharmacyId: number, cards: PharmacyDashboardCardSettingDto[]): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/pharmacies/{pharmacyId}/cards";
        if (pharmacyId === undefined || pharmacyId === null)
            throw new globalThis.Error("The parameter 'pharmacyId' must be defined.");
        url_ = url_.replace("{pharmacyId}", encodeURIComponent("" + pharmacyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cards);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePharmacyCardAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePharmacyCardAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdatePharmacyCardAvailability(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DrugClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves a collection of all drugs.
     * @param type (optional) Flag that indicates the type of drugs to retrieve.
     * @return A collection of drugs.
     */
    get(type?: DrugType | undefined): Observable<GetDrugQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Drug?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDrugQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDrugQueryResponse[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetDrugQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDrugQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new drug in the system.
     * @param command The command containing drug creation details.
     * @return The created drug information.
     */
    create(command: CreateDrugCommand): Observable<CreateDrugCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Drug";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateDrugCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateDrugCommandResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateDrugCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateDrugCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing drug in the system.
     * @param command The command containing drug update details.
     * @return Result indicating success or failure of the update operation.
     */
    update(command: UpdateDrugCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Drug";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the details of a specific drug by its ID.
     * @param id The ID of the drug.
     * @return Details of the specified drug.
     */
    getDrugDetails(id: number): Observable<GetDrugDetailsQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Drug/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDrugDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDrugDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDrugDetailsQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDrugDetailsQueryResponse[]>;
        }));
    }

    protected processGetDrugDetails(response: HttpResponseBase): Observable<GetDrugDetailsQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDrugDetailsQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a drug from the system by its ID.
     * @param id The ID of the drug to delete.
     * @return Result indicating success or failure of the delete operation.
     */
    delete(id: number): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Drug/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of drug select items for use in dropdowns or selection controls.
     * @param workflowId (optional) Optional workflow id to filter drugs by.
     * @return Returns the list of drug select items.
     */
    getDrugSelectList(workflowId?: number | undefined): Observable<GetDrugSelectListQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Drug/GetSelectList?";
        if (workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDrugSelectList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDrugSelectList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDrugSelectListQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDrugSelectListQueryResponse[]>;
        }));
    }

    protected processGetDrugSelectList(response: HttpResponseBase): Observable<GetDrugSelectListQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDrugSelectListQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid or improperly formed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access. User is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden. User does not have the necessary permissions.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the dispense types for a specific workflow drug.
     * @param workflowId (optional) The unique identifier of the workflow.
     * @param drugId (optional) The unique identifier of the drug.
     * @return A collection of workflow drug dispense types if successful, or an error response.
     */
    getDispenseTypesForWorkflowAndDrug(workflowId?: number | undefined, drugId?: number | undefined): Observable<GetDispenseTypesForWorkflowAndDrugQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Drug/GetDispenseTypesForWorkflowAndDrug?";
        if (workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        if (drugId === null)
            throw new globalThis.Error("The parameter 'drugId' cannot be null.");
        else if (drugId !== undefined)
            url_ += "drugId=" + encodeURIComponent("" + drugId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDispenseTypesForWorkflowAndDrug(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDispenseTypesForWorkflowAndDrug(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDispenseTypesForWorkflowAndDrugQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDispenseTypesForWorkflowAndDrugQueryResponse[]>;
        }));
    }

    protected processGetDispenseTypesForWorkflowAndDrug(response: HttpResponseBase): Observable<GetDispenseTypesForWorkflowAndDrugQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDispenseTypesForWorkflowAndDrugQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the dispense types for multiple drugs in a specific workflow.
     * @param drugIds The collection of unique identifiers of the drugs.
     * @param workflowId (optional) The unique identifier of the workflow.
     * @return A collection of workflow drug dispense types if successful, or an error response.
     */
    getDispenseTypesForWorkflowAndDrugs(drugIds: number[], workflowId?: number | undefined): Observable<GetDispenseTypesForWorkflowAndDrugsQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Drug/GetDispenseTypesForWorkflowAndDrugs?";
        if (workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(drugIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDispenseTypesForWorkflowAndDrugs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDispenseTypesForWorkflowAndDrugs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDispenseTypesForWorkflowAndDrugsQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDispenseTypesForWorkflowAndDrugsQueryResponse[]>;
        }));
    }

    protected processGetDispenseTypesForWorkflowAndDrugs(response: HttpResponseBase): Observable<GetDispenseTypesForWorkflowAndDrugsQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDispenseTypesForWorkflowAndDrugsQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of other drug details for selection in dropdown controls.
     * @return A collection of other drug details items for selection controls.
     */
    getOtherDrugDetailsSelectList(): Observable<GetOtherDrugDetailsSelectListQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Drug/OtherDrugDetailsSelectList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOtherDrugDetailsSelectList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOtherDrugDetailsSelectList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOtherDrugDetailsSelectListQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOtherDrugDetailsSelectListQueryResponse[]>;
        }));
    }

    protected processGetOtherDrugDetailsSelectList(response: HttpResponseBase): Observable<GetOtherDrugDetailsSelectListQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOtherDrugDetailsSelectListQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DrugDetailsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a new drug detail.
     * @param command The command containing the details of the drug to create.
     * @return An IActionResult representing the result of the operation.
     */
    create(command: CreateDrugDetailsCommand): Observable<CreateDrugDetailsCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/DrugDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateDrugDetailsCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateDrugDetailsCommandResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateDrugDetailsCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateDrugDetailsCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing drug detail.
     * @param command The command containing the updated details of the drug.
     * @return An IActionResult representing the result of the operation.
     */
    update(command: UpdateDrugDetailsCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/DrugDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an existing drug detail.
     * @param id The ID of the drug detail to delete.
     * @return An IActionResult representing the result of the operation.
     */
    delete(id: number): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/DrugDetails/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EnumsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves all available enumeration types in the system.
     * @return Returns the list of available enumeration types.
     */
    getAllTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/Enums";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new entry in the specified enumeration.
     * @param command The command containing the enumeration name and description for the new entry.
     * @return The enumeration entry was successfully created.
     */
    create(command: CreateEnumEntityCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Enums";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The enumeration name or description was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the description of an enumeration entity identified by its ID and name.
     * @param command The command containing the unique identifier and new description of the enumeration entity to update.
     * @return An IActionResult indicating the result of the update operation. Returns 200 OK with a result object if
                successful; otherwise, returns an appropriate error response.
     */
    update(command: UpdateEnumEntityCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Enums";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all entities of a specified enumeration.
     * @param enumName The name of the enumeration to retrieve (e.g., "OrderStatus", "DispenseType").
     * @return Returns the list of enumeration entities.
     */
    get(enumName: string): Observable<GetEnumEntityQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Enums/{enumName}";
        if (enumName === undefined || enumName === null)
            throw new globalThis.Error("The parameter 'enumName' must be defined.");
        url_ = url_.replace("{enumName}", encodeURIComponent("" + enumName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEnumEntityQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEnumEntityQueryResponse[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetEnumEntityQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEnumEntityQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The enumeration name was invalid or not recognized.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an entity of the specified enum type by its unique identifier.
     * @param id The unique identifier of the entity to delete.
     * @param enumName The name of the enum type that identifies the entity category.
     * @return An IActionResult indicating the result of the delete operation. Returns a 200 OK response with
                the result if successful; otherwise, returns an appropriate error response.
     */
    delete(id: number, enumName: string): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Enums/{id}/{enumName}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (enumName === undefined || enumName === null)
            throw new globalThis.Error("The parameter 'enumName' must be defined.");
        url_ = url_.replace("{enumName}", encodeURIComponent("" + enumName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a specific enumeration entity by ID.
     * @param enumName The name of the enumeration (e.g., "OrderStatus", "DispenseType").
     * @param id The unique identifier of the enumeration entity.
     * @return Returns the requested enumeration entity.
     */
    getById(enumName: string, id: number): Observable<GetEnumEntityQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Enums/{enumName}/{id}";
        if (enumName === undefined || enumName === null)
            throw new globalThis.Error("The parameter 'enumName' must be defined.");
        url_ = url_.replace("{enumName}", encodeURIComponent("" + enumName));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEnumEntityQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEnumEntityQueryResponse>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetEnumEntityQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEnumEntityQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The enumeration name or ID was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The enumeration entity was not found.", status, _responseText, _headers, result422);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all entities of a specified enumeration.
     * @param enumName The name of the enumeration to retrieve (e.g., "OrderStatus", "DispenseType").
     * @return Returns the list of enumeration entities.
     */
    get2(enumName: string): Observable<GetEnumEntityQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/integration/Enums/{enumName}";
        if (enumName === undefined || enumName === null)
            throw new globalThis.Error("The parameter 'enumName' must be defined.");
        url_ = url_.replace("{enumName}", encodeURIComponent("" + enumName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEnumEntityQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEnumEntityQueryResponse[]>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<GetEnumEntityQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEnumEntityQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The enumeration name was invalid or not recognized.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Missing or invalid API key.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all available enumeration types in the system.
     * @return Returns the list of available enumeration types.
     */
    getAllTypes2(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/integration/Enums";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTypes2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTypes2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllTypes2(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Missing or invalid API key.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a specific enumeration entity by ID.
     * @param enumName The name of the enumeration (e.g., "OrderStatus", "DispenseType").
     * @param id The unique identifier of the enumeration entity.
     * @return Returns the requested enumeration entity.
     */
    getById2(enumName: string, id: number): Observable<GetEnumEntityQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/integration/Enums/{enumName}/{id}";
        if (enumName === undefined || enumName === null)
            throw new globalThis.Error("The parameter 'enumName' must be defined.");
        url_ = url_.replace("{enumName}", encodeURIComponent("" + enumName));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEnumEntityQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEnumEntityQueryResponse>;
        }));
    }

    protected processGetById2(response: HttpResponseBase): Observable<GetEnumEntityQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEnumEntityQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The enumeration name or ID was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Missing or invalid API key.", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The enumeration entity was not found.", status, _responseText, _headers, result422);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FeatureFlagClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns all feature flags.
     * @return The set of feature flags.
     */
    getFeatureFlags(): Observable<GetFeatureFlagsResponse> {
        let url_ = this.baseUrl + "/api/v1/FeatureFlag";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatureFlags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatureFlags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFeatureFlagsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFeatureFlagsResponse>;
        }));
    }

    protected processGetFeatureFlags(response: HttpResponseBase): Observable<GetFeatureFlagsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetFeatureFlagsResponse;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets a feature flag's enabled state by key. ADMINISTRATOR only.
     * @param key The stable flag key.
     * @param request The body carrying the new enabled state.
     * @return A success result, or an error if the flag was not found.
     */
    setFeatureFlag(key: string, request: SetFeatureFlagRequest): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/FeatureFlag/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFeatureFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFeatureFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processSetFeatureFlag(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GamificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the signed-in user's My Day summary: live today-so-far counts and points per milestone
    vs the manager targets and the user's own "at this time last week" baseline, plus the
    precomputed streak, private badges and private standing.
     * @return The My Day summary.
     */
    getMyDay(): Observable<MyDayResponse> {
        let url_ = this.baseUrl + "/api/v1/Gamification/my-day";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyDayResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyDayResponse>;
        }));
    }

    protected processGetMyDay(response: HttpResponseBase): Observable<MyDayResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MyDayResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the lightweight pace read for the navbar chip: today's points vs the daily target
    only. Cheap by design - the chip polls this on route changes all day.
     * @return Today's points and the daily target.
     */
    getMyDayScore(): Observable<MyDayScoreResponse> {
        let url_ = this.baseUrl + "/api/v1/Gamification/my-day/score";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyDayScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyDayScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyDayScoreResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyDayScoreResponse>;
        }));
    }

    protected processGetMyDayScore(response: HttpResponseBase): Observable<MyDayScoreResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MyDayScoreResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the signed-in user's "today's plan": unfinished orders assigned to them or last touched
    by them, urgent first. Neutral, plannable framing by design.
     * @return The unfinished-work list.
     */
    getMyUnfinishedWork(): Observable<MyUnfinishedWorkResponse> {
        let url_ = this.baseUrl + "/api/v1/Gamification/my-day/unfinished-work";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyUnfinishedWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyUnfinishedWork(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyUnfinishedWorkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyUnfinishedWorkResponse>;
        }));
    }

    protected processGetMyUnfinishedWork(response: HttpResponseBase): Observable<MyUnfinishedWorkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MyUnfinishedWorkResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the signed-in user's daily coach line: one short, supportive AI suggestion built from
    their own aggregate activity (Foundry chat model; cached per user per day). Available is
    false when no model is configured.
     * @param language (optional) UI language for the hint ("en" or "fr"; defaults to English).
     * @return The coach line.
     */
    getMyDayCoach(language?: string | null | undefined): Observable<MyDayCoachResponse> {
        let url_ = this.baseUrl + "/api/v1/Gamification/my-day/coach?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyDayCoach(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyDayCoach(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyDayCoachResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyDayCoachResponse>;
        }));
    }

    protected processGetMyDayCoach(response: HttpResponseBase): Observable<MyDayCoachResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MyDayCoachResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Records whether the daily coach hint was helpful (thumbs up/down). POC: logged to
    telemetry for prompt tuning; no data is persisted.
     * @param command The feedback verdict.
     * @return OK on success.
     */
    submitCoachFeedback(command: SubmitCoachFeedbackCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Gamification/my-day/coach/feedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitCoachFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitCoachFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitCoachFeedback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the manager KPI configuration for the current pharmacy: per milestone type, the daily
    target, point weight and rationale shown to the team.
     * @return The KPI target configuration.
     */
    getKpiTargets(): Observable<KpiTargetsResponse> {
        let url_ = this.baseUrl + "/api/v1/Gamification/kpi-targets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKpiTargets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKpiTargets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KpiTargetsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KpiTargetsResponse>;
        }));
    }

    protected processGetKpiTargets(response: HttpResponseBase): Observable<KpiTargetsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KpiTargetsResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saves the manager KPI configuration for the current pharmacy. The pharmacy is taken from the
    caller's session, never from the request body.
     * @param command The KPI targets to save.
     * @return No content on success.
     */
    upsertKpiTargets(command: UpsertKpiTargetsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Gamification/kpi-targets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertKpiTargets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertKpiTargets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertKpiTargets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Explains the Team pulse section in plain language (Foundry chat model over the anonymized
    aggregates; cached per pharmacy per run). Mirrors the Manager Analytics chart explanations.
     * @param language (optional) UI language for the explanation ("en" or "fr"; defaults to English).
     * @return The explanation text, or Available = false when no model is configured.
     */
    explainTeamOverview(language?: string | null | undefined): Observable<TeamOverviewExplanationResponse> {
        let url_ = this.baseUrl + "/api/v1/Gamification/team-overview/explain?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExplainTeamOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExplainTeamOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeamOverviewExplanationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeamOverviewExplanationResponse>;
        }));
    }

    protected processExplainTeamOverview(response: HttpResponseBase): Observable<TeamOverviewExplanationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamOverviewExplanationResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the anonymized team overview for the current pharmacy: team totals trend, per-milestone
    attainment, the attainment distribution histogram (bucket counts only, no identities) and a
    single most-improved highlight.
     * @return The team overview.
     */
    getTeamOverview(): Observable<TeamOverviewResponse> {
        let url_ = this.baseUrl + "/api/v1/Gamification/team-overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeamOverviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeamOverviewResponse>;
        }));
    }

    protected processGetTeamOverview(response: HttpResponseBase): Observable<TeamOverviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamOverviewResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HolidayClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves holidays for the specified years, filtered by the pharmacy's province.
    Utilizes in-memory caching for improved performance.
     * @param years (optional) An optional array of years to retrieve holidays for. If not provided, defaults to the current year.
     * @return Successfully returns the list of holidays for the specified years and province.
     */
    getHolidaysForPharmacyProvince(years?: number[] | null | undefined): Observable<GetHolidaysQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Holiday?";
        if (years !== undefined && years !== null)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidaysForPharmacyProvince(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidaysForPharmacyProvince(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHolidaysQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHolidaysQueryResponse>;
        }));
    }

    protected processGetHolidaysForPharmacyProvince(response: HttpResponseBase): Observable<GetHolidaysQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetHolidaysQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid, such as containing unsupported or malformed years.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The user is not authorized to access this endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The user does not have permission to access this endpoint.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IssueTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves a list of issue types based on the provided filter criteria.
     * @param isCancel (optional) Indicates if the issue is a cancellation.
     * @param isReject (optional) Indicates if the issue is a rejection.
     * @param isFollowUp (optional) Indicates if the issue requires a follow-up.
     * @param isRxVerification (optional) Indicates if the issue is related to prescription verification.
     * @param isReadyToShip (optional) Indicates if the item is ready to ship.
     * @param isPendingDelivery (optional) Indicates if the item is pending delivery.
     * @param isPendingPickup (optional) Indicates if the item is pending pickup.
     * @param isDeliveryIssue (optional) Indicates if there is a delivery issue.
     * @return A collection of issue types matching the filter criteria.
     */
    getIssueTypes(isCancel?: boolean | undefined, isReject?: boolean | undefined, isFollowUp?: boolean | undefined, isRxVerification?: boolean | undefined, isReadyToShip?: boolean | undefined, isPendingDelivery?: boolean | undefined, isPendingPickup?: boolean | undefined, isDeliveryIssue?: boolean | undefined): Observable<GetIssueTypesQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/IssueType?";
        if (isCancel === null)
            throw new globalThis.Error("The parameter 'isCancel' cannot be null.");
        else if (isCancel !== undefined)
            url_ += "IsCancel=" + encodeURIComponent("" + isCancel) + "&";
        if (isReject === null)
            throw new globalThis.Error("The parameter 'isReject' cannot be null.");
        else if (isReject !== undefined)
            url_ += "IsReject=" + encodeURIComponent("" + isReject) + "&";
        if (isFollowUp === null)
            throw new globalThis.Error("The parameter 'isFollowUp' cannot be null.");
        else if (isFollowUp !== undefined)
            url_ += "IsFollowUp=" + encodeURIComponent("" + isFollowUp) + "&";
        if (isRxVerification === null)
            throw new globalThis.Error("The parameter 'isRxVerification' cannot be null.");
        else if (isRxVerification !== undefined)
            url_ += "IsRxVerification=" + encodeURIComponent("" + isRxVerification) + "&";
        if (isReadyToShip === null)
            throw new globalThis.Error("The parameter 'isReadyToShip' cannot be null.");
        else if (isReadyToShip !== undefined)
            url_ += "IsReadyToShip=" + encodeURIComponent("" + isReadyToShip) + "&";
        if (isPendingDelivery === null)
            throw new globalThis.Error("The parameter 'isPendingDelivery' cannot be null.");
        else if (isPendingDelivery !== undefined)
            url_ += "IsPendingDelivery=" + encodeURIComponent("" + isPendingDelivery) + "&";
        if (isPendingPickup === null)
            throw new globalThis.Error("The parameter 'isPendingPickup' cannot be null.");
        else if (isPendingPickup !== undefined)
            url_ += "IsPendingPickup=" + encodeURIComponent("" + isPendingPickup) + "&";
        if (isDeliveryIssue === null)
            throw new globalThis.Error("The parameter 'isDeliveryIssue' cannot be null.");
        else if (isDeliveryIssue !== undefined)
            url_ += "IsDeliveryIssue=" + encodeURIComponent("" + isDeliveryIssue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIssueTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIssueTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIssueTypesQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIssueTypesQueryResponse[]>;
        }));
    }

    protected processGetIssueTypes(response: HttpResponseBase): Observable<GetIssueTypesQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetIssueTypesQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ManagerAnalyticsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Per-status dwell-time percentiles and current backlog (the bottleneck view).
     */
    getStatusDwell(): Observable<StatusDwellResponse> {
        let url_ = this.baseUrl + "/api/v1/ManagerAnalytics/status-dwell";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusDwell(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusDwell(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusDwellResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusDwellResponse>;
        }));
    }

    protected processGetStatusDwell(response: HttpResponseBase): Observable<StatusDwellResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StatusDwellResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pharmacy-local time-of-day load heatmap (created / accepted / rx-verified series).
     */
    getLoadHeatmap(): Observable<LoadHeatmapResponse> {
        let url_ = this.baseUrl + "/api/v1/ManagerAnalytics/load-heatmap";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoadHeatmap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoadHeatmap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadHeatmapResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadHeatmapResponse>;
        }));
    }

    protected processGetLoadHeatmap(response: HttpResponseBase): Observable<LoadHeatmapResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoadHeatmapResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * SLA adherence and cycle-time trend by pharmacy-local day.
     */
    getSlaTrend(): Observable<SlaTrendResponse> {
        let url_ = this.baseUrl + "/api/v1/ManagerAnalytics/sla-trend";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlaTrend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlaTrend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlaTrendResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlaTrendResponse>;
        }));
    }

    protected processGetSlaTrend(response: HttpResponseBase): Observable<SlaTrendResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SlaTrendResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Live "patient risk" buckets: refill gaps, treatment-start risk, urgent waiting, missed pickups.
     */
    getPatientRisk(): Observable<PatientRiskResponse> {
        let url_ = this.baseUrl + "/api/v1/ManagerAnalytics/patient-risk";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientRisk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientRisk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientRiskResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientRiskResponse>;
        }));
    }

    protected processGetPatientRisk(response: HttpResponseBase): Observable<PatientRiskResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatientRiskResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Live "program health": every workflow (program) with activity, worst attention first.
     */
    getProgramHealth(): Observable<ProgramHealthResponse> {
        let url_ = this.baseUrl + "/api/v1/ManagerAnalytics/program-health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramHealthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramHealthResponse>;
        }));
    }

    protected processGetProgramHealth(response: HttpResponseBase): Observable<ProgramHealthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgramHealthResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Explains a single chart (dwell/heatmap/sla/capacity/forecast) in plain language.
     * @param language (optional) 
     */
    explainChart(chart: string, language?: string | null | undefined): Observable<ExplainChartResponse> {
        let url_ = this.baseUrl + "/api/v1/ManagerAnalytics/explain/{chart}?";
        if (chart === undefined || chart === null)
            throw new globalThis.Error("The parameter 'chart' must be defined.");
        url_ = url_.replace("{chart}", encodeURIComponent("" + chart));
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExplainChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExplainChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExplainChartResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExplainChartResponse>;
        }));
    }

    protected processExplainChart(response: HttpResponseBase): Observable<ExplainChartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExplainChartResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * An AI-generated plain-language brief over the latest analytics (Foundry chat model).
     * @param language (optional) 
     */
    getInsights(language?: string | null | undefined): Observable<InsightsResponse> {
        let url_ = this.baseUrl + "/api/v1/ManagerAnalytics/insights?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsights(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsights(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsightsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsightsResponse>;
        }));
    }

    protected processGetInsights(response: HttpResponseBase): Observable<InsightsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsightsResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Average daily order load vs configured capacity, per weekday (the staffing view).
     */
    getCapacityUtilization(): Observable<CapacityUtilizationResponse> {
        let url_ = this.baseUrl + "/api/v1/ManagerAnalytics/capacity-utilization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCapacityUtilization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCapacityUtilization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CapacityUtilizationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CapacityUtilizationResponse>;
        }));
    }

    protected processGetCapacityUtilization(response: HttpResponseBase): Observable<CapacityUtilizationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CapacityUtilizationResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The "why orders wait" Pareto: follow-up counts per delay reason, biggest cause first.
     */
    getDelayReasons(): Observable<DelayReasonsResponse> {
        let url_ = this.baseUrl + "/api/v1/ManagerAnalytics/delay-reasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelayReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelayReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DelayReasonsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DelayReasonsResponse>;
        }));
    }

    protected processGetDelayReasons(response: HttpResponseBase): Observable<DelayReasonsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DelayReasonsResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Network-wide daily volume actuals plus the baseline forecast (AI PoC).
     */
    getVolumeForecast(): Observable<VolumeForecastResponse> {
        let url_ = this.baseUrl + "/api/v1/ManagerAnalytics/volume-forecast";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVolumeForecast(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVolumeForecast(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VolumeForecastResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VolumeForecastResponse>;
        }));
    }

    protected processGetVolumeForecast(response: HttpResponseBase): Observable<VolumeForecastResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VolumeForecastResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ManufacturerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves a collection of all manufacturers.
     * @return A collection of manufacturers.
     */
    get(): Observable<GetManufacturerQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Manufacturer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetManufacturerQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetManufacturerQueryResponse[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetManufacturerQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetManufacturerQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a manufacturer.
     * @param command The command containing the manufacturer to create.
     * @return The details of the created manufacturer or an error response.
     */
    create(command: CreateManufacturerCommand): Observable<CreateManufacturerResponse> {
        let url_ = this.baseUrl + "/api/v1/Manufacturer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateManufacturerResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateManufacturerResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateManufacturerResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateManufacturerResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the details of a manufacturer.
     * @param command The command containing the manufacturer to update.
     * @return The details of the manufacturer or an error response.
     */
    update(command: UpdateManufacturerCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Manufacturer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a manufacturer by its identifier.
     * @param id (optional) The unique identifier of the manufacturer to delete.
     * @return A success result or an error response.
     */
    delete(id?: number | undefined): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Manufacturer?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves orders based on their statuses.
     * @param statuses (optional) The statuses of the orders to retrieve.
     * @param followUpDateFrom (optional) From date for the follow-up list date range.
     * @param followUpDateTo (optional) To date for the follow-up list date range.
     * @param excludeGroupShipmentOrders (optional) Flag to indicate whether or not orders belonging to group shipments should be included.
     * @return A collection of orders matching the specified statuses.
     */
    getOrderByStatus(statuses?: string[] | undefined, followUpDateFrom?: DateTime | null | undefined, followUpDateTo?: DateTime | null | undefined, excludeGroupShipmentOrders?: boolean | null | undefined): Observable<GetOrderByStatusQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order?";
        if (statuses === null)
            throw new globalThis.Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (followUpDateFrom !== undefined && followUpDateFrom !== null)
            url_ += "followUpDateFrom=" + encodeURIComponent(followUpDateFrom ? "" + followUpDateFrom.toString() : "") + "&";
        if (followUpDateTo !== undefined && followUpDateTo !== null)
            url_ += "followUpDateTo=" + encodeURIComponent(followUpDateTo ? "" + followUpDateTo.toString() : "") + "&";
        if (excludeGroupShipmentOrders !== undefined && excludeGroupShipmentOrders !== null)
            url_ += "excludeGroupShipmentOrders=" + encodeURIComponent("" + excludeGroupShipmentOrders) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderByStatusQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderByStatusQueryResponse[]>;
        }));
    }

    protected processGetOrderByStatus(response: HttpResponseBase): Observable<GetOrderByStatusQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderByStatusQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the initial status of an order.
     * @param command The command containing the order ID and new initial status details.
     * @return A result indicating success or failure of the update operation.
     */
    updateOrderInitialStatus(command: UpdateOrderInitialStatusCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderInitialStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderInitialStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateOrderInitialStatus(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves an order by its unique identifier.
     * @param id The unique identifier of the order to retrieve.
     * @return The order details for the specified identifier.
     */
    getOrderById(id: number): Observable<GetOrderByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderByIdQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderByIdQueryResponse>;
        }));
    }

    protected processGetOrderById(response: HttpResponseBase): Observable<GetOrderByIdQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderByIdQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the screen information for a specific order.
     * @param id The unique identifier of the order.
     * @return The screen information for the specified order.
     */
    getOrderScreen(id: number): Observable<GetOrderScreenQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/Screen";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderScreen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderScreen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderScreenQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderScreenQueryResponse>;
        }));
    }

    protected processGetOrderScreen(response: HttpResponseBase): Observable<GetOrderScreenQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderScreenQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the status of an order to "Accepted" and optionally prepares patient data for transfer to Kroll.
     * @param command The AcceptOrderCommand containing:
    - The order ID to be updated.
    - A flag indicating whether the patient should be transferred to Kroll.
     * @return The order was successfully accepted.
     */
    acceptOrder(command: AcceptOrderCommand): Observable<AcceptOrderCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/AcceptOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcceptOrderCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcceptOrderCommandResponse>;
        }));
    }

    protected processAcceptOrder(response: HttpResponseBase): Observable<AcceptOrderCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AcceptOrderCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid, such as missing or invalid order details.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access to the endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access to the endpoint is forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the screening information for an order.
     * @param command The command containing the order ID and updated screening details.
     * @return A result indicating success or failure of the screening update operation.
     */
    updateOrderScreen(command: UpdateOrderScreenCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/Screen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderScreen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderScreen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateOrderScreen(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a follow-up for an existing order.
     * @param command The command containing the follow-up details.
     * @return A result indicating success or failure of the follow-up creation.
     */
    createFollowup(command: CreateFollowupCommand): Observable<CreateFollowupCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/Followup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFollowup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFollowup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateFollowupCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateFollowupCommandResponse>;
        }));
    }

    protected processCreateFollowup(response: HttpResponseBase): Observable<CreateFollowupCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateFollowupCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assigns orders to a specific user.
     * @param command The command containing user and order assignment details.
     * @return The order assignments were created successfully.
     */
    createUserOrderAssignments(command: CreateUserOrderAssignmentCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/Assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserOrderAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserOrderAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCreateUserOrderAssignments(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates user order assignments for specified orders and user.
     * @param command The command containing user and order assignment details.
     * @return A result indicating success or failure of the assignment update operation.
     */
    updateUserOrderAssignment(command: UpdateUserOrderAssignmentCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/Assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserOrderAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserOrderAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateUserOrderAssignment(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates an order with new patient data.
     * @param command CreateNewPatientOrderCommandThe command containing the order and patient details.
     * @return A IActionResult indicating success or failure of the follow-up creation.
     */
    createNewPatientOrder(command: CreateNewPatientOrderCommand): Observable<CreateNewPatientOrderCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/CreateNewPatientOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewPatientOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewPatientOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateNewPatientOrderCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateNewPatientOrderCommandResponse>;
        }));
    }

    protected processCreateNewPatientOrder(response: HttpResponseBase): Observable<CreateNewPatientOrderCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateNewPatientOrderCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the pharmacy information for an order.
     * @param command The command containing the updated pharmacy details for the order.
     * @return An IActionResult indicating the success or failure of the operation.
     */
    updatePharmacy(command: UpdateOrderPharmacyCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/Pharmacy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePharmacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePharmacy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdatePharmacy(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the patient information for an order.
     * @param command The command containing the updated patient details for the order.
     * @return An IActionResult indicating the success or failure of the operation.
     */
    updatePatient(command: UpdateOrderPatientCommand): Observable<UpdateOrderPatientCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/Patient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateOrderPatientCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateOrderPatientCommandResponse>;
        }));
    }

    protected processUpdatePatient(response: HttpResponseBase): Observable<UpdateOrderPatientCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateOrderPatientCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the notes of a specified type for a list of orders or for a patient+workflow combination.
    Exactly one mode must be active: supply ids (non-empty) or both
    patientId and workflowId — not both.
     * @param noteType The type of note to retrieve.
     * @param ids (optional) The unique identifiers of the orders for which notes will be retrieved (order-IDs mode).
     * @param includePreviousOrderNotes (optional) Indicates whether to include notes from previous orders (order-IDs mode only).
     * @param patientId (optional) Patient ID for patient+workflow mode. Must be paired with workflowId.
     * @param workflowId (optional) Workflow ID for patient+workflow mode. Must be paired with patientId.
     * @return List of notes or an error response.
     */
    getOrderNotes(noteType: NoteType, ids?: number[] | null | undefined, includePreviousOrderNotes?: boolean | undefined, patientId?: number | null | undefined, workflowId?: number | null | undefined): Observable<GetOrderNotesQueryResponse[]> {
        let url_ = this.baseUrl + "/notes/{noteType}?";
        if (noteType === undefined || noteType === null)
            throw new globalThis.Error("The parameter 'noteType' must be defined.");
        url_ = url_.replace("{noteType}", encodeURIComponent("" + noteType));
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (includePreviousOrderNotes === null)
            throw new globalThis.Error("The parameter 'includePreviousOrderNotes' cannot be null.");
        else if (includePreviousOrderNotes !== undefined)
            url_ += "includePreviousOrderNotes=" + encodeURIComponent("" + includePreviousOrderNotes) + "&";
        if (patientId !== undefined && patientId !== null)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (workflowId !== undefined && workflowId !== null)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderNotesQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderNotesQueryResponse[]>;
        }));
    }

    protected processGetOrderNotes(response: HttpResponseBase): Observable<GetOrderNotesQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderNotesQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the pickup date for an order.
     * @param command The command containing the order ID and updated pickup date.
     * @return A result indicating success or failure of the pickup operation.
     */
    updateOrderPickUp(command: UpdateOrderPickUpCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/PickUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderPickUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderPickUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateOrderPickUp(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Completes the current order and stores the reason why a next order is not required.
     * @param command The command containing the order ID and reason why a next order is not required.
     * @return A result indicating success or failure of the operation.
     */
    updateOrderNoNextOrder(command: UpdateOrderNoNextOrderCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/UpdateOrderNoNextOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderNoNextOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderNoNextOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateOrderNoNextOrder(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Completes the current order and creates the next order in the system.
     * @param command The command containing the order ID, next order follow-up date, and next order treatment run-out date.
     * @return A result indicating success or failure of the operation.
     */
    createNextOrder(command: CreateNextOrderCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/CreateNextOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNextOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNextOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCreateNextOrder(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the dates for the next order.
     * @param id The unique identifier of the order for which notes will be retrieved.
     * @return Next order dates or an error response.
     */
    getNextOrderDates(id: number): Observable<GetNextOrderDatesQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/nextorderdates";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextOrderDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextOrderDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNextOrderDatesQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNextOrderDatesQueryResponse>;
        }));
    }

    protected processGetNextOrderDates(response: HttpResponseBase): Observable<GetNextOrderDatesQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetNextOrderDatesQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the drug information for an order.
     * @param command The command containing the updated drug details for the order.
     * @return An IActionResult indicating the success or failure of the operation.
     */
    updateDrugInfo(command: UpdateOrderDrugInfoCommand): Observable<UpdateOrderDrugInfoCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/DrugInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDrugInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDrugInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateOrderDrugInfoCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateOrderDrugInfoCommandResponse>;
        }));
    }

    protected processUpdateDrugInfo(response: HttpResponseBase): Observable<UpdateOrderDrugInfoCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateOrderDrugInfoCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the status of an order.
     * @param command The command containing the order ID and new status details.
     * @return An IActionResult indicating the success or failure of the operation.
     */
    updateStatus(command: UpdateOrderStatusCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/Status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the shipment type for an order.
     * @param command The command containing the updated shipment type details for the order.
     * @return An IActionResult indicating the success or failure of the operation.
     */
    updateShipmentType(command: UpdateOrderShipmentTypeCommand): Observable<UpdateOrderShipmentTypeCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/ShipmentType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShipmentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShipmentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateOrderShipmentTypeCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateOrderShipmentTypeCommandResponse>;
        }));
    }

    protected processUpdateShipmentType(response: HttpResponseBase): Observable<UpdateOrderShipmentTypeCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateOrderShipmentTypeCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new order item for an existing order.
     * @param command The command containing the details of the order item to be created.
     * @return An IActionResult indicating the success or failure of the operation.
     */
    createOrderItem(command: CreateOrderItemCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/OrderItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrderItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrderItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCreateOrderItem(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing order item with new details.
     * @param command The command containing the updated order item details.
     * @return An IActionResult indicating the success or failure of the operation.
     */
    updateOrderItem(command: UpdateOrderItemCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/OrderItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateOrderItem(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an order item from an existing order.
     * @param command The command containing the details of the order item to be deleted.
     * @return An IActionResult indicating the success or failure of the deletion operation.
     */
    deleteOrderItems(command: DeleteOrderItemsCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/OrderItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrderItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrderItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeleteOrderItems(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates new shipment(s) for an existing order.
    Multiple shipments for an order indicate at least one relay shipment and one final destination shipment.
     * @param command The command containing the details required to create the order shipment(s).
     * @return An IActionResult indicating the success or failure of the shipment creation.
     */
    createOrderShipment(command: CreateOrderShipmentCommand): Observable<CreateOrderShipmentCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/Shipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrderShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrderShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrderShipmentCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrderShipmentCommandResponse>;
        }));
    }

    protected processCreateOrderShipment(response: HttpResponseBase): Observable<CreateOrderShipmentCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateOrderShipmentCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Atomically schedules a shipment for an order within a single database transaction.
    Wraps drug info update, order item CRUD, shipment type, next order follow-up,
    shipment CRUD, tracking numbers, notes, status update, and assignment update
    into one all-or-nothing operation. If any sub-operation fails, all changes are rolled back.
     * @param command The command containing all scheduling details.
     * @return The shipment was successfully scheduled.
     */
    scheduleShipment(command: ScheduleShipmentCommand): Observable<ScheduleShipmentCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/ScheduleShipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleShipmentCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleShipmentCommandResponse>;
        }));
    }

    protected processScheduleShipment(response: HttpResponseBase): Observable<ScheduleShipmentCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleShipmentCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid or a sub-operation validation failed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access to the endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access to the endpoint is forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Atomically processes a follow-up required action for an order within a single database transaction.
    Wraps an optional delay-reason status update, drug info update, order item CRUD, shipment type,
    next order follow-up, shipment CRUD, tracking numbers, notes (create and update), and DDI review
    into one all-or-nothing operation. If any sub-operation fails, all changes are rolled back.
    Unlike ScheduleShipment, this does NOT unassign the user from the order.
     * @param command The command containing all follow-up required details.
     * @return The follow-up required action was successfully processed.
     */
    followUpRequired(command: FollowUpRequiredCommand): Observable<FollowUpRequiredCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/FollowUpRequired";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFollowUpRequired(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFollowUpRequired(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FollowUpRequiredCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FollowUpRequiredCommandResponse>;
        }));
    }

    protected processFollowUpRequired(response: HttpResponseBase): Observable<FollowUpRequiredCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FollowUpRequiredCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid or a sub-operation validation failed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access to the endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access to the endpoint is forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the drug information for a specific order by its unique identifier.
     * @param id The unique identifier of the order.
     * @return The drug information associated with the specified order.
     */
    getOrderDrugInfo(id: number): Observable<GetOrderDrugInfoQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/DrugInfo";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDrugInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDrugInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderDrugInfoQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderDrugInfoQueryResponse>;
        }));
    }

    protected processGetOrderDrugInfo(response: HttpResponseBase): Observable<GetOrderDrugInfoQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderDrugInfoQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all order items for a specific order by its unique identifier.
     * @param id The unique identifier of the order.
     * @return A list of order items associated with the specified order.
     */
    getOrderItems(id: number): Observable<GetOrderItemsQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/OrderItems";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderItemsQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderItemsQueryResponse[]>;
        }));
    }

    protected processGetOrderItems(response: HttpResponseBase): Observable<GetOrderItemsQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderItemsQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the shipment type for a specific order by its unique identifier.
     * @param id The unique identifier of the order.
     * @return The shipment type information associated with the specified order.
     */
    getShipmentType(id: number): Observable<GetOrderShipmentTypeQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/ShipmentType";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipmentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipmentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderShipmentTypeQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderShipmentTypeQueryResponse>;
        }));
    }

    protected processGetShipmentType(response: HttpResponseBase): Observable<GetOrderShipmentTypeQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderShipmentTypeQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all shipments for a specific order by its unique identifier.
     * @param id The unique identifier of the order.
     * @return A list of shipments associated with the specified order.
     */
    getShipments(id: number): Observable<GetOrderShipmentsQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/Shipments";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderShipmentsQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderShipmentsQueryResponse[]>;
        }));
    }

    protected processGetShipments(response: HttpResponseBase): Observable<GetOrderShipmentsQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderShipmentsQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an order from a group shipment.
     * @param command The command containing the id of the order to be removed from a group shipment.
     * @return An IActionResult indicating the success or failure of the operation.
     */
    removeOrderFromGroupShipment(command: RemoveOrderFromGroupShipmentCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/OrderFromGroupShipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveOrderFromGroupShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveOrderFromGroupShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processRemoveOrderFromGroupShipment(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves group shipments and their orders based on statuses of group shipments and orders.
    If no statuses are provided, returns all.
    If the flag 'groupShipmentMustContainAtLeastOneOfOrderStatus' = true,
    there must be at least one order in the group shipment with the requested order status(es).
     * @param groupShipmentMustContainAtLeastOneOfOrderStatus (optional) If true, must be at least one order in the group with the requested order statuses. If false, returns all.
     * @param groupShipmentStatuses (optional) If populated, must be at least one order in the group with the requested order statuses. If not populated, returns all.
     * @param orderStatuses (optional) If populated, the statuses of the orders to retrieve. If not populated, returns all.
     * @param ignoreClosedOrders (optional) If true, ignores displaying closed orders.
     * @return A collection of orders matching the specified statuses.
     */
    getGroupShipmentOrdersByStatus(groupShipmentMustContainAtLeastOneOfOrderStatus?: boolean | undefined, groupShipmentStatuses?: string[] | null | undefined, orderStatuses?: string[] | null | undefined, ignoreClosedOrders?: boolean | undefined): Observable<GetGroupShipmentOrdersByStatusQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/GroupShipmentOrders?";
        if (groupShipmentMustContainAtLeastOneOfOrderStatus === null)
            throw new globalThis.Error("The parameter 'groupShipmentMustContainAtLeastOneOfOrderStatus' cannot be null.");
        else if (groupShipmentMustContainAtLeastOneOfOrderStatus !== undefined)
            url_ += "groupShipmentMustContainAtLeastOneOfOrderStatus=" + encodeURIComponent("" + groupShipmentMustContainAtLeastOneOfOrderStatus) + "&";
        if (groupShipmentStatuses !== undefined && groupShipmentStatuses !== null)
            groupShipmentStatuses && groupShipmentStatuses.forEach(item => { url_ += "groupShipmentStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (orderStatuses !== undefined && orderStatuses !== null)
            orderStatuses && orderStatuses.forEach(item => { url_ += "orderStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (ignoreClosedOrders === null)
            throw new globalThis.Error("The parameter 'ignoreClosedOrders' cannot be null.");
        else if (ignoreClosedOrders !== undefined)
            url_ += "ignoreClosedOrders=" + encodeURIComponent("" + ignoreClosedOrders) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupShipmentOrdersByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupShipmentOrdersByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGroupShipmentOrdersByStatusQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGroupShipmentOrdersByStatusQueryResponse[]>;
        }));
    }

    protected processGetGroupShipmentOrdersByStatus(response: HttpResponseBase): Observable<GetGroupShipmentOrdersByStatusQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetGroupShipmentOrdersByStatusQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes all shipments associated with an order.
     * @param command The command containing the order ID for which shipments should be deleted.
     * @return A result indicating success or failure of the deletion operation.
     */
    deleteOrderShipments(command: DeleteOrderShipmentsCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/Shipments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrderShipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrderShipments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeleteOrderShipments(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the verification information for an order.
     * @param command The command containing the updated verification details for the order.
     * @return An IActionResult indicating the success or failure of the operation.
     */
    updateVerification(command: UpdateOrderVerificationCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/Verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVerification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateVerification(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Ships a regular order by processing the provided shipment details.
     * @param command The command containing the order ID and shipment details, including tracking numbers.
     * @return The order was successfully shipped.
     */
    shipRegularOrder(command: ShipRegularOrderCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/ShipRegularOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShipRegularOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShipRegularOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processShipRegularOrder(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid, such as missing or invalid shipment details.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access to the endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access to the endpoint is forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Ships a group of orders by processing the provided group shipment details.
     * @param command The command containing the group shipment ID and shipment details, including tracking numbers.
     * @return The group shipment was successfully shipped.
     */
    shipGroupOrders(command: ShipGroupOrdersCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/ShipGroupOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShipGroupOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShipGroupOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processShipGroupOrders(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid, such as missing or invalid shipment details.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access to the endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access to the endpoint is forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the next follow-up date for an existing order.
     * @param command The command containing the order ID and updated next follow-up date details.
     * @return The next follow-up date was successfully updated.
     */
    updateOrderNextFollowup(command: UpdateNextOrderFollowupCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/NextOrderFollowup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderNextFollowup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderNextFollowup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateOrderNextFollowup(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid or malformed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access to the endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access to the endpoint is forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the order history for a specific patient.
     * @param patientId The ID of the patient whose order history is to be retrieved.
     * @return A list of orders associated with the specified patient.
     */
    getPatientOrderHistory(patientId: number): Observable<GetPatientOrderHistoryQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/PatientOrderHistory/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientOrderHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientOrderHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPatientOrderHistoryQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPatientOrderHistoryQueryResponse[]>;
        }));
    }

    protected processGetPatientOrderHistory(response: HttpResponseBase): Observable<GetPatientOrderHistoryQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPatientOrderHistoryQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the status-change history for a single order: each status the order passed through,
    when it entered that status, and who moved it there.
     * @param id The unique identifier of the order.
     * @return The order's status transitions, oldest first.
     */
    getOrderStatusHistory(id: number): Observable<GetOrderStatusHistoryQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/StatusHistory";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderStatusHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderStatusHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderStatusHistoryQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderStatusHistoryQueryResponse[]>;
        }));
    }

    protected processGetOrderStatusHistory(response: HttpResponseBase): Observable<GetOrderStatusHistoryQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderStatusHistoryQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all drugs associated with a specific order.
     * @param id The unique identifier of the order.
     * @return A list of drugs associated with the specified order.
     */
    getOrderDrugs(id: number): Observable<GetOrderDrugsQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/OrderDrugs";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDrugs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDrugs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderDrugsQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderDrugsQueryResponse[]>;
        }));
    }

    protected processGetOrderDrugs(response: HttpResponseBase): Observable<GetOrderDrugsQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderDrugsQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a select list of drug details for a specific order.
     * @param id The unique identifier of the order.
     * @return A list of drug details for selection.
     */
    getDrugDetailsSelectList(id: number): Observable<GetDrugDetailsSelectListQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/DrugDetailsSelectList";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDrugDetailsSelectList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDrugDetailsSelectList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDrugDetailsSelectListQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDrugDetailsSelectListQueryResponse[]>;
        }));
    }

    protected processGetDrugDetailsSelectList(response: HttpResponseBase): Observable<GetDrugDetailsSelectListQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDrugDetailsSelectListQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancels an order based on the provided command.
     * @param command The command containing the details required to cancel the order. This must include valid order identifiers
                and any necessary cancellation information.
     * @return An IActionResult indicating the result of the operation. Returns a 200 OK response with a Result object if the cancellation is successful.
     */
    cancelOrder(command: CancelOrderCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCancelOrder(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates an ad-hoc order for a patient based on the provided command.
     * @param command The command containing the patient ID and reason for the ad-hoc order.
     * @return The ad-hoc order was successfully created.
     */
    createAdhocOrder(command: CreateAdhocOrderCommand): Observable<CreateAdhocOrderCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/CreateAdhocOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAdhocOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAdhocOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAdhocOrderCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAdhocOrderCommandResponse>;
        }));
    }

    protected processCreateAdhocOrder(response: HttpResponseBase): Observable<CreateAdhocOrderCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAdhocOrderCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid or malformed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access to the endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access to the endpoint is forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all orders that have been manually verified.
     * @return A collection of manually verified orders.
     */
    getOrdersManuallyVerified(): Observable<GetOrdersManuallyVerifiedQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/ManuallyVerified";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrdersManuallyVerified(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersManuallyVerified(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrdersManuallyVerifiedQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrdersManuallyVerifiedQueryResponse[]>;
        }));
    }

    protected processGetOrdersManuallyVerified(response: HttpResponseBase): Observable<GetOrdersManuallyVerifiedQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrdersManuallyVerifiedQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Raises an issue for a specific order.
     * @param command The command containing the details of the issue to be raised for the order.
     * @return An IActionResult indicating the success or failure of the operation.
     */
    raiseIssue(command: RaiseOrderIssueCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/RaiseIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRaiseIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRaiseIssue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processRaiseIssue(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reschedules an order based on the provided command.
     * @param command The command containing the order ID and new schedule details.
     * @return An IActionResult indicating the success or failure of the reschedule operation.
     */
    rescheduleOrder(command: RescheduleOrderCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/RescheduleOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRescheduleOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRescheduleOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processRescheduleOrder(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new note associated with an order.
     * @param command The command containing the order ID, note type, and note content details.
     * @return A result indicating success or failure of the note creation.
     */
    createNote(command: CreateNoteCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/Note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCreateNote(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing note associated with an order.
     * @param command The command containing the note ID, updated note type, and note content details.
     * @return A result indicating success or failure of the note update.
     */
    updateNote(command: UpdateNoteCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/Note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateNote(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the next follow-up date for a specific order.
     * @param id The unique identifier of the order.
     * @return The next follow-up date for the specified order.
     */
    getNextFollowupDate(id: number): Observable<GetNextFollowupDateQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/nextfollowupdate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextFollowupDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextFollowupDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNextFollowupDateQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNextFollowupDateQueryResponse>;
        }));
    }

    protected processGetNextFollowupDate(response: HttpResponseBase): Observable<GetNextFollowupDateQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetNextFollowupDateQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reschedules a group shipment order based on the provided command.
     * @param command The command containing the group shipment order ID and new schedule details.
     * @return An IActionResult indicating the success or failure of the reschedule operation.
     */
    rescheduleGroupShipmentOrder(command: RescheduleGroupShipmentOrderCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/RescheduleGroupShipmentOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRescheduleGroupShipmentOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRescheduleGroupShipmentOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processRescheduleGroupShipmentOrder(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves orders for commercialization as a parent-child grid (Patient+Workflow → OrderItems),
    filtered to a single tab by the order item's commercialization status category. Open items have no
    status yet assigned, Pending items have a status that is set but not closed, and Closed items have a
    commercialization status that is marked as closed.
    Completed items (Commercialized + AR Paid) are excluded from all tabs.
    The user can filter by either the order item's earliest fill date or AR follow-up date using the dateFilterField radio selection.
    The dateFrom and dateTo range is applied to the selected date field.
     * @param tab (optional) Selects which tab to return: Open (no status), Pending (status set but not closed), or Closed (status marked closed).
     * @param dateFilterField (optional) Specifies which date field to filter by:
    LastFillDate: Filters by the order item's earliest non-deleted KrollTransaction fill date.
    ArFollowUpDate: Filters by the order item's AR follow-up date.
     * @param dateFrom (optional) Optional filter: inclusive lower bound for the selected date field. Items with no value for the selected field are always included.
     * @param dateTo (optional) Optional filter: inclusive upper bound for the selected date field. Items with no value for the selected field are always included.
     * @param commercializationStatusId (optional) Optional filter: commercialization status ID.
     * @param arStatusId (optional) Optional filter: AR status ID.
     * @return A parent-child collection of patients with their order items for the commercialization workflow,
    filtered according to the selected criteria.
     */
    getOrdersForCommercialization(tab?: CommercializationTab | undefined, dateFilterField?: CommercializationDateFilterField | undefined, dateFrom?: DateTime | null | undefined, dateTo?: DateTime | null | undefined, commercializationStatusId?: number | null | undefined, arStatusId?: number | null | undefined): Observable<GetOrdersForCommercializationParentResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/OrdersForCommercialization?";
        if (tab === null)
            throw new globalThis.Error("The parameter 'tab' cannot be null.");
        else if (tab !== undefined)
            url_ += "tab=" + encodeURIComponent("" + tab) + "&";
        if (dateFilterField === null)
            throw new globalThis.Error("The parameter 'dateFilterField' cannot be null.");
        else if (dateFilterField !== undefined)
            url_ += "dateFilterField=" + encodeURIComponent("" + dateFilterField) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (commercializationStatusId !== undefined && commercializationStatusId !== null)
            url_ += "commercializationStatusId=" + encodeURIComponent("" + commercializationStatusId) + "&";
        if (arStatusId !== undefined && arStatusId !== null)
            url_ += "arStatusId=" + encodeURIComponent("" + arStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrdersForCommercialization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersForCommercialization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrdersForCommercializationParentResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrdersForCommercializationParentResponse[]>;
        }));
    }

    protected processGetOrdersForCommercialization(response: HttpResponseBase): Observable<GetOrdersForCommercializationParentResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrdersForCommercializationParentResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves follow-up orders within a specified date range.
     * @param followUpDateFrom (optional) The start date for the follow-up orders filter.
     * @param followUpDateTo (optional) The end date for the follow-up orders filter.
     * @return A collection of follow-up orders within the specified date range.
     */
    getFollowupOrders(followUpDateFrom?: DateTime | null | undefined, followUpDateTo?: DateTime | null | undefined): Observable<GetFollowupOrdersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/FollowupOrders?";
        if (followUpDateFrom !== undefined && followUpDateFrom !== null)
            url_ += "followUpDateFrom=" + encodeURIComponent(followUpDateFrom ? "" + followUpDateFrom.toString() : "") + "&";
        if (followUpDateTo !== undefined && followUpDateTo !== null)
            url_ += "followUpDateTo=" + encodeURIComponent(followUpDateTo ? "" + followUpDateTo.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFollowupOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFollowupOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFollowupOrdersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFollowupOrdersQueryResponse[]>;
        }));
    }

    protected processGetFollowupOrders(response: HttpResponseBase): Observable<GetFollowupOrdersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetFollowupOrdersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all orders with the "Requested" status from the system.
     */
    getRequestedOrders(): Observable<GetRequestedOrdersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/RequestedOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestedOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestedOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRequestedOrdersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRequestedOrdersQueryResponse[]>;
        }));
    }

    protected processGetRequestedOrders(response: HttpResponseBase): Observable<GetRequestedOrdersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRequestedOrdersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all orders that require Rx verification.
     * @return A collection of orders requiring Rx verification.
     */
    getRxVerificationOrders(): Observable<GetRxVerificationOrdersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/RxVerificationOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRxVerificationOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRxVerificationOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRxVerificationOrdersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRxVerificationOrdersQueryResponse[]>;
        }));
    }

    protected processGetRxVerificationOrders(response: HttpResponseBase): Observable<GetRxVerificationOrdersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRxVerificationOrdersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all ready-to-ship orders from the system.
     * @return A collection of orders that are ready to be shipped.
     */
    getReadyToShipOrders(): Observable<GetReadyToShipOrdersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/ReadyToShipOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReadyToShipOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReadyToShipOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReadyToShipOrdersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReadyToShipOrdersQueryResponse[]>;
        }));
    }

    protected processGetReadyToShipOrders(response: HttpResponseBase): Observable<GetReadyToShipOrdersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetReadyToShipOrdersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all orders with pending delivery status from the system.
     * @return A collection of orders that have been shipped but not yet delivered to their destinations.
     */
    getPendingDeliveryOrders(): Observable<GetPendingDeliveryOrdersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/PendingDeliveryOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingDeliveryOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingDeliveryOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPendingDeliveryOrdersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPendingDeliveryOrdersQueryResponse[]>;
        }));
    }

    protected processGetPendingDeliveryOrders(response: HttpResponseBase): Observable<GetPendingDeliveryOrdersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPendingDeliveryOrdersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all orders that are scheduled for pickup.
     * @return A collection of orders scheduled for pickup.
     */
    getPickupOrders(): Observable<GetPickupOrdersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/PickupOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPickupOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPickupOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPickupOrdersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPickupOrdersQueryResponse[]>;
        }));
    }

    protected processGetPickupOrders(response: HttpResponseBase): Observable<GetPickupOrdersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPickupOrdersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all orders with delivery issues from the system.
     * @return A collection of orders that have delivery issues.
     */
    getDeliveryIssueOrders(): Observable<GetDeliveryIssueOrdersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/DeliveryIssueOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryIssueOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryIssueOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDeliveryIssueOrdersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDeliveryIssueOrdersQueryResponse[]>;
        }));
    }

    protected processGetDeliveryIssueOrders(response: HttpResponseBase): Observable<GetDeliveryIssueOrdersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDeliveryIssueOrdersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reports a delivery issue for an order.
     * @param command The command containing delivery issue details for the order.
     * @return An IActionResult indicating the success or failure of the operation.
     */
    reportDeliveryIssue(command: ReportOrderDeliveryIssueCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/ReportDeliveryIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportDeliveryIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportDeliveryIssue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processReportDeliveryIssue(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves related group replacement orders for a specific order.
     * @param id The unique identifier of the order.
     * @return A collection of related group replacement orders.
     */
    getRelatedGroupReplacementOrders(id: number): Observable<GetRelatedGroupReplacementOrdersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/RelatedGroupReplacementOrders";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelatedGroupReplacementOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelatedGroupReplacementOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRelatedGroupReplacementOrdersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRelatedGroupReplacementOrdersQueryResponse[]>;
        }));
    }

    protected processGetRelatedGroupReplacementOrders(response: HttpResponseBase): Observable<GetRelatedGroupReplacementOrdersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRelatedGroupReplacementOrdersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Schedules related orders for processing based on the provided command.
     * @param command The command containing details for scheduling related orders.
     * @return An IActionResult indicating the result of the scheduling operation.
     */
    scheduleRelatedOrders(command: ScheduleRelatedOrdersCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/ScheduleRelatedOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleRelatedOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleRelatedOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processScheduleRelatedOrders(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates Kroll transaction records for order items.
     * @param command The command containing order item Kroll transaction details.
     * @return An IActionResult indicating the result of the operation.
     */
    krollTransaction(command: CreateOrderItemKrollTransactionsCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/KrollTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKrollTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKrollTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processKrollTransaction(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resolves the Kroll transaction details for an existing order item.
     * @param command The command containing the Kroll transaction data to resolve for the order item.
     * @return A 200 OK response with the result if the resolution was successful;
    a 400 Bad Request if the command is invalid;
    a 401 Unauthorized if the caller is not authenticated;
    a 403 Forbidden if the caller lacks the required permissions;
    or a 500 Internal Server Error if an unexpected error occurs.
     */
    resolveKrollTransaction(command: ResolveKrollTransactionCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/ResolveKrollTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveKrollTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveKrollTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processResolveKrollTransaction(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resolves a delivery issue for an order.
     * @param command The command containing details to resolve the delivery issue.
     * @return An IActionResult indicating the result of the operation.
     */
    resolveDeliveryIssue(command: ResolveDeliveryIssueCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/ResolveDeliveryIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveDeliveryIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveDeliveryIssue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processResolveDeliveryIssue(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the date and time when the Drug-Drug Interaction (DDI) Review was completed for a specific order.
     * @param command The UpdateOrderDateDdiReviewCompletedCommand containing the unique identifier of the order to update.
     * @return Result indicating success or failure:
    200 OK: The DDI review completion date was successfully updated.
    400 Bad Request: The request is invalid.
    401 Unauthorized: The user is not authenticated.
    403 Forbidden: The user does not have permission to perform this action.
    404 Not Found: The order with the specified ID does not exist.
    500 Internal Server Error: An unexpected error occurred.
     */
    updateOrderDateDdiReviewCompleted(command: UpdateOrderDateDdiReviewCompletedCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/UpdateOrderDateDdiReviewCompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderDateDdiReviewCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderDateDdiReviewCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateOrderDateDdiReviewCompleted(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the items from the previous order for the same workflow, patient, and pharmacy as the specified current order.
     * @param currentOrderId The unique identifier of the current order.
     * @return Returns the list of previous order items.
     */
    getPreviousOrderItems(currentOrderId: number): Observable<GetOrderItemsQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/{currentOrderId}/PreviousOrderItems";
        if (currentOrderId === undefined || currentOrderId === null)
            throw new globalThis.Error("The parameter 'currentOrderId' must be defined.");
        url_ = url_.replace("{currentOrderId}", encodeURIComponent("" + currentOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreviousOrderItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreviousOrderItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderItemsQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderItemsQueryResponse[]>;
        }));
    }

    protected processGetPreviousOrderItems(response: HttpResponseBase): Observable<GetOrderItemsQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderItemsQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request is invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access to the endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access to the endpoint is forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a manual order for a specified patient and workflow.
     * @param command The CreateManualOrderCommand containing:
    PatientId (long): The unique identifier of the patient for whom the manual order is being created.
    WorkflowId (long): The unique identifier of the workflow for which the order is being created.
     * @return The manual order was successfully created.
     */
    createManualOrder(command: CreateManualOrderCommand): Observable<CreateManualOrderCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/CreateManualOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateManualOrderCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateManualOrderCommandResponse>;
        }));
    }

    protected processCreateManualOrder(response: HttpResponseBase): Observable<CreateManualOrderCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateManualOrderCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid or malformed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access to the endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access to the endpoint is forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Rejects an order based on the specified command.
     * @param command The command containing the details required to reject the order. Cannot be null.
     * @return An IActionResult representing the result of the reject operation. Returns a 200 OK response
                with the result if the operation succeeds; otherwise, returns an appropriate error response.
     */
    rejectOrder(command: RejectOrderCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/Reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processRejectOrder(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the status of a specific order by its unique identifier.
     * @param id The unique identifier of the order.
     * @return The status information for the specified order.
     */
    getOrderStatus(id: number): Observable<GetOrderStatusQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/Status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderStatusQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderStatusQueryResponse>;
        }));
    }

    protected processGetOrderStatus(response: HttpResponseBase): Observable<GetOrderStatusQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderStatusQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks whether an order is still an open (unresolved) delivery issue, so the delivery-issue
    screen can tell before acting if another session has resolved or moved the order on.
     * @param id The unique identifier of the order.
     * @return Whether the order is still an open delivery issue.
     */
    getDeliveryIssueOrderState(id: number): Observable<GetDeliveryIssueOrderStateQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/DeliveryIssueState";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryIssueOrderState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryIssueOrderState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDeliveryIssueOrderStateQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDeliveryIssueOrderStateQueryResponse>;
        }));
    }

    protected processGetDeliveryIssueOrderState(response: HttpResponseBase): Observable<GetDeliveryIssueOrderStateQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDeliveryIssueOrderStateQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Atomically creates a new patient and accepts the linked order in a single transaction.
    If either operation fails, all changes are rolled back.
     * @param command The command containing patient details and order acceptance parameters.
     * @return A CreatePatientAndAcceptOrderCommandResponse containing the new patient ID and accepted order ID on success.
     */
    createPatientAndAcceptOrder(command: CreatePatientAndAcceptOrderCommand): Observable<CreatePatientAndAcceptOrderCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/CreatePatientAndAcceptOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatientAndAcceptOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatientAndAcceptOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePatientAndAcceptOrderCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePatientAndAcceptOrderCommandResponse>;
        }));
    }

    protected processCreatePatientAndAcceptOrder(response: HttpResponseBase): Observable<CreatePatientAndAcceptOrderCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePatientAndAcceptOrderCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the patient information associated with a specific order by its unique identifier.
     * @param id The unique identifier of the order.
     * @return The patient information for the specified order.
     */
    getPatientByOrderId(id: number): Observable<GetPatientByOrderIdQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/Patient";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientByOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientByOrderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPatientByOrderIdQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPatientByOrderIdQueryResponse>;
        }));
    }

    protected processGetPatientByOrderId(response: HttpResponseBase): Observable<GetPatientByOrderIdQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPatientByOrderIdQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates order items for commercialization,
    optionally adding a commercialization note, and creating Kroll transaction records.
     * @param command The command containing the order ID, optional note, and Kroll transactions.
     * @return A result indicating success or failure of the commercialization operation.
     */
    updateOrderItemsForCommercialization(command: UpdateOrderItemsForCommercializationCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/UpdateOrderItemsForCommercialization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderItemsForCommercialization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderItemsForCommercialization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateOrderItemsForCommercialization(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all order items for the specified order item IDs that have at least one commercialized Kroll transaction,
    along with their linked Kroll prescription data. Each order item is returned as a parent row, with its
    matched commercialized Kroll Rx records as child rows, enriched with fill date, dispensed quantity,
    and days supply from the Kroll API. If no commercialized Kroll transactions exist for the given items,
    an empty list is returned.
     * @param patientId (optional) The unique identifier of the patient.
     * @param workflowId (optional) The unique identifier of the workflow.
     * @param isOpen (optional) When true, returns open commercialization items; when false, returns closed items.
     * @return Returns the list of order items with commercialized Kroll transactions and their Kroll Rx data.
     */
    getCommercializedDispensesWithKrollRx(patientId?: number | undefined, workflowId?: number | undefined, isOpen?: boolean | undefined): Observable<GetCommercializedDispensesWithKrollRxResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/CommercializedDispensesWithKrollRx?";
        if (patientId === null)
            throw new globalThis.Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        if (isOpen === null)
            throw new globalThis.Error("The parameter 'isOpen' cannot be null.");
        else if (isOpen !== undefined)
            url_ += "isOpen=" + encodeURIComponent("" + isOpen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercializedDispensesWithKrollRx(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercializedDispensesWithKrollRx(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCommercializedDispensesWithKrollRxResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCommercializedDispensesWithKrollRxResponse>;
        }));
    }

    protected processGetCommercializedDispensesWithKrollRx(response: HttpResponseBase): Observable<GetCommercializedDispensesWithKrollRxResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCommercializedDispensesWithKrollRxResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request is invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access to the endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access to the endpoint is forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all non-commercialized order items for a specific patient and workflow,
    along with their linked non-commercialized Kroll prescription data. Each order item is returned as a parent row,
    with its matched Kroll Rx records as child rows, enriched with fill date, drug name, dispensed quantity,
    and days supply from the Kroll API.
     * @param patientId (optional) The unique identifier of the patient.
     * @param workflowId (optional) The unique identifier of the workflow.
     * @param isOpen (optional) When true, returns open commercialization items; when false, returns closed items.
     * @return Returns the list of order items with non-commercialized Kroll transactions and their Kroll Rx data.
     */
    nonCommercializedDispensesWithKrollRx(patientId?: number | undefined, workflowId?: number | undefined, isOpen?: boolean | undefined): Observable<GetNonCommercializedDispensesWithKrollRxResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/NonCommercializedDispensesWithKrollRx?";
        if (patientId === null)
            throw new globalThis.Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        if (isOpen === null)
            throw new globalThis.Error("The parameter 'isOpen' cannot be null.");
        else if (isOpen !== undefined)
            url_ += "isOpen=" + encodeURIComponent("" + isOpen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNonCommercializedDispensesWithKrollRx(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNonCommercializedDispensesWithKrollRx(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNonCommercializedDispensesWithKrollRxResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNonCommercializedDispensesWithKrollRxResponse>;
        }));
    }

    protected processNonCommercializedDispensesWithKrollRx(response: HttpResponseBase): Observable<GetNonCommercializedDispensesWithKrollRxResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetNonCommercializedDispensesWithKrollRxResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request is invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access to the endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access to the endpoint is forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a collection of orders that have mismatched patient information.
     * @return An IActionResult containing a collection of unmatched orders if successful; otherwise, an
                error response indicating the reason for failure.
     */
    getMismatchedOrders(): Observable<GetMismatchedOrdersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Order/Mismatched";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMismatchedOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMismatchedOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMismatchedOrdersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMismatchedOrdersQueryResponse[]>;
        }));
    }

    protected processGetMismatchedOrders(response: HttpResponseBase): Observable<GetMismatchedOrdersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetMismatchedOrdersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves details of mismatched orders for the specified order identifier.
     * @param id The unique identifier of the order for which to retrieve mismatched details.
     * @return An IActionResult containing the mismatched order details if found; otherwise, an appropriate
                error response.
     */
    getMismatchedOrderDetails(id: number): Observable<GetMismatchedOrderDetailsQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/{id}/Mismatched";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMismatchedOrderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMismatchedOrderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMismatchedOrderDetailsQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMismatchedOrderDetailsQueryResponse>;
        }));
    }

    protected processGetMismatchedOrderDetails(response: HttpResponseBase): Observable<GetMismatchedOrderDetailsQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetMismatchedOrderDetailsQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resolves mismatches detected in an order through the provided command.
     * @param command The ResolveOrderMismatchCommand that contains the details required to resolve the order mismatch.
     * @return Returns a 200 OK response with the operation result if the mismatch was resolved successfully.  
    - 400 Bad Request if the input is invalid.
    - 401 Unauthorized if the user is not authenticated.
    - 403 Forbidden if the user does not have permission.
    - 500 Internal Server Error if an unexpected error occurs.
     */
    resolveMismatch(command: ResolveOrderMismatchCommand): Observable<ResolveOrderMismatchCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/ResolveMismatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveMismatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveMismatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResolveOrderMismatchCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResolveOrderMismatchCommandResponse>;
        }));
    }

    protected processResolveMismatch(response: HttpResponseBase): Observable<ResolveOrderMismatchCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResolveOrderMismatchCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Dismisses a mismatch detected in an order.
     * @param command The command containing the details required to dismiss the order mismatch.
     * @return Returns a 200 OK response with the operation result if the mismatch was dismissed successfully.
    - 400 Bad Request if the input is invalid.
    - 401 Unauthorized if the user is not authenticated.
    - 403 Forbidden if the user does not have permission.
    - 500 Internal Server Error if an unexpected error occurs.
     */
    dismissMismatch(command: DismissOrderMismatchCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Order/DismissMismatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDismissMismatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDismissMismatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDismissMismatch(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all Kroll Rx dispenses associated with a specific order item.
     * @param orderItemId (optional) The unique identifier of the order item.
     * @return Returns the Kroll Rx dispenses for the order item.
     */
    getOrderItemKrollRxDispensesQuery(orderItemId?: number | undefined): Observable<GetOrderItemKrollRxDispensesResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/GetOrderItemKrollRxDispensesQuery?";
        if (orderItemId === null)
            throw new globalThis.Error("The parameter 'orderItemId' cannot be null.");
        else if (orderItemId !== undefined)
            url_ += "orderItemId=" + encodeURIComponent("" + orderItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderItemKrollRxDispensesQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderItemKrollRxDispensesQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderItemKrollRxDispensesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderItemKrollRxDispensesResponse>;
        }));
    }

    protected processGetOrderItemKrollRxDispensesQuery(response: HttpResponseBase): Observable<GetOrderItemKrollRxDispensesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderItemKrollRxDispensesResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request is invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access to the endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access to the endpoint is forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves completed dispenses that do not have any uncancelled Kroll transactions.
     * @param fillDateFrom (optional) Inclusive start date for fill date filtering.
     * @param fillDateTo (optional) Inclusive end date for fill date filtering.
     * @param pageNumber (optional) 1-based page number.
     * @param pageSize (optional) Page size. Allowed values are 5, 10, 20, 30, 40, and 50.
     * @return Returns paged completed dispenses without uncancelled Kroll transactions. When Kroll is unavailable but fallback data is available, the response is still 200 with degradation headers.
     */
    getMissingDispensesWithKrollRx(fillDateFrom?: DateTime | undefined, fillDateTo?: DateTime | undefined, pageNumber?: number | undefined, pageSize?: number | undefined): Observable<GetMissingDispensesWithKrollRxResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/MissingDispensesWithKrollRx?";
        if (fillDateFrom === null)
            throw new globalThis.Error("The parameter 'fillDateFrom' cannot be null.");
        else if (fillDateFrom !== undefined)
            url_ += "fillDateFrom=" + encodeURIComponent(fillDateFrom ? "" + fillDateFrom.toString() : "") + "&";
        if (fillDateTo === null)
            throw new globalThis.Error("The parameter 'fillDateTo' cannot be null.");
        else if (fillDateTo !== undefined)
            url_ += "fillDateTo=" + encodeURIComponent(fillDateTo ? "" + fillDateTo.toString() : "") + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMissingDispensesWithKrollRx(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissingDispensesWithKrollRx(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissingDispensesWithKrollRxResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissingDispensesWithKrollRxResponse>;
        }));
    }

    protected processGetMissingDispensesWithKrollRx(response: HttpResponseBase): Observable<GetMissingDispensesWithKrollRxResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetMissingDispensesWithKrollRxResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request is invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access to the endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access to the endpoint is forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports commercialized inventory data as an Excel file for transactions within the specified date range.
     * @param fromDate (optional) Start date (inclusive) for the DateCommercialized filter.
     * @param toDate (optional) End date (inclusive) for the DateCommercialized filter.
     * @return An .xlsx file attachment when data exists, 204 No Content when no matching data is found,
    or the appropriate error response.
     */
    getExcelExportForCommercializedInventory(fromDate?: DateTime | undefined, toDate?: DateTime | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Order/GetExcelExportForCommercializedInventory?";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcelExportForCommercializedInventory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcelExportForCommercializedInventory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetExcelExportForCommercializedInventory(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An .xlsx file attachment when data exists, 204 No Content when no matching data is found,\nor the appropriate error response.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderLockClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves the current lock status of the specified order without side effects.
     * @param orderId The unique identifier of the order to check.
     * @return The current lock state including holder info and pending request details.
     */
    getStatus(orderId: number): Observable<GetOrderLockQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/order/{orderId}/lock";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderLockQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderLockQueryResponse>;
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<GetOrderLockQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderLockQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Releases the lock on the specified order held by the current user.
     * @param orderId The unique identifier of the order to unlock.
     * @return A result indicating success or failure of the release operation.
     */
    release(orderId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/order/{orderId}/lock";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRelease(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Attempts to acquire a lock on the specified order for the current user.
    If not locked, acquires the lock. If already locked by the current user, renews it.
    If locked by another user, returns the current lock holder's information.
     * @param orderId The unique identifier of the order to lock.
     * @param body The request containing connection and device info.
     * @return Lock state including the holder info and whether a new lock was acquired.
     */
    tryAcquire(orderId: number, body: TryAcquireLockBody): Observable<TryAcquireLockCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/order/{orderId}/lock/TryAcquire";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTryAcquire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTryAcquire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TryAcquireLockCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TryAcquireLockCommandResponse>;
        }));
    }

    protected processTryAcquire(response: HttpResponseBase): Observable<TryAcquireLockCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TryAcquireLockCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Requests the lock from the current holder of the specified order.
    The owner receives a SignalR notification and has a configurable timeout to respond.
     * @param orderId The unique identifier of the order to request the lock for.
     * @param body The lock request containing the requester's connection ID.
     * @return The request expiry timestamp and timeout in seconds.
     */
    requestLock(orderId: number, body: ConnectionIdBody): Observable<RequestLockCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/order/{orderId}/lock/Request";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestLock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestLock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestLockCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestLockCommandResponse>;
        }));
    }

    protected processRequestLock(response: HttpResponseBase): Observable<RequestLockCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestLockCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancels a pending lock request made by the current user on the specified order.
     * @param orderId The unique identifier of the order to cancel the lock request for.
     * @return A result indicating success or failure of the cancellation.
     */
    cancelRequest(orderId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/order/{orderId}/lock/Request";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approves a pending lock request, transferring the lock to the requester.
    Only the current lock owner can approve.
     * @param orderId The unique identifier of the order whose lock request to approve.
     * @return A result indicating success or failure of the approval.
     */
    approve(orderId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/order/{orderId}/lock/Request/Approve";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Declines a pending lock request on the specified order.
    Only the current lock owner can decline.
     * @param orderId The unique identifier of the order whose lock request to decline.
     * @return A result indicating success or failure of the decline.
     */
    decline(orderId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/order/{orderId}/lock/Request/Decline";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDecline(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Forcefully steals the lock from the current holder after the request timeout expires.
    Only the user who made the pending request (or any user if no request exists) may steal.
     * @param orderId The unique identifier of the order whose lock to steal.
     * @param body The steal request containing the new holder's connection ID.
     * @return The new lock expiry timestamp.
     */
    steal(orderId: number, body: ConnectionIdBody): Observable<StealLockCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/order/{orderId}/lock/Steal";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSteal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSteal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StealLockCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StealLockCommandResponse>;
        }));
    }

    protected processSteal(response: HttpResponseBase): Observable<StealLockCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StealLockCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PatientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves the patient information.
     * @param id The ID of the patient.
     * @return The patient information.
     */
    getPatient(id: number): Observable<GetPatientByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Patient/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPatientByIdQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPatientByIdQueryResponse>;
        }));
    }

    protected processGetPatient(response: HttpResponseBase): Observable<GetPatientByIdQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPatientByIdQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves patients that match the specified search criteria.
     * @param orderId (optional) Order Id
     * @param sourceSystemExternalReferenceId (optional) External identifier for the patient in source system e.g. PSP ID
     * @param dateOfBirth (optional) Patient's date of birth
     * @param firstName (optional) Patient's first name
     * @param lastName (optional) Patient's last name
     * @param addressLine1 (optional) First line of patient's home address
     * @param postalCode (optional) Patient's postal code
     * @param email (optional) Patient's email address
     * @param prHealthCard (optional) Patient's provincial health card number
     * @param genderValueCode (optional) Code representing patient's gender
     * @param province (optional) Patient's province of residence
     * @return A collection of patients matching the specified criteria.
     */
    getPatientMatches(orderId?: number | undefined, sourceSystemExternalReferenceId?: string | null | undefined, dateOfBirth?: DateTime | undefined, firstName?: string | undefined, lastName?: string | undefined, addressLine1?: string | null | undefined, postalCode?: string | null | undefined, email?: string | null | undefined, prHealthCard?: string | null | undefined, genderValueCode?: string | null | undefined, province?: string | null | undefined): Observable<GetPatientMatchesQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Patient/Matches?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&";
        if (sourceSystemExternalReferenceId !== undefined && sourceSystemExternalReferenceId !== null)
            url_ += "SourceSystemExternalReferenceId=" + encodeURIComponent("" + sourceSystemExternalReferenceId) + "&";
        if (dateOfBirth === null)
            throw new globalThis.Error("The parameter 'dateOfBirth' cannot be null.");
        else if (dateOfBirth !== undefined)
            url_ += "DateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toString() : "") + "&";
        if (firstName === null)
            throw new globalThis.Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === null)
            throw new globalThis.Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (addressLine1 !== undefined && addressLine1 !== null)
            url_ += "AddressLine1=" + encodeURIComponent("" + addressLine1) + "&";
        if (postalCode !== undefined && postalCode !== null)
            url_ += "PostalCode=" + encodeURIComponent("" + postalCode) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (prHealthCard !== undefined && prHealthCard !== null)
            url_ += "PrHealthCard=" + encodeURIComponent("" + prHealthCard) + "&";
        if (genderValueCode !== undefined && genderValueCode !== null)
            url_ += "GenderValueCode=" + encodeURIComponent("" + genderValueCode) + "&";
        if (province !== undefined && province !== null)
            url_ += "Province=" + encodeURIComponent("" + province) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPatientMatchesQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPatientMatchesQueryResponse>;
        }));
    }

    protected processGetPatientMatches(response: HttpResponseBase): Observable<GetPatientMatchesQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPatientMatchesQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new patient in the system.
     * @param command The command containing the details of the patient to create.
     * @return A result indicating the success or failure of the operation.
     */
    createPatient(command: CreatePatientCommand): Observable<CreatePatientCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Patient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePatientCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePatientCommandResponse>;
        }));
    }

    protected processCreatePatient(response: HttpResponseBase): Observable<CreatePatientCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePatientCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Searches for patients based on the specified criteria.
     * @param dateOfBirth (optional) 
     * @param email (optional) 
     * @param externalId (optional) 
     * @param patientKrollId (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param prhealthCard (optional) 
     * @param phone (optional) 
     * @param preferredLanguage (optional) 
     * @param orderId (optional) 
     * @return A collection of patients matching the specified criteria.
    Returns a success response with the matching patients, or an error response if no patients are found.
     */
    searchPatients(dateOfBirth?: DateTime | null | undefined, email?: string | null | undefined, externalId?: string | null | undefined, patientKrollId?: number | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, prhealthCard?: string | null | undefined, phone?: string | null | undefined, preferredLanguage?: string | null | undefined, orderId?: number | null | undefined): Observable<PatientSearchQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Patient/Search?";
        if (dateOfBirth !== undefined && dateOfBirth !== null)
            url_ += "DateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toString() : "") + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (externalId !== undefined && externalId !== null)
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&";
        if (patientKrollId !== undefined && patientKrollId !== null)
            url_ += "PatientKrollId=" + encodeURIComponent("" + patientKrollId) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (prhealthCard !== undefined && prhealthCard !== null)
            url_ += "PrhealthCard=" + encodeURIComponent("" + prhealthCard) + "&";
        if (phone !== undefined && phone !== null)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (preferredLanguage !== undefined && preferredLanguage !== null)
            url_ += "PreferredLanguage=" + encodeURIComponent("" + preferredLanguage) + "&";
        if (orderId !== undefined && orderId !== null)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchPatients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPatients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientSearchQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientSearchQueryResponse[]>;
        }));
    }

    protected processSearchPatients(response: HttpResponseBase): Observable<PatientSearchQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatientSearchQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves notes associated with a specific patient and note type.
     * @param id The unique identifier of the patient.
     * @param noteType The type of notes to retrieve (e.g., medical, administrative).
     * @return An IActionResult containing a collection of notes matching the specified criteria.
    Returns a success response with the notes if found, or an error response if no notes are available or an issue occurs.
     */
    getPatientNotes(id: number, noteType: NoteType): Observable<GetPatientNotesQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Patient/{id}/notes/{noteType}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (noteType === undefined || noteType === null)
            throw new globalThis.Error("The parameter 'noteType' must be defined.");
        url_ = url_.replace("{noteType}", encodeURIComponent("" + noteType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPatientNotesQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPatientNotesQueryResponse[]>;
        }));
    }

    protected processGetPatientNotes(response: HttpResponseBase): Observable<GetPatientNotesQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPatientNotesQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a Kroll patient by their Kroll ID.
     * @param patientKrollId (optional) The unique identifier of the Kroll patient.
     * @param patientId (optional) The Link patient the caller is looking at. Optional. When supplied, the response also carries
    what a refresh would change about their stored contacts, which the header refresh needs in
    order to show the user what would happen. Callers that only display Kroll's list, such as the
    shipping-address picker, leave it null and are unaffected.
     * @return The Kroll patient data was successfully retrieved.
     */
    getKrollPatientById(patientKrollId?: number | undefined, patientId?: number | null | undefined): Observable<GetKrollPatientByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Patient/GetKrollPatientById?";
        if (patientKrollId === null)
            throw new globalThis.Error("The parameter 'patientKrollId' cannot be null.");
        else if (patientKrollId !== undefined)
            url_ += "PatientKrollId=" + encodeURIComponent("" + patientKrollId) + "&";
        if (patientId !== undefined && patientId !== null)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKrollPatientById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKrollPatientById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetKrollPatientByIdQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetKrollPatientByIdQueryResponse>;
        }));
    }

    protected processGetKrollPatientById(response: HttpResponseBase): Observable<GetKrollPatientByIdQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetKrollPatientByIdQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request is invalid (e.g., missing or invalid parameters).", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request is unauthorized (e.g., missing or invalid authentication).", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request is forbidden (e.g., insufficient permissions).", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The Kroll patient was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a patient's information from Kroll.
     * @param command The command containing the patient IDs.
     * @return A result indicating the success or failure of the operation.
     */
    updatePatientFromKroll(command: UpdatePatientFromKrollCommand): Observable<UpdatePatientFromKrollCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Patient/UpdatePatientFromKroll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatientFromKroll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatientFromKroll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePatientFromKrollCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePatientFromKrollCommandResponse>;
        }));
    }

    protected processUpdatePatientFromKroll(response: HttpResponseBase): Observable<UpdatePatientFromKrollCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdatePatientFromKrollCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves Kroll patient prescription data by patient ID.
     * @param patientKrollId (optional) The unique identifier of the patient in the Kroll system.
     * @param daysSinceFillDate (optional) The number of days since the fill date to filter prescriptions.
     * @param dins (optional) The list of DINs to filter prescriptions.
     * @param excludedOrderId (optional) An optional order ID to exclude from the results.
     * @return An IActionResult containing the Kroll patient prescription data if found, or an error response if not.
     */
    getKrollPatientRxById(patientKrollId?: number | undefined, daysSinceFillDate?: number | undefined, dins?: string[] | undefined, excludedOrderId?: number | null | undefined): Observable<GetKrollPatientRxByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Patient/GetKrollPatientRxById?";
        if (patientKrollId === null)
            throw new globalThis.Error("The parameter 'patientKrollId' cannot be null.");
        else if (patientKrollId !== undefined)
            url_ += "PatientKrollId=" + encodeURIComponent("" + patientKrollId) + "&";
        if (daysSinceFillDate === null)
            throw new globalThis.Error("The parameter 'daysSinceFillDate' cannot be null.");
        else if (daysSinceFillDate !== undefined)
            url_ += "daysSinceFillDate=" + encodeURIComponent("" + daysSinceFillDate) + "&";
        if (dins === null)
            throw new globalThis.Error("The parameter 'dins' cannot be null.");
        else if (dins !== undefined)
            dins && dins.forEach(item => { url_ += "dins=" + encodeURIComponent("" + item) + "&"; });
        if (excludedOrderId !== undefined && excludedOrderId !== null)
            url_ += "excludedOrderId=" + encodeURIComponent("" + excludedOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKrollPatientRxById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKrollPatientRxById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetKrollPatientRxByIdQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetKrollPatientRxByIdQueryResponse>;
        }));
    }

    protected processGetKrollPatientRxById(response: HttpResponseBase): Observable<GetKrollPatientRxByIdQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetKrollPatientRxByIdQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the information note associated with a specific patient.
     * @param id The unique identifier of the patient.
     * @return An IActionResult containing the patient's information note if found, or an error response if not found or an issue occurs.
     */
    getPatientInfoNote(id: number): Observable<GetPatientInfoNotesQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Patient/{id}/InfoNote";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientInfoNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientInfoNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPatientInfoNotesQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPatientInfoNotesQueryResponse>;
        }));
    }

    protected processGetPatientInfoNote(response: HttpResponseBase): Observable<GetPatientInfoNotesQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPatientInfoNotesQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates or updates an information note for a patient.
     * @param command The command containing the patient ID and information note details.
     * @return An IActionResult containing a success result if the note was created/updated successfully,
    or an error response if the operation failed.
     */
    createPatientInfoNote(command: CreatePatientInfoNoteCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Patient/InfoNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatientInfoNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatientInfoNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCreatePatientInfoNote(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a patient's communication-consent preferences (SMS and email).
     * @param command The command containing the patient ID and consent flags.
     * @return A result indicating the success or failure of the operation.
     */
    updateCommunicationConsent(command: UpdatePatientCommunicationConsentCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Patient/CommunicationConsent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCommunicationConsent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCommunicationConsent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateCommunicationConsent(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all external reference identifiers associated with a specific patient.
     * @param id The unique identifier of the patient.
     * @param workflowId (optional) The unique identifier of the workflow (optional).
     * @return Returns a collection of external reference identifiers for the patient.
     */
    getPatientExternalIds(id: number, workflowId?: number | null | undefined): Observable<GetPatientExternalIdsQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Patient/{id}/PatientExternalIds?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (workflowId !== undefined && workflowId !== null)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientExternalIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientExternalIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPatientExternalIdsQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPatientExternalIdsQueryResponse[]>;
        }));
    }

    protected processGetPatientExternalIds(response: HttpResponseBase): Observable<GetPatientExternalIdsQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPatientExternalIdsQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request is invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Authentication failed.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Insufficient permissions.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The patient was not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Handles an HTTP GET request to retrieve all patient matches based on the specified query parameters.
     * @param firstName (optional) When true, includes first name as a matching criterion.
     * @param lastName (optional) When true, includes last name as a matching criterion.
     * @param dob (optional) When true, includes date of birth as a matching criterion.
     * @param province (optional) When true, includes home province as a matching criterion.
     * @param programId (optional) When true, includes program ID (external reference) as a matching criterion.
     * @param pHN (optional) When true, includes provincial health number as a matching criterion.
     * @param patientKrollId (optional) When true, includes Kroll patient ID as a matching criterion.
     * @return An IActionResult containing a GetAllPatientMatchesQueryResponse with the list of
                patient matches if successful; otherwise, an error response indicating the reason for failure.
     */
    getAllPatientMatches(firstName?: boolean | undefined, lastName?: boolean | undefined, dob?: boolean | undefined, province?: boolean | undefined, programId?: boolean | undefined, pHN?: boolean | undefined, patientKrollId?: boolean | undefined): Observable<GetAllPatientMatchesQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Patient/AllMatches?";
        if (firstName === null)
            throw new globalThis.Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === null)
            throw new globalThis.Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (dob === null)
            throw new globalThis.Error("The parameter 'dob' cannot be null.");
        else if (dob !== undefined)
            url_ += "Dob=" + encodeURIComponent("" + dob) + "&";
        if (province === null)
            throw new globalThis.Error("The parameter 'province' cannot be null.");
        else if (province !== undefined)
            url_ += "Province=" + encodeURIComponent("" + province) + "&";
        if (programId === null)
            throw new globalThis.Error("The parameter 'programId' cannot be null.");
        else if (programId !== undefined)
            url_ += "ProgramId=" + encodeURIComponent("" + programId) + "&";
        if (pHN === null)
            throw new globalThis.Error("The parameter 'pHN' cannot be null.");
        else if (pHN !== undefined)
            url_ += "PHN=" + encodeURIComponent("" + pHN) + "&";
        if (patientKrollId === null)
            throw new globalThis.Error("The parameter 'patientKrollId' cannot be null.");
        else if (patientKrollId !== undefined)
            url_ += "PatientKrollId=" + encodeURIComponent("" + patientKrollId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPatientMatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPatientMatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllPatientMatchesQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllPatientMatchesQueryResponse>;
        }));
    }

    protected processGetAllPatientMatches(response: HttpResponseBase): Observable<GetAllPatientMatchesQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAllPatientMatchesQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Handles an HTTP POST request to merge two patient records by reassigning all orders from the destination
    patient to the source patient, then soft-deleting the destination patient.
     * @param command The command containing the source and destination patient IDs.
     * @return An IActionResult indicating the result of the merge operation.
     */
    mergePatients(command: MergePatientsCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Patient/Merge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMergePatients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMergePatients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processMergePatients(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Processes a request to mark a duplicate patient record as reviewed.
     * @param command The command containing the details required to mark the duplicate patient as reviewed. Cannot be null.
     * @return An IActionResult indicating the result of the operation. Returns 200 OK with the result if successful, 400
                Bad Request if the request is invalid, 401 Unauthorized if authentication fails, 403 Forbidden if the user
                does not have permission, or 404 Not Found if the specified resource does not exist.
     */
    duplicateReviewed(command: DuplicatePatientReviewedCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Patient/DuplicateReviewed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateReviewed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateReviewed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDuplicateReviewed(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves commercialization notes for a patient.
     * @param patientId The unique identifier of the patient.
     * @param workflowId (optional) Optional workflow identifier used to filter notes to a single workflow.
     * @return Commercialization notes were retrieved successfully.
     */
    getPatientCommercializationNotes(patientId: number, workflowId?: number | null | undefined): Observable<GetPatientCommercializationNotesQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Patient/{patientId}/CommercializationNotes?";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (workflowId !== undefined && workflowId !== null)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientCommercializationNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientCommercializationNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPatientCommercializationNotesQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPatientCommercializationNotesQueryResponse[]>;
        }));
    }

    protected processGetPatientCommercializationNotes(response: HttpResponseBase): Observable<GetPatientCommercializationNotesQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPatientCommercializationNotesQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Authentication failed.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The authenticated user is not authorized to access this resource.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates or updates an external identifier for a specific patient.
     * @param command The command containing the patient ID and external identifier details.
     * @return An IActionResult containing a success result if the external identifier was created/updated successfully,
    or an error response if the operation failed.
     */
    createExternalId(command: CreatePatientExternalIdCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Patient/ExternalId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCreateExternalId(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the external identifier associated with a patient.
     * @param command The command containing the details required to identify and delete the patient's external identifier. Cannot
                be null.
     * @return A result indicating the outcome of the delete operation. Returns status code 200 (OK) if the deletion is
                successful, 404 (Not Found) if the external identifier does not exist, 400 (Bad Request) for invalid input,
                403 (Forbidden) if the user is not authorized, or 401 (Unauthorized) if authentication fails.
     */
    deleteExternalId(command: DeletePatientExternalIdCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Patient/ExternalId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeleteExternalId(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the current user's recently-viewed patients (most-recent-first, capped at 20).
     * @return The user's recent patients across every pharmacy they currently have access to.
     */
    getRecentPatients(): Observable<RecentPatientResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Patient/Recent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentPatients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentPatients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentPatientResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentPatientResponse[]>;
        }));
    }

    protected processGetRecentPatients(response: HttpResponseBase): Observable<RecentPatientResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecentPatientResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Records that the current user viewed a patient, maintaining the per-user recent list.
    Invalidates the user's cached list; clients re-read via the Recent GET.
     * @param command The command containing the patient/pharmacy or the order context.
     * @return Success once the view is recorded.
     */
    recordRecentPatient(command: RecordRecentPatientCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Patient/Recent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecordRecentPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecordRecentPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processRecordRecentPatient(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PatientWorkflowLockClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves the current lock status of the specified patient workflow pharmacy resource without side effects.
     * @param patientId The patient ID.
     * @param workflowId The workflow ID.
     * @param resourceType The resource type identifier.
     * @return The current lock state including holder info and pending request details.
     */
    getStatus(patientId: number, workflowId: number, resourceType: string): Observable<GetPatientWorkflowLockQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/patient-workflow-lock/{patientId}/{workflowId}/{resourceType}";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (workflowId === undefined || workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPatientWorkflowLockQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPatientWorkflowLockQueryResponse>;
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<GetPatientWorkflowLockQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPatientWorkflowLockQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Releases the lock on the specified patient workflow resource held by the current user.
     * @param patientId The patient ID.
     * @param workflowId The workflow ID.
     * @param resourceType The resource type identifier.
     * @return A result indicating success or failure of the release operation.
     */
    release(patientId: number, workflowId: number, resourceType: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/patient-workflow-lock/{patientId}/{workflowId}/{resourceType}";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (workflowId === undefined || workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRelease(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Attempts to acquire a lock on the specified patient workflow resource for the current user.
    If not locked, acquires the lock. If already locked by the current user, renews it.
    If locked by another user, returns the current lock holder's information.
     * @param patientId The patient ID.
     * @param workflowId The workflow ID.
     * @param resourceType The resource type identifier.
     * @param body The request containing connection and device info.
     * @return Lock state including the holder info and whether a new lock was acquired.
     */
    tryAcquire(patientId: number, workflowId: number, resourceType: string, body: TryAcquirePatientWorkflowLockBody): Observable<TryAcquirePatientWorkflowLockCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/patient-workflow-lock/{patientId}/{workflowId}/{resourceType}/TryAcquire";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (workflowId === undefined || workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTryAcquire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTryAcquire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TryAcquirePatientWorkflowLockCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TryAcquirePatientWorkflowLockCommandResponse>;
        }));
    }

    protected processTryAcquire(response: HttpResponseBase): Observable<TryAcquirePatientWorkflowLockCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TryAcquirePatientWorkflowLockCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Requests the lock from the current holder of the specified patient workflow resource.
    The owner receives a SignalR notification and has a configurable timeout to respond.
     * @param patientId The patient ID.
     * @param workflowId The workflow ID.
     * @param resourceType The resource type identifier.
     * @param body The lock request containing the requester's connection ID.
     * @return The request expiry timestamp and timeout in seconds.
     */
    requestLock(patientId: number, workflowId: number, resourceType: string, body: PatientWorkflowLockConnectionIdBody): Observable<RequestPatientWorkflowLockCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/patient-workflow-lock/{patientId}/{workflowId}/{resourceType}/Request";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (workflowId === undefined || workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestLock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestLock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestPatientWorkflowLockCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestPatientWorkflowLockCommandResponse>;
        }));
    }

    protected processRequestLock(response: HttpResponseBase): Observable<RequestPatientWorkflowLockCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestPatientWorkflowLockCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancels a pending lock request made by the current user on the specified patient workflow resource.
     * @param patientId The patient ID.
     * @param workflowId The workflow ID.
     * @param resourceType The resource type identifier.
     * @return A result indicating success or failure of the cancellation.
     */
    cancelRequest(patientId: number, workflowId: number, resourceType: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/patient-workflow-lock/{patientId}/{workflowId}/{resourceType}/Request";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (workflowId === undefined || workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approves a pending lock request, transferring the lock to the requester.
    Only the current lock owner can approve.
     * @param patientId The patient ID.
     * @param workflowId The workflow ID.
     * @param resourceType The resource type identifier.
     * @return A result indicating success or failure of the approval.
     */
    approve(patientId: number, workflowId: number, resourceType: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/patient-workflow-lock/{patientId}/{workflowId}/{resourceType}/Request/Approve";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (workflowId === undefined || workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Declines a pending lock request on the specified patient workflow resource.
    Only the current lock owner can decline.
     * @param patientId The patient ID.
     * @param workflowId The workflow ID.
     * @param resourceType The resource type identifier.
     * @return A result indicating success or failure of the decline.
     */
    decline(patientId: number, workflowId: number, resourceType: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/patient-workflow-lock/{patientId}/{workflowId}/{resourceType}/Request/Decline";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (workflowId === undefined || workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDecline(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Forcefully steals the lock from the current holder after the request timeout expires.
    Only the user who made the pending request (or any user if no request exists) may steal.
     * @param patientId The patient ID.
     * @param workflowId The workflow ID.
     * @param resourceType The resource type identifier.
     * @param body The steal request containing the new holder's connection ID.
     * @return The new lock expiry timestamp.
     */
    steal(patientId: number, workflowId: number, resourceType: string, body: PatientWorkflowLockConnectionIdBody): Observable<StealPatientWorkflowLockCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/patient-workflow-lock/{patientId}/{workflowId}/{resourceType}/Steal";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (workflowId === undefined || workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSteal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSteal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StealPatientWorkflowLockCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StealPatientWorkflowLockCommandResponse>;
        }));
    }

    protected processSteal(response: HttpResponseBase): Observable<StealPatientWorkflowLockCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StealPatientWorkflowLockCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PharmacyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves a list of pharmacy select items for use in dropdowns or selection controls.
     * @return Returns the list of pharmacy select items.
     */
    getPharmacySelectList(): Observable<GetPharmacySelectListQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/GetSelectList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPharmacySelectList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPharmacySelectList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPharmacySelectListQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPharmacySelectListQueryResponse[]>;
        }));
    }

    protected processGetPharmacySelectList(response: HttpResponseBase): Observable<GetPharmacySelectListQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPharmacySelectListQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid or improperly formed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access. User is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden. User does not have the necessary permissions.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of pharmacies.
     * @return A list of pharmacies in a successful response or an error response.
     */
    get(): Observable<GetPharmacyQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPharmacyQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPharmacyQueryResponse[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetPharmacyQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPharmacyQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the details of a pharmacy.
     * @param command The command containing the pharmacy details to update.
     * @return The details of the pharmacy or an error response.
     */
    update(command: UpdatePharmacyCommand): Observable<UpdatePharmacyResponse> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePharmacyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePharmacyResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdatePharmacyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdatePharmacyResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the details of a pharmacy by its identifier.
     * @param id The unique identifier of the pharmacy to retrieve.
     * @return The details of the pharmacy or an error response.
     */
    getById(id: number): Observable<GetPharmacyQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPharmacyQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPharmacyQueryResponse>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetPharmacyQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPharmacyQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the users of a pharmacy by its identifier and optional user role.
     * @param id The unique identifier of the pharmacy for which users will be retrieved.
     * @param userRole (optional) The role of the pharmacy users to retrieve.
     * @return Operation completed successfully.
     */
    getAssociatedUsers(id: number, userRole?: string | null | undefined): Observable<GetPharmacyAssociatedUsersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/{id}/AssociatedUsers?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userRole !== undefined && userRole !== null)
            url_ += "userRole=" + encodeURIComponent("" + userRole) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssociatedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssociatedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPharmacyAssociatedUsersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPharmacyAssociatedUsersQueryResponse[]>;
        }));
    }

    protected processGetAssociatedUsers(response: HttpResponseBase): Observable<GetPharmacyAssociatedUsersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPharmacyAssociatedUsersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Associates users with a pharmacy.
     * @param command Command containing pharmacy ID and user list.
     * @return Operation completed successfully.
     */
    associateUsers(command: AssociateUserToPharmacyCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/AssociateUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processAssociateUsers(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes the association between a user and a pharmacy.
     * @param command The command containing the user and pharmacy association details to remove.
     * @return Returns success when the user is successfully unassociated from the pharmacy.
     */
    unassociateUser(command: UnassociatePharmacyUserCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/UnassociateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassociateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassociateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUnassociateUser(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid or improperly formed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access. User is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden. User does not have the necessary permissions.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the couriers of a pharmacy by its identifier.
     * @param id The unique identifier of the pharmacy for which couriers will be retrieved.
     * @return List of pharmacy couriers or an error response.
     */
    getCouriers(id: number): Observable<GetPharmacyCouriersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/{id}/Couriers";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCouriers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCouriers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPharmacyCouriersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPharmacyCouriersQueryResponse[]>;
        }));
    }

    protected processGetCouriers(response: HttpResponseBase): Observable<GetPharmacyCouriersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPharmacyCouriersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new courier for a pharmacy.
     * @param command The command containing the pharmacy courier details to create.
     * @return The details of the created pharmacy courier or an error response.
     */
    createPharmacyCourier(command: CreatePharmacyCourierCommand): Observable<CreatePharmacyCourierCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/Couriers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePharmacyCourier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePharmacyCourier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePharmacyCourierCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePharmacyCourierCommandResponse>;
        }));
    }

    protected processCreatePharmacyCourier(response: HttpResponseBase): Observable<CreatePharmacyCourierCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePharmacyCourierCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a pharmacy courier by its identifier.
     * @param id The unique identifier of the pharmacy courier to delete.
     * @return A success result or an error response.
     */
    deletePharmacyCourier(id: number): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/Couriers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePharmacyCourier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePharmacyCourier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeletePharmacyCourier(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the daily capacity of a pharmacy based on its identifier and specified capacity types.
     * @param id The unique identifier of the pharmacy.
     * @param dailyCapacityTypes (optional) A list of daily capacity types to filter the results.
     * @return A list of daily capacity records or an error response.
     */
    getDailyCapacity(id: number, dailyCapacityTypes?: string[] | undefined): Observable<GetPharmacyDailyCapacityQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/{id}/DailyCapacity?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dailyCapacityTypes === null)
            throw new globalThis.Error("The parameter 'dailyCapacityTypes' cannot be null.");
        else if (dailyCapacityTypes !== undefined)
            dailyCapacityTypes && dailyCapacityTypes.forEach(item => { url_ += "DailyCapacityTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyCapacity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyCapacity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPharmacyDailyCapacityQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPharmacyDailyCapacityQueryResponse[]>;
        }));
    }

    protected processGetDailyCapacity(response: HttpResponseBase): Observable<GetPharmacyDailyCapacityQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPharmacyDailyCapacityQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new daily capacity record for a pharmacy.
     * @param command The command containing the details of the daily capacity to create.
     * @return The details of the created daily capacity or an error response.
     */
    createDailyCapacity(command: CreatePharmacyDailyCapacityCommand): Observable<CreatePharmacyDailyCapacityCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/DailyCapacity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDailyCapacity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDailyCapacity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePharmacyDailyCapacityCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePharmacyDailyCapacityCommandResponse>;
        }));
    }

    protected processCreateDailyCapacity(response: HttpResponseBase): Observable<CreatePharmacyDailyCapacityCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePharmacyDailyCapacityCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the daily capacity of a pharmacy.
     * @param command The command containing the details of the daily capacity to update.
     * @return The details of the updated daily capacity or an error response.
     */
    updateDailyCapacity(command: UpdatePharmacyDailyCapacityCommand): Observable<UpdatePharmacyDailyCapacityCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/DailyCapacity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDailyCapacity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDailyCapacity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePharmacyDailyCapacityCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePharmacyDailyCapacityCommandResponse>;
        }));
    }

    protected processUpdateDailyCapacity(response: HttpResponseBase): Observable<UpdatePharmacyDailyCapacityCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdatePharmacyDailyCapacityCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the address book entries associated with a specific pharmacy.
     * @param id The unique identifier of the pharmacy for which address book entries will be retrieved.
     * @param type (optional) The type of address book entries that will be retrieved.
     * @return A list of address book entries associated with the pharmacy or an error response.
     */
    getAddressBook(id: number, type?: string | null | undefined): Observable<GetPharmacyAddressBookQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/{id}/AddressBook?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressBook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPharmacyAddressBookQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPharmacyAddressBookQueryResponse[]>;
        }));
    }

    protected processGetAddressBook(response: HttpResponseBase): Observable<GetPharmacyAddressBookQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPharmacyAddressBookQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new address book entry for a pharmacy.
     * @param command The command containing the address book details to create.
     * @return The details of the created address book entry or an error response.
     */
    createAddressBook(command: CreatePharmacyAddressBookCommand): Observable<CreatePharmacyAddressBookCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/AddressBook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAddressBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAddressBook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePharmacyAddressBookCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePharmacyAddressBookCommandResponse>;
        }));
    }

    protected processCreateAddressBook(response: HttpResponseBase): Observable<CreatePharmacyAddressBookCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePharmacyAddressBookCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing address book entry for a pharmacy.
     * @param command The command containing the address book details to update.
     * @return The details of the updated address book entry or an error response.
     */
    updateAddressBook(command: UpdatePharmacyAddressBookCommand): Observable<UpdatePharmacyAddressBookCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/AddressBook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAddressBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAddressBook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePharmacyAddressBookCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePharmacyAddressBookCommandResponse>;
        }));
    }

    protected processUpdateAddressBook(response: HttpResponseBase): Observable<UpdatePharmacyAddressBookCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdatePharmacyAddressBookCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an address book entry for a pharmacy.
     * @param command The command containing the address book entry details to delete.
     * @return A success result or an error response.
     */
    deleteAddressBook(command: DeletePharmacyAddressBookCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/AddressBook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAddressBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAddressBook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeleteAddressBook(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the count of shipment items by date range for a specific shipment.
     * @param id The unique identifier of the shipment.
     * @param startDate (optional) The start date of the range.
     * @param endDate (optional) The end date of the range.
     * @param drugStoragType (optional) The storage type of the drug (optional).
     * @return A collection of item counts grouped by date for the specified shipment and date range.
     */
    getShipmentCountByDateRange(id: number, startDate?: DateTime | undefined, endDate?: DateTime | undefined, drugStoragType?: string | null | undefined): Observable<ItemCountByDateDto[]> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/{id}/Shipment/Count?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (drugStoragType !== undefined && drugStoragType !== null)
            url_ += "drugStoragType=" + encodeURIComponent("" + drugStoragType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipmentCountByDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipmentCountByDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemCountByDateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemCountByDateDto[]>;
        }));
    }

    protected processGetShipmentCountByDateRange(response: HttpResponseBase): Observable<ItemCountByDateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ItemCountByDateDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the Nexus integration settings for a pharmacy.
     * @param command The command containing the Nexus integration details to update.
     * @return The Nexus integration settings were successfully updated.
     */
    updateNexusIntegration(command: UpdatePharmacyNexusIntegrationCommand): Observable<UpdatePharmacyNexusIntegrationCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/NexusIntegration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNexusIntegration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNexusIntegration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePharmacyNexusIntegrationCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePharmacyNexusIntegrationCommandResponse>;
        }));
    }

    protected processUpdateNexusIntegration(response: HttpResponseBase): Observable<UpdatePharmacyNexusIntegrationCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdatePharmacyNexusIntegrationCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid or improperly formed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden. User does not have the necessary permissions.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the Nexus connection setting for a pharmacy.
     * @param command The command containing the Nexus connection setting to update.
     * @return The Nexus connection setting was successfully updated.
     */
    updateNexusConnection(command: UpdatePharmacyNexusConnectionCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/NexusConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNexusConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNexusConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateNexusConnection(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid or improperly formed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access. User is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden. User does not have the necessary permissions.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Tests the Nexus connection for a pharmacy.
     * @param pharmacyId The unique identifier of the pharmacy.
     * @return Returns a success message if the connection test passed, or a failure message with the reason.
     */
    testNexusConnection(pharmacyId: number): Observable<TestPharmacyNexusConnectionQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Pharmacy/{pharmacyId}/TestNexusConnection";
        if (pharmacyId === undefined || pharmacyId === null)
            throw new globalThis.Error("The parameter 'pharmacyId' must be defined.");
        url_ = url_.replace("{pharmacyId}", encodeURIComponent("" + pharmacyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestNexusConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestNexusConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TestPharmacyNexusConnectionQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TestPharmacyNexusConnectionQueryResponse>;
        }));
    }

    protected processTestNexusConnection(response: HttpResponseBase): Observable<TestPharmacyNexusConnectionQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TestPharmacyNexusConnectionQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid or improperly formed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access. User is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden. User does not have the necessary permissions.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Pharmacy not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SentrexDriverScheduleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a new Sentrex driver schedule with the specified availability and capacity.
     * @param command The command containing the driver schedule details to be created.
     * @return Returns CreateSentrexDriverScheduleCommandResponse on success, or an error response on failure.
     */
    createSentrexDriverSchedule(command: CreateSentrexDriverScheduleCommand): Observable<CreateSentrexDriverScheduleCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/SentrexDriverSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSentrexDriverSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSentrexDriverSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSentrexDriverScheduleCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSentrexDriverScheduleCommandResponse>;
        }));
    }

    protected processCreateSentrexDriverSchedule(response: HttpResponseBase): Observable<CreateSentrexDriverScheduleCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateSentrexDriverScheduleCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing Sentrex driver schedule with the provided details.
     * @param command The command containing the updated driver schedule details.
     * @return Returns a Result indicating the success or failure of the update operation.
     */
    updateSentrexDriverSchedule(command: UpdateSentrexDriverScheduleCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/SentrexDriverSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSentrexDriverSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSentrexDriverSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateSentrexDriverSchedule(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all Sentrex driver schedules for a specific route.
     * @param routeId (optional) The unique identifier of the route to retrieve schedules for.
     * @return Returns a list of GetSentrexDriverSchedulesQueryResponse objects containing the driver schedules for the specified route, or an error response on failure.
     */
    sentrexDriverSchedules(routeId?: number | undefined): Observable<GetSentrexDriverSchedulesQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/SentrexDriverSchedule?";
        if (routeId === null)
            throw new globalThis.Error("The parameter 'routeId' cannot be null.");
        else if (routeId !== undefined)
            url_ += "routeId=" + encodeURIComponent("" + routeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSentrexDriverSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSentrexDriverSchedules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSentrexDriverSchedulesQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSentrexDriverSchedulesQueryResponse[]>;
        }));
    }

    protected processSentrexDriverSchedules(response: HttpResponseBase): Observable<GetSentrexDriverSchedulesQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSentrexDriverSchedulesQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an existing Sentrex driver schedule.
     * @param command The command containing the ID of the driver schedule to delete.
     * @return Returns a Result indicating the success or failure of the delete operation.
     */
    deleteSentrexDriverSchedule(command: DeleteSentrexDriverScheduleCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/SentrexDriverSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSentrexDriverSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSentrexDriverSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeleteSentrexDriverSchedule(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the availability of Sentrex drivers for a given postal code.
     * @param postalCode (optional) The postal code to check driver availability for.
     * @param expectedDeliveryDate (optional) The expected delivery date to check driver availability for.
     * @return Returns a GetSentrexDriverAvailabilityQueryResponse containing driver availability information, or an error response on failure.
     */
    getSentrexDriverAvailability(postalCode?: string | undefined, expectedDeliveryDate?: DateTime | undefined): Observable<GetSentrexDriverAvailabilityQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/SentrexDriverSchedule/Availability?";
        if (postalCode === null)
            throw new globalThis.Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        if (expectedDeliveryDate === null)
            throw new globalThis.Error("The parameter 'expectedDeliveryDate' cannot be null.");
        else if (expectedDeliveryDate !== undefined)
            url_ += "expectedDeliveryDate=" + encodeURIComponent(expectedDeliveryDate ? "" + expectedDeliveryDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSentrexDriverAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSentrexDriverAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSentrexDriverAvailabilityQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSentrexDriverAvailabilityQueryResponse>;
        }));
    }

    protected processGetSentrexDriverAvailability(response: HttpResponseBase): Observable<GetSentrexDriverAvailabilityQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSentrexDriverAvailabilityQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all Sentrex driver route schedules.
     * @return Returns a list of GetSentrexDriverRouteQueryResponse objects representing the driver route schedules, or an error response on failure.
     */
    getSentrexDriverRoutes(): Observable<GetSentrexDriverRouteQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/SentrexDriverSchedule/Routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSentrexDriverRoutes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSentrexDriverRoutes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSentrexDriverRouteQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSentrexDriverRouteQueryResponse[]>;
        }));
    }

    protected processGetSentrexDriverRoutes(response: HttpResponseBase): Observable<GetSentrexDriverRouteQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSentrexDriverRouteQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new Sentrex driver route for scheduling and managing driver delivery routes.
     * @param command The command containing the driver route details to be created.
     * @return Returns CreateSentrexDriverRouteCommandResponse on success, or an error response on failure.
     */
    createSentrexDriverRoute(command: CreateSentrexDriverRouteCommand): Observable<CreateSentrexDriverRouteCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/SentrexDriverSchedule/Routes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSentrexDriverRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSentrexDriverRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSentrexDriverRouteCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSentrexDriverRouteCommandResponse>;
        }));
    }

    protected processCreateSentrexDriverRoute(response: HttpResponseBase): Observable<CreateSentrexDriverRouteCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateSentrexDriverRouteCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing Sentrex driver route with the provided details.
     * @param command The command containing the updated driver route details.
     * @return Returns a Result indicating the success or failure of the update operation.
     */
    updateSentrexDriverRoute(command: UpdateSentrexDriverRouteCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/SentrexDriverSchedule/Routes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSentrexDriverRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSentrexDriverRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateSentrexDriverRoute(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an existing Sentrex driver route.
     * @param command The command containing the ID of the driver route to delete.
     * @return Returns a Result indicating the success or failure of the delete operation.
     */
    deleteSentrexDriverRoute(command: DeleteSentrexDriverRouteCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/SentrexDriverSchedule/Routes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSentrexDriverRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSentrexDriverRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeleteSentrexDriverRoute(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ShipmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a new shipment.
     * @param command The command containing shipment details.
     * @return An IActionResult representing the result of the operation.
     */
    createShipment(command: CreateShipmentCommand): Observable<CreateShipmentCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Shipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateShipmentCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateShipmentCommandResponse>;
        }));
    }

    protected processCreateShipment(response: HttpResponseBase): Observable<CreateShipmentCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateShipmentCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing shipment.
     * @param command The command containing updated shipment details.
     * @return An IActionResult representing the result of the operation.
     */
    updateShipment(command: UpdateShipmentCommand): Observable<UpdateShipmentCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Shipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateShipmentCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateShipmentCommandResponse>;
        }));
    }

    protected processUpdateShipment(response: HttpResponseBase): Observable<UpdateShipmentCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateShipmentCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes one or more shipments.
     * @param command The command containing the IDs of the shipments to delete.
     * @return An IActionResult representing the result of the operation.
     */
    deleteShipments(command: DeleteShipmentsCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Shipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShipments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeleteShipments(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new shipment track number.
     * @param command The command containing track number details.
     * @return An IActionResult representing the result of the operation.
     */
    createShipmentTrackNumber(command: CreateShipmentTrackNumberCommand): Observable<CreateShipmentTrackNumberCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Shipment/TrackNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShipmentTrackNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShipmentTrackNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateShipmentTrackNumberCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateShipmentTrackNumberCommandResponse>;
        }));
    }

    protected processCreateShipmentTrackNumber(response: HttpResponseBase): Observable<CreateShipmentTrackNumberCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateShipmentTrackNumberCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all track numbers associated with a specific shipment.
     * @param id The unique identifier of the shipment.
     * @return A list of track numbers for the specified shipment.
     */
    getTrackNumbers(id: number): Observable<GetShipmentTrackNumbersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Shipment/{id}/TrackNumbers";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrackNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrackNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShipmentTrackNumbersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShipmentTrackNumbersQueryResponse[]>;
        }));
    }

    protected processGetTrackNumbers(response: HttpResponseBase): Observable<GetShipmentTrackNumbersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetShipmentTrackNumbersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes one or more shipment track numbers.
     * @param command The command containing the IDs of the track numbers to delete.
     * @return An IActionResult representing the result of the operation.
     */
    deleteTrackNumbers(command: DeleteShipmentTrackNumbersCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Shipment/TrackNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTrackNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTrackNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeleteTrackNumbers(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates one or more shipments' expected delivery date, and sets the actual delivery date to the expected delivery date.
    Updates one or more shipments' tracking number(s).
     * @param command The command containing the shipment IDs, expected delivery dates and tracking number(s).
     * @return A result indicating success or failure of the operation.
     */
    updateShipmentsDeliveryDatesTrackingNumbers(command: UpdateShipmentsDeliveryDatesTrackingNumbersCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Shipment/UpdateShipmentsDeliveryDatesTrackingNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShipmentsDeliveryDatesTrackingNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShipmentsDeliveryDatesTrackingNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateShipmentsDeliveryDatesTrackingNumbers(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates one or more shipments' tracking number(s).
     * @param command The command containing the shipment IDs and tracking number(s).
     * @return A result indicating success or failure of the operation.
     */
    updateShipmentsTrackingNumbers(command: UpdateShipmentTrackNumbersCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Shipment/UpdateShipmentsTrackingNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShipmentsTrackingNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShipmentsTrackingNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateShipmentsTrackingNumbers(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the group shipments for the user's current pharmacy.
     * @param groupShipmentStatuses (optional) The statuses of the group shipments to retrieve.
     * @return An IActionResult representing a list of group shipments.
     */
    getGroupShipments(groupShipmentStatuses?: string[] | undefined): Observable<GetGroupShipmentsQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Shipment/GroupShipments?";
        if (groupShipmentStatuses === null)
            throw new globalThis.Error("The parameter 'groupShipmentStatuses' cannot be null.");
        else if (groupShipmentStatuses !== undefined)
            groupShipmentStatuses && groupShipmentStatuses.forEach(item => { url_ += "groupShipmentStatuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupShipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupShipments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGroupShipmentsQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGroupShipmentsQueryResponse[]>;
        }));
    }

    protected processGetGroupShipments(response: HttpResponseBase): Observable<GetGroupShipmentsQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetGroupShipmentsQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Finds existing group shipments that the order being scheduled could be added to — same
    delivery address, same expected delivery date, same courier, unlocked, and still open to orders.
     * @param query The candidate address, expected delivery date, and courier to match on.
     * @return The matching group shipments, or an empty collection when there are none.
     */
    getMatchingGroupShipments(query: GetMatchingGroupShipmentsQuery): Observable<GetMatchingGroupShipmentsQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Shipment/GroupShipments/Matching";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchingGroupShipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchingGroupShipments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMatchingGroupShipmentsQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMatchingGroupShipmentsQueryResponse[]>;
        }));
    }

    protected processGetMatchingGroupShipments(response: HttpResponseBase): Observable<GetMatchingGroupShipmentsQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetMatchingGroupShipmentsQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds an order to an existing group shipment: the order adopts the group's shipment legs,
    gives up its own, and is typed as a group delivery.
     * @param command The order and the group shipment to join.
     * @return The order-shipment links created for the group's legs.
     */
    joinGroupShipment(command: JoinGroupShipmentCommand): Observable<JoinGroupShipmentCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Shipment/GroupShipments/Join";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJoinGroupShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJoinGroupShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JoinGroupShipmentCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JoinGroupShipmentCommandResponse>;
        }));
    }

    protected processJoinGroupShipment(response: HttpResponseBase): Observable<JoinGroupShipmentCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JoinGroupShipmentCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the orders for a group shipment.
     * @param id The unique identifier of the group shipment.
     * @param ignoreResolvedOrders (optional) When true, leaves out orders whose delivery issue has already been resolved.
     * @return The orders linked to the specified group shipment.
     */
    getGroupShipmentOrders(id: number, ignoreResolvedOrders?: boolean | undefined): Observable<GetOrdersByGroupShipmentIdQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Shipment/{id}/Orders?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (ignoreResolvedOrders === null)
            throw new globalThis.Error("The parameter 'ignoreResolvedOrders' cannot be null.");
        else if (ignoreResolvedOrders !== undefined)
            url_ += "ignoreResolvedOrders=" + encodeURIComponent("" + ignoreResolvedOrders) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupShipmentOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupShipmentOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrdersByGroupShipmentIdQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrdersByGroupShipmentIdQueryResponse[]>;
        }));
    }

    protected processGetGroupShipmentOrders(response: HttpResponseBase): Observable<GetOrdersByGroupShipmentIdQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrdersByGroupShipmentIdQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new group shipment.
     * @param command The command containing group shipment details.
     * @return An IActionResult representing the result of the operation.
     */
    createGroupShipment(command: CreateGroupShipmentCommand): Observable<CreateGroupShipmentCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Shipment/GroupShipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGroupShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGroupShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateGroupShipmentCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateGroupShipmentCommandResponse>;
        }));
    }

    protected processCreateGroupShipment(response: HttpResponseBase): Observable<CreateGroupShipmentCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateGroupShipmentCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a group shipment.
     * @param command The command containing updated group shipment details.
     * @return An IActionResult representing the result of the operation.
     */
    updateGroupShipment(command: UpdateGroupShipmentCommand): Observable<UpdateGroupShipmentCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Shipment/GroupShipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGroupShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGroupShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateGroupShipmentCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateGroupShipmentCommandResponse>;
        }));
    }

    protected processUpdateGroupShipment(response: HttpResponseBase): Observable<UpdateGroupShipmentCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateGroupShipmentCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a group shipment by its unique identifier.
     * @param id The unique identifier of the group shipment.
     * @return The group shipment details for the specified ID.
     */
    getGroupShipmentById(id: number): Observable<GetGroupShipmentByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Shipment/GroupShipment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupShipmentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupShipmentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGroupShipmentByIdQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGroupShipmentByIdQueryResponse>;
        }));
    }

    protected processGetGroupShipmentById(response: HttpResponseBase): Observable<GetGroupShipmentByIdQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetGroupShipmentByIdQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the group shipment with the specified identifier.
     * @param id The unique identifier of the group shipment to delete.
     * @return An IActionResult indicating the result of the delete operation. Returns status code 200 if the
                deletion is successful, 400 for a bad request, 401 if unauthorized, 403 if forbidden, or 500 for an internal
                server error.
     */
    deleteGroupShipment(id: number): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Shipment/GroupShipment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteGroupShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGroupShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeleteGroupShipment(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Toggles the lock status of a group shipment.
     * @param command The command containing the group shipment ID and the desired lock status.
     * @return An IActionResult representing the result of the operation.
     */
    toggleLockGroupShipment(command: ToggleLockGroupShipmentCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Shipment/ToggleLockGroupShipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleLockGroupShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleLockGroupShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processToggleLockGroupShipment(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verifies a group shipment by updating its status to "Group Verified."
     * @param command The command containing the group shipment ID to verify.
     * @return An IActionResult representing the result of the operation.
     */
    verifyGroupShipment(command: VerifyGroupShipmentCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Shipment/VerifyGroupShipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyGroupShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyGroupShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processVerifyGroupShipment(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reports a delivery issue for a group shipment.
     * @param command The command containing details about the delivery issue to report.
     * @return An IActionResult representing the result of the operation.
     */
    reportGroupShipmentDeliveryIssue(command: ReportGroupShipmentDeliveryIssueCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Shipment/ReportGroupShipmentDeliveryIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportGroupShipmentDeliveryIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportGroupShipmentDeliveryIssue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processReportGroupShipmentDeliveryIssue(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Raises an issue for a group shipment.
     * @param command The command containing details about the group shipment issue to raise.
     * @return An IActionResult representing the result of the operation.
     */
    raiseGroupShipmentIssue(command: RaiseGroupShipmentIssueCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Shipment/RaiseGroupShipmentIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRaiseGroupShipmentIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRaiseGroupShipmentIssue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processRaiseGroupShipmentIssue(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reschedules the orders associated with a group shipment.
     * @param command The command containing the order IDs to reschedule.
     * @return An IActionResult representing the result of the operation.
     */
    rescheduleGroupShipment(command: RescheduleGroupShipmentCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Shipment/RescheduleGroupShipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRescheduleGroupShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRescheduleGroupShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processRescheduleGroupShipment(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Marks a group shipment as delivered by updating its status to "Delivered" if all associated orders are delivered.
     * @param command The command containing the group shipment ID to mark as delivered.
     * @return An IActionResult representing the result of the operation.
     */
    deliverGroupShipment(command: DeliverGroupShipmentCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Shipment/DeliveryGroupShipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliverGroupShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliverGroupShipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeliverGroupShipment(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the status of one or more orders within a group shipment.
     * @param command The command containing the order IDs and the new status to apply.
     * @return An IActionResult representing the result of the operation.
     */
    updateGroupShipmentStatus(command: UpdateGroupShipmentStatusCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Shipment/UpdateGroupShipmentStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGroupShipmentStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGroupShipmentStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateGroupShipmentStatus(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the status of a specific group shipment.
     * @param id The unique identifier of the group shipment.
     * @return The status details of the specified group shipment.
     */
    getGroupShipmentStatus(id: number): Observable<GetGroupShipmentStatusQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Shipment/GroupShipment/{id}/Status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupShipmentStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupShipmentStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGroupShipmentStatusQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGroupShipmentStatusQueryResponse>;
        }));
    }

    protected processGetGroupShipmentStatus(response: HttpResponseBase): Observable<GetGroupShipmentStatusQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetGroupShipmentStatusQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves a filtered list of system users.
     * @param query (optional) Filter criteria for the user search.
     * @return Operation completed successfully.
     */
    get(query?: GetUsersQuery | undefined): Observable<GetUsersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Users?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUsersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUsersQueryResponse[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetUsersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetUsersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing user.
     * @param command The user details to update.
     * @return Operation completed successfully.
     */
    update(command: UpdateUserCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new system user. If a Sentrex tenant user ID is provided, SSO access is enabled.
     * @param command The user creation details.
     * @return Operation completed successfully.
     */
    create(command: CreateUserCommand): Observable<CreateUserCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateUserCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateUserCommandResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateUserCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateUserCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves user details by ID.
     * @param id The unique identifier of the user.
     * @return Operation completed successfully.
     */
    getById(id: number): Observable<GetUserByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserByIdQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserByIdQueryResponse>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetUserByIdQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetUserByIdQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a user by ID.
     * @param id The Id of the user that will be deleted.
     * @return Operation completed successfully.
     */
    delete(id: number): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Searches Sentrex Azure Active Directory users by email.
     * @param emailTerm (optional) The email search term
     * @param enabledAccountOnly (optional) Whether to return only enabled accounts
     * @param checkUsers (optional) Whether to check if users exist in the system
     * @return Operation completed successfully.
     */
    getSentrexUsers(emailTerm?: string | undefined, enabledAccountOnly?: boolean | undefined, checkUsers?: boolean | undefined): Observable<GetADUserResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Users/GetSentrexUsers?";
        if (emailTerm === null)
            throw new globalThis.Error("The parameter 'emailTerm' cannot be null.");
        else if (emailTerm !== undefined)
            url_ += "EmailTerm=" + encodeURIComponent("" + emailTerm) + "&";
        if (enabledAccountOnly === null)
            throw new globalThis.Error("The parameter 'enabledAccountOnly' cannot be null.");
        else if (enabledAccountOnly !== undefined)
            url_ += "EnabledAccountOnly=" + encodeURIComponent("" + enabledAccountOnly) + "&";
        if (checkUsers === null)
            throw new globalThis.Error("The parameter 'checkUsers' cannot be null.");
        else if (checkUsers !== undefined)
            url_ += "CheckUsers=" + encodeURIComponent("" + checkUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSentrexUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSentrexUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetADUserResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetADUserResponse[]>;
        }));
    }

    protected processGetSentrexUsers(response: HttpResponseBase): Observable<GetADUserResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetADUserResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of users who can be assigned to entities within the system.
     * @param query (optional) The query parameters to filter assignable users.
     * @return Returns the list of assignable users.
     */
    getAssignableUsers(query?: GetAssignableUsersQuery | undefined): Observable<GetAssignableUsersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Users/AssignableUsers?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignableUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignableUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAssignableUsersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAssignableUsersQueryResponse[]>;
        }));
    }

    protected processGetAssignableUsers(response: HttpResponseBase): Observable<GetAssignableUsersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAssignableUsersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkflowClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves a list of workflows.
     * @return A list of workflows in a successful response or an error response.
     */
    get(): Observable<GetWorkflowQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Workflow";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWorkflowQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWorkflowQueryResponse[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetWorkflowQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWorkflowQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the details of a workflow.
     * @param command The command containing the workflow details to update.
     * @return The details of the workflow or an error response.
     */
    update(command: UpdateWorkflowCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Workflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a workflow.
     * @param command The command containing the workflow details to create.
     * @return The details of the workflow or an error response.
     */
    create(command: CreateWorkflowCommand): Observable<CreateWorkflowResponse> {
        let url_ = this.baseUrl + "/api/v1/Workflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWorkflowResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWorkflowResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateWorkflowResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateWorkflowResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the details of a workflow by its identifier.
     * @param id The unique identifier of the workflow to retrieve.
     * @return The details of the workflow or an error response.
     */
    getById(id: number): Observable<GetWorkflowQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/Workflow/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWorkflowQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWorkflowQueryResponse>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetWorkflowQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWorkflowQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the client api keys of a workflow by its identifier.
     * @param id The unique identifier of the workflow for which client api keys will be retrieved.
     * @return List of workflow client api keys or an error response.
     */
    getApiKeys(id: number): Observable<GetWorkflowApiKeysQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Workflow/{id}/api-keys";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApiKeys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApiKeys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWorkflowApiKeysQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWorkflowApiKeysQueryResponse[]>;
        }));
    }

    protected processGetApiKeys(response: HttpResponseBase): Observable<GetWorkflowApiKeysQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWorkflowApiKeysQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new client api key for a workflow.
     * @param command The command containing the workflow api key details to create.
     * @return The details of the created workflow api key or an error response.
     */
    createWorkflowApiKey(command: CreateWorkflowApiKeyCommand): Observable<CreateWorkflowApiKeyCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Workflow/api-key";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkflowApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkflowApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWorkflowApiKeyCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWorkflowApiKeyCommandResponse>;
        }));
    }

    protected processCreateWorkflowApiKey(response: HttpResponseBase): Observable<CreateWorkflowApiKeyCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateWorkflowApiKeyCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the details of a client api key for a workflow.
     * @param command The command containing the workflow api key details to update.
     * @return The details of the workflow api key or an error response.
     */
    updateWorkflowApiKey(command: UpdateWorkflowApiKeyCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Workflow/api-key";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkflowApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkflowApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateWorkflowApiKey(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the pharmacies of a workflow by its identifier.
     * @param id The unique identifier of the workflow for which pharmacies will be retrieved.
     * @return List of workflow pharmacies or an error response.
     */
    getPharmacies(id: number): Observable<GetWorkflowPharmaciesQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Workflow/{id}/pharmacies";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPharmacies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPharmacies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWorkflowPharmaciesQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWorkflowPharmaciesQueryResponse[]>;
        }));
    }

    protected processGetPharmacies(response: HttpResponseBase): Observable<GetWorkflowPharmaciesQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWorkflowPharmaciesQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new pharmacy for a workflow.
     * @param command The command containing the workflow pharmacy details to create.
     * @return The details of the created workflow pharmacy or an error response.
     */
    createWorkflowPharmacy(command: CreateWorkflowPharmacyCommand): Observable<CreateWorkflowPharmacyCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Workflow/pharmacy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkflowPharmacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkflowPharmacy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWorkflowPharmacyCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWorkflowPharmacyCommandResponse>;
        }));
    }

    protected processCreateWorkflowPharmacy(response: HttpResponseBase): Observable<CreateWorkflowPharmacyCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateWorkflowPharmacyCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a workflow pharmacy by its identifier.
     * @param id The unique identifier of the workflow pharmacy to delete.
     * @return A success result or an error response.
     */
    deleteWorkflowPharmacy(id: number): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Workflow/pharmacies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWorkflowPharmacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWorkflowPharmacy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeleteWorkflowPharmacy(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves drugs associated with a specific workflow.
     * @param id The unique identifier of the workflow.
     * @return A list of drugs associated with the workflow in a successful response or an error response.
     */
    getDrugs(id: number): Observable<GetWorkflowDrugsQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Workflow/{id}/drugs";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDrugs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDrugs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWorkflowDrugsQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWorkflowDrugsQueryResponse[]>;
        }));
    }

    protected processGetDrugs(response: HttpResponseBase): Observable<GetWorkflowDrugsQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWorkflowDrugsQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates associations between workflows and drugs.
     * @param command The command containing workflow and drug information to create.
     * @return A success result or an error response if the creation fails.
     */
    createDrugs(command: CreateWorkflowDrugsCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Workflow/drugs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDrugs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDrugs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCreateDrugs(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a workflow drug by its unique identifier.
     * @param id The unique identifier of the drug to delete.
     * @return A success result or an error response if the deletion fails.
     */
    deleteDrug(id: number): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Workflow/drugs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDrug(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDrug(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeleteDrug(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the dispense types for a specific workflow drug.
     * @param id The unique identifier of the workflow drug.
     * @return A collection of workflow drug dispense types if successful, or an error response.
     */
    getDispenseTypes(id: number): Observable<GetWorkflowDrugDispenseTypesQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Workflow/drugs/{id}/dispense-types";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDispenseTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDispenseTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWorkflowDrugDispenseTypesQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWorkflowDrugDispenseTypesQueryResponse[]>;
        }));
    }

    protected processGetDispenseTypes(response: HttpResponseBase): Observable<GetWorkflowDrugDispenseTypesQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWorkflowDrugDispenseTypesQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates new workflow drug dispense types based on the provided command.
     * @param command The command containing data to create workflow drug dispense types.
     * @return The identifier of the created workflow drug dispense type if successful, or an error response.
     */
    createDispenseType(command: CreateWorkflowDrugDispenseTypeCommand): Observable<CreateWorkflowDrugDispenseTypeCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/Workflow/drugs/dispense-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDispenseType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDispenseType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWorkflowDrugDispenseTypeCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWorkflowDrugDispenseTypeCommandResponse>;
        }));
    }

    protected processCreateDispenseType(response: HttpResponseBase): Observable<CreateWorkflowDrugDispenseTypeCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateWorkflowDrugDispenseTypeCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets the Commercialize flag on a workflow drug dispense type.
     * @param id The unique identifier of the workflow drug dispense type.
     * @param command The command carrying the new Commercialize value.
     * @return A 204 No Content response if successful, or an appropriate error response if the operation fails.
     */
    updateDispenseType(id: number, command: UpdateWorkflowDrugDispenseTypeCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Workflow/drugs/dispense-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDispenseType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDispenseType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateDispenseType(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a workflow drug dispense type by its identifier.
     * @param id The unique identifier of the workflow drug dispense type to delete.
     * @return A 204 No Content response if successful, or an appropriate error response if the operation fails.
     */
    deleteDispenseType(id: number): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/Workflow/drugs/dispense-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDispenseType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDispenseType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processDeleteDispenseType(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of workflow select items for use in dropdowns or selection controls.
     * @param pharmacyId (optional) Pharmacy Id
     * @param includeRetired (optional) Whether or not to include retired workflows
     * @param skipAllowPatientCreationCheck (optional) Whether or not to skip the check for allowing new patient creation
     * @return Returns the list of workflow select items.
     */
    getWorkflowSelectList(pharmacyId?: number | null | undefined, includeRetired?: boolean | null | undefined, skipAllowPatientCreationCheck?: boolean | null | undefined): Observable<GetWorkflowSelectListQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/Workflow/GetSelectList?";
        if (pharmacyId !== undefined && pharmacyId !== null)
            url_ += "pharmacyId=" + encodeURIComponent("" + pharmacyId) + "&";
        if (includeRetired !== undefined && includeRetired !== null)
            url_ += "includeRetired=" + encodeURIComponent("" + includeRetired) + "&";
        if (skipAllowPatientCreationCheck !== undefined && skipAllowPatientCreationCheck !== null)
            url_ += "skipAllowPatientCreationCheck=" + encodeURIComponent("" + skipAllowPatientCreationCheck) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkflowSelectList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkflowSelectList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWorkflowSelectListQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWorkflowSelectListQueryResponse[]>;
        }));
    }

    protected processGetWorkflowSelectList(response: HttpResponseBase): Observable<GetWorkflowSelectListQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWorkflowSelectListQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was invalid or improperly formed.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized access. User is not authenticated.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden. User does not have the necessary permissions.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DrugsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves the complete list of drugs available in the system.
     * @return Successfully retrieved the drug list. Returns an array of drug objects with Id and display name.
     */
    get(): Observable<GetDrugSelectListQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/integration/Drugs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDrugSelectListQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDrugSelectListQueryResponse[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetDrugSelectListQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDrugSelectListQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was malformed or invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Missing or invalid API key. Authentication is required for this endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden. The authenticated client does not have permission to access this resource.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class KrollIntegrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Associates a Kroll Patient ID with a Link patient.
     * @param request The Kroll patient data including patient ID, name, and address.
     * @param signature (optional) The webhook signature for request verification (X-Webhook-Signature header).
     * @param clientId (optional) The Nexus webhook client identifier (X-Webhook-ClientId header).
     * @return Kroll Patient ID successfully linked to the Link patient.
     */
    setKrollPatientId(request: NexusSetKrollPatientIdDto, signature?: string | undefined, clientId?: string | undefined): Observable<Result> {
        let url_ = this.baseUrl + "/api/v1/integration/KrollIntegration/SetKrollPatientId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "X-Webhook-Signature": signature !== undefined && signature !== null ? "" + signature : "",
                "X-Webhook-ClientId": clientId !== undefined && clientId !== null ? "" + clientId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetKrollPatientId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetKrollPatientId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processSetKrollPatientId(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Request body is invalid or missing required fields.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Missing or invalid webhook signature or client ID.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The client is not authorized to perform this operation.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Patient or pharmacy not found in the system.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderIntegrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a new patient order from an external source system.
     * @param patientOrder The full order payload including patient information, drugs, and shipping details.
     * @return Order created successfully. Returns the Link order ID and current status.
     */
    patientOrder(patientOrder: OrderIntegrationCommand): Observable<OrderIntegrationCommandResponse> {
        let url_ = this.baseUrl + "/api/v1/integration/OrderIntegration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientOrder);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatientOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatientOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderIntegrationCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderIntegrationCommandResponse>;
        }));
    }

    protected processPatientOrder(response: HttpResponseBase): Observable<OrderIntegrationCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderIntegrationCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Request body is invalid or missing required fields.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Missing or invalid API key.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The client is not authorized to create orders.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Referenced pharmacy or workflow not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the full details of an order by its Link order ID.
     * @param orderId The unique Link order identifier.
     * @return Returns the order details.
     */
    getOrderDetails(orderId: number): Observable<GetOrderDetailsQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/integration/OrderIntegration/OrderDetails?";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined and cannot be null.");
        else
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderDetailsQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderDetailsQueryResponse>;
        }));
    }

    protected processGetOrderDetails(response: HttpResponseBase): Observable<GetOrderDetailsQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderDetailsQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The order ID is invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Missing or invalid API key.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The client is not authorized to view this order.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Order not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all orders for a patient by their source system external identifier.
     * @param sourceSystemExternalId The unique external identifier from the source system (e.g., the Record GUID from 360).
     * @return Returns the list of patient orders.
     */
    getPatientOrders(sourceSystemExternalId: string): Observable<GetPatientOrdersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/integration/OrderIntegration/PatientOrders?";
        if (sourceSystemExternalId === undefined || sourceSystemExternalId === null)
            throw new globalThis.Error("The parameter 'sourceSystemExternalId' must be defined and cannot be null.");
        else
            url_ += "sourceSystemExternalId=" + encodeURIComponent("" + sourceSystemExternalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPatientOrdersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPatientOrdersQueryResponse[]>;
        }));
    }

    protected processGetPatientOrders(response: HttpResponseBase): Observable<GetPatientOrdersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPatientOrdersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The source system external ID is missing or invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Missing or invalid API key.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The client is not authorized to view these orders.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("No orders found for the given identifier.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves orders matching a list of order IDs.
     * @param request The filter criteria containing the list of order IDs to retrieve.
     * @return Returns the matching orders.
     */
    getMatchingOrdersByStatus(request: OrderFilterRequest): Observable<GetOrdersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/integration/OrderIntegration/Orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchingOrdersByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchingOrdersByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrdersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrdersQueryResponse[]>;
        }));
    }

    protected processGetMatchingOrdersByStatus(response: HttpResponseBase): Observable<GetOrdersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrdersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The filter criteria are invalid or empty.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Missing or invalid API key.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The client is not authorized to view these orders.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("No orders found matching the criteria.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delivers a list of orders by their Link order IDs.
     * @param orderIds The list of Link order IDs to deliver.
     * @return Returns per-order delivery results.
     */
    deliverOrders(orderIds: number[]): Observable<DeliverOrdersQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/integration/OrderIntegration/DeliverOrders?";
        if (orderIds === undefined || orderIds === null)
            throw new globalThis.Error("The parameter 'orderIds' must be defined and cannot be null.");
        else
            orderIds && orderIds.forEach(item => { url_ += "orderIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeliverOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeliverOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliverOrdersQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliverOrdersQueryResponse[]>;
        }));
    }

    protected processDeliverOrders(response: HttpResponseBase): Observable<DeliverOrdersQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeliverOrdersQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The order ID list is invalid or empty.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Missing or invalid API key.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The client is not authorized to deliver these orders.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves dispense information for specified order items.
     * @param request The filter request containing a list of order item IDs to retrieve dispense information for.
     * @return Returns the dispense information.
     */
    dispense(request: DispenseDetailsFilterRequest): Observable<GetOrderDispenseQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/integration/OrderIntegration/Dispense";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDispense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDispense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderDispenseQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderDispenseQueryResponse[]>;
        }));
    }

    protected processDispense(response: HttpResponseBase): Observable<GetOrderDispenseQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOrderDispenseQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request is invalid or order item IDs are missing.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Missing or invalid API key.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The client is not authorized to view this dispense information.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("One or more order items not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of dispense IDs based on the provided filter criteria.
     * @param orderItemIds (optional) Gets or sets the list of order item identifiers to filter dispense details.
     * @param fromDate (optional) Gets or sets the start date of the range to filter results.
     * @param toDate (optional) Gets or sets the end date of the range to filter results.
     * @param actionType (optional) Gets or sets the type of action to be performed for the order dispense operation.
     * @return Returns the list of dispense IDs.
     */
    dispenseIds(orderItemIds?: number[] | undefined, fromDate?: DateTime | null | undefined, toDate?: DateTime | null | undefined, actionType?: OrderDispenseActionType | null | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/v1/integration/OrderIntegration/DispenseIds?";
        if (orderItemIds === null)
            throw new globalThis.Error("The parameter 'orderItemIds' cannot be null.");
        else if (orderItemIds !== undefined)
            orderItemIds && orderItemIds.forEach(item => { url_ += "OrderItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (actionType !== undefined && actionType !== null)
            url_ += "ActionType=" + encodeURIComponent("" + actionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDispenseIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDispenseIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processDispenseIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request is invalid or filter criteria are missing.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Missing or invalid API key.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The client is not authorized to view this dispense information.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("No dispense records found matching the criteria.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PatientCoverageIntegrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets patient coverage information from a source system e.g PatientLink or LuminavNext.
     * @param patientId (optional) The ID of the patient.
     * @param orderId (optional) The ID of the order.
     * @param workflowId (optional) The ID of the workflow.
     * @return Successfully retrieved patient coverage.
     */
    getPatientCoverage(patientId?: number | null | undefined, orderId?: number | null | undefined, workflowId?: number | null | undefined): Observable<PatientCoverageDto> {
        let url_ = this.baseUrl + "/api/v1/PatientCoverageIntegration/GetPatientCoverage?";
        if (patientId !== undefined && patientId !== null)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (workflowId !== undefined && workflowId !== null)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientCoverage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientCoverage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientCoverageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientCoverageDto>;
        }));
    }

    protected processGetPatientCoverage(response: HttpResponseBase): Observable<PatientCoverageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatientCoverageDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Invalid request data.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Patient coverage not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PharmaciesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves the pharmacies allowed for the authenticated workflow.
     * @return Successfully retrieved the allowed pharmacies.
     */
    get(): Observable<GetAllowedPharmaciesQueryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/integration/Pharmacies/Allowed";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllowedPharmaciesQueryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllowedPharmaciesQueryResponse[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetAllowedPharmaciesQueryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAllowedPharmaciesQueryResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("The request was malformed or invalid.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Missing or invalid API key. Authentication is required for this endpoint.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Access forbidden. The authenticated client does not have permission to access this resource.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal server error occurred while processing the request.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface GetAttachmentsQueryResponse {
    id?: number;
    orderId?: number;
    patientId?: number;
    workflowId?: number;
    workflowName?: string;
    documentType?: string;
    dateReceived?: DateTime;
    fileName?: string;
    fileType?: string;
    fileContent?: string;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

/** Represents the response for retrieving details about the currently authenticated user. */
export interface GetAuthenticatedUserQueryResponse {
    /** Gets or sets the unique identifier of the authenticated user. */
    id?: number;
    /** Gets or sets the full name of the authenticated user. */
    firstName?: string;
    /** Gets or sets the last name of the authenticated user. */
    lastName?: string;
    /** Gets or sets the email address of the authenticated user. */
    email?: string;
    /** Gets the full display name of the authenticated user, combining first and last names. */
    displayName?: string;
    /** Gets or sets the current pharmacy that the authenticated user has access to. */
    currentPharmacy?: PharmacyAccessResponse | undefined;
    /** Gets or sets the list of pharmacies that the authenticated user has access to, */
    pharmacyAccessList?: { [key in keyof typeof UserRole]?: PharmacyAccessResponse[]; };
    /** Gets or sets the grid settings associated with the authenticated user. */
    gridSettings?: GetAuthenticatedUserGridSettingsResponse[];
    /** Gets or sets which optional platform features are enabled in this environment. */
    features?: AuthenticatedUserFeaturesResponse;
}

/** Represents a response to the PharmacyAccessResponse. */
export interface PharmacyAccessResponse {
    pharmacyId?: number;
    pharmacyName?: string;
    allowAssignOrders?: boolean;
    allowPerformClinicalValidation?: boolean;
    excludeFromAssignmentList?: boolean;
    commercializationAccess?: boolean;
    role?: UserRole;
    timeZone?: string;
    pharmacyShortName?: string | undefined;
}

export enum UserRole {
    ADMINISTRATOR = 0,
    PHARMACY_ADMINISTRATOR = 1,
    PHARMACY_MANAGER = 2,
    PHARMACY_USER = 3,
    TRANSPORTATION_MANAGER = 4,
    NONE = 5,
    THIRD_PARTY = 6,
}

/** Represents the settings for a grid associated with an authenticated user. */
export interface GetAuthenticatedUserGridSettingsResponse {
    id?: number | undefined;
    description?: string;
    key?: string;
    settings?: string;
    isDefault?: boolean;
}

/** Which optional platform features are enabled in this environment. Sent with the current user so the UI can hide the surfaces of a feature whose backing service is switched off (a disabled aggregation would otherwise show pages with a permanently frozen 'data as of'). */
export interface AuthenticatedUserFeaturesResponse {
    /** Mirrors configuration ManagerAnalytics:Enabled. */
    managerAnalytics?: boolean;
    /** Mirrors configuration Gamification:Enabled. */
    gamification?: boolean;
}

/** Represents the result of an operation, indicating success or failure. */
export interface Result {
    /** Gets a value indicating whether the result is successful. */
    isSuccess?: boolean;
    /** Gets the error associated with the result, if any. */
    error?: ResultError;
}

/** Initializes a new instance of the ResultError class. */
export interface ResultError {
    /** The error code. */
    code?: string;
    /** The error description. */
    description?: string;
    /** The type of error. */
    errorType?: ResultErrorType;
}

/** Represents the different types of errors that can occur. */
export enum ResultErrorType {
    Failure = 0,
    NotFound = 1,
    Validation = 2,
    Conflict = 3,
    AccessUnAuthorized = 4,
    AccessForbidden = 5,
}

/** Represents the response for a grid settings query. */
export interface GetGridSettingsQueryResponse {
    /** The unique identifier of the grid setting. */
    id?: number;
    /** The description of the grid setting. */
    description?: string;
    /** The key used to identify the grid setting. */
    key?: string;
    /** The settings configuration data for the grid. */
    settings?: string;
    /** Indicates whether this is the default grid setting. */
    isDefault?: boolean;
}

/** Represents the result of an upsert operation for grid settings, containing the identifier of the affected settings record. */
export interface UpsertGridSettingsCommandResponse {
    /** The unique identifier of the grid settings record that was created or updated. */
    id?: number | undefined;
}

/** Represents a command to upsert grid settings for the authenticated user. */
export interface UpsertGridSettingsCommand {
    id?: number | undefined;
    description?: string;
    key?: string;
    settings?: string;
    isDefault?: boolean;
}

/** System-level settings the dashboard needs when it loads. These are the same for everyone and are controlled by the server, not the user, so the frontend reads them once instead of having values baked into the app. */
export interface DashboardConfigDto {
    /** How often the dashboard should automatically reload all its tiles, in seconds. The frontend
uses this to set up its auto-refresh timer. */
    autoRefreshIntervalSeconds?: number;
}

/** One card the user is allowed to add to their dashboard in the pharmacy they are currently in. The available-cards endpoint returns a list of these, and the frontend uses them to fill in the "Customize tiles" panel. */
export interface DashboardCardDto {
    /** The card's code, e.g. "ORDER_VERIFICATIONS". The frontend sends this back to ask for the card's data. */
    cardKey?: string;
    /** The card's name as shown to the user, e.g. "Order verifications". */
    name?: string;
    /** The card's category: "GENERAL" (anyone) or "MANAGER" (only users allowed to see manager cards). */
    cardType?: string;
}

/** The current user's saved layout for their current pharmacy. */
export interface GetUserDashboardLayoutResponse {
    /** True if the user has ever saved a layout for this pharmacy, even one with no cards (every tile
turned off). This lets the frontend tell a deliberate all-off layout apart from a user who has
never customized: an all-off layout has HasSavedLayout true with an empty
Cards, whereas an uncustomized user has it false and falls back to the default. */
    hasSavedLayout?: boolean;
    /** The placed cards and their positions (empty if all tiles are turned off). */
    cards?: DashboardLayoutCardDto[];
}

/** One card sitting on a saved dashboard, with where it is and how big it is. The same shape is used both ways — the frontend sends a list of these to save the layout, and gets the same list back when loading it — so a card's position survives the round trip. The numbers describe a spot on the tile grid the frontend draws. */
export interface DashboardLayoutCardDto {
    /** The card's code, e.g. "READY_TO_SHIP". */
    cardKey?: string;
    /** Which column the tile starts in (the grid starts at 0). */
    col?: number;
    /** Which row the tile starts in (the grid starts at 0). */
    row?: number;
    /** How many columns wide the tile is (at least 1). */
    colSpan?: number;
    /** How many rows tall the tile is (at least 1). */
    rowSpan?: number;
}

/** Saves the current user's dashboard layout for their current pharmacy. The frontend sends the complete set of placed cards when the user clicks Save (collapsing a whole customize session into one write), and this becomes the new saved layout. An empty set is a valid layout: it means the user turned every tile off.            The server checks every card against what the user is actually allowed to see, so a tampered or stale request can never save a card the user should not have. */
export interface SaveUserDashboardLayoutCommand {
    /** The full set of placed cards with their positions and sizes. */
    cards?: DashboardLayoutCardDto[];
}

/** The current user's saved Follow Up tile preference for their current pharmacy. */
export interface GetUserFollowUpTilePreferenceResponse {
    /** False (Auto) unless the user has explicitly switched to Custom. */
    isCustomMode?: boolean;
    /** The user's Custom-mode workflow selection, in their chosen display order. Empty when the user
is in Auto mode, or is in Custom mode but has not picked anything (yet). */
    workflows?: FollowUpTileWorkflowSelectionDto[];
}

/** One workflow in a user's Custom-mode Follow Up tile selection. The same shape is used both ways — the frontend sends a list of these (as just the ordered workflow ids) to save the selection, and gets the same list back, with names filled in, when loading it. */
export interface FollowUpTileWorkflowSelectionDto {
    /** The selected workflow. */
    workflowId?: number;
    /** The workflow's display name. */
    workflowName?: string;
    /** Where this workflow sits in the user's chosen display order (0-based). */
    sortOrder?: number;
    /** True once the workflow's retirement date has arrived. A retired workflow stays selectable and
stays on the tile; the frontend marks it so the user can see why it is no longer filling up. */
    isRetired?: boolean;
}

/** Saves the current user's Follow Up tile preference for their current pharmacy: the Auto/Custom mode, and the full ordered set of Custom-mode workflows. The frontend sends the complete selection whenever it changes (mode toggle or edited selection), and this becomes the new saved preference — an empty selection is valid (Custom mode with nothing picked yet).            The server checks every workflow against what is actually available to the current pharmacy, so a tampered or stale request can never save a workflow the pharmacy does not have. */
export interface SaveUserFollowUpTilePreferenceCommand {
    /** False for Auto (system-ranked top 10), true for Custom. */
    isCustomMode?: boolean;
    /** The full Custom-mode selection, in the order they should display. Kept even while
IsCustomMode is false, so a user's picks survive toggling back to Auto and
forward to Custom again. */
    workflowIds?: number[];
}

/** The dashboard data payload: each requested card's data keyed by card, plus how current that data is so the toolbar's "Last refreshed" label can tell the truth. */
export interface GetDashboardDataResponse {
    /** When the returned data is current as of, in UTC. For a normal load or the automatic refresh this is
the start of the shared freshness window, so every card reads as one coherent "as of" time and can
be up to one auto-refresh interval ago for data read late in its window. For a manual refresh the
data is computed live, so this is the actual time of that refresh. The frontend shows this as the
"Last refreshed" time in the pharmacy's timezone and counts down a full interval from it. */
    asOf?: DateTime;
    /** Each card's data, keyed by card key. */
    cards?: { [key: string]: any; };
    /** The pharmacy-local dates the tiles' Overdue / Today / Tomorrow columns are measured against, so a
tile can link a count to its bucket with a real date window attached. Computed live rather than
read from the per-card cache, because a stale "today" would send the user to the wrong day. Null
only when the pharmacy has no province to derive a local date from. */
    segmentDates?: DashboardSegmentDatesDto | undefined;
}

/** The two calendar dates every tile's Overdue / Today / Tomorrow split is measured against, in the pharmacy's own local time. Sent alongside the card data so a tile can turn a count into a link carrying a real date window, and the destination list can filter on plain date comparisons instead of re-deriving the pharmacy's timezone and its province's statutory holidays. */
export interface DashboardSegmentDatesDto {
    /** The pharmacy's current local date, at midnight. */
    today?: DateTime;
    /** The next business day after Today, skipping weekends and the pharmacy
province's observed holidays - the same date the cards call "Tomorrow", which over a weekend or
a long weekend is not the next calendar day. */
    tomorrow?: DateTime;
}

/** Fetches the data for a set of dashboard cards in one call. The frontend sends only the cards it is actually showing, so a small dashboard only does a little work — a card whose data was not asked for is never queried.            The result is a GetDashboardDataResponse: the per-card data keyed by card, plus an AsOf stamp telling the frontend how current that data really is. The shape inside each card key is owned by that card and is treated as an opaque blob here, which is why adding real card data later does not change this endpoint or the frontend shell.            Each card's data is served from a per-pharmacy cache keyed to a shared freshness window, so everyone at a pharmacy shares one snapshot until the window rolls over and the same queries are not re-run for every visitor. The window is anchored to a stable per-pharmacy grid so the cards stay in step and the pharmacies don't all recompute on the same instant (see DashboardCacheWindow). When the user clicks Refresh, the frontend asks for live numbers by setting ForceRefresh, which skips the cached value, runs the card live, and refreshes the cache so the next visitor benefits too, while staying on the same shared window boundary. */
export interface GetDashboardDataQuery {
    /** The cards to fetch data for. */
    cardKeys?: string[];
    /** When true, ignore any cached value and fetch fresh data, then update the cache. Used by the
dashboard's manual Refresh button so the user always sees current numbers. Leave false for the
normal page load and the automatic refresh, which are happy to read the shared cached snapshot. */
    forceRefresh?: boolean;
}

/** One dashboard card as seen on the pharmacy tile availability screen, with whether it is currently turned on for the pharmacy being configured. Unlike the user-facing available-cards list, this includes every card in the catalog (General and Manager) so an administrator can switch any of them on or off. */
export interface DashboardCardAvailabilityDto {
    /** The card's code, e.g. "ORDER_VERIFICATIONS". */
    cardKey?: string;
    /** The card's name as shown to the user, e.g. "Order verifications". */
    name?: string;
    /** The card's category: "GENERAL" or "MANAGER". */
    cardType?: string;
    /** True if the card is available for the pharmacy; false if an administrator has turned it off. */
    isEnabled?: boolean;
}

/** One card's desired on/off setting sent from the pharmacy tile availability screen when an administrator saves. The screen sends the full set of cards, and each one says whether it should be available for the pharmacy. */
export interface PharmacyDashboardCardSettingDto {
    /** The card's code, e.g. "ORDER_VERIFICATIONS". */
    cardKey?: string;
    /** True to make the card available for the pharmacy; false to turn it off. */
    isEnabled?: boolean;
}

/** Represents the response model for a drug query operation. Contains essential information about a drug. */
export interface GetDrugQueryResponse {
    /** The unique identifier for the drug. */
    id?: number;
    /** The commercial or brand name of the drug. */
    name?: string;
    /** The non-proprietary or generic name of the drug. */
    genericName?: string;
    /** The name of the company that manufactures the drug. */
    manufacturerName?: string;
    /** The unique identifier for the drug manufacturer. */
    manufacturerId?: number;
    /** The drug storage type. */
    storageTypeValue?: string;
    /** The drug storage type description. */
    storageTypeDescription?: string;
    /** Is other drug */
    isOther?: boolean;
}

export enum DrugType {
    ALL = 1,
    OTHER = 2,
    BRAND = 3,
}

/** Represents a response model for drug details query results */
export interface GetDrugDetailsQueryResponse {
    /** The unique identifier for the drug details record */
    id?: number;
    /** The identifier of the associated drug */
    drugId?: number;
    /** The strength or dosage of the drug */
    strength?: string;
    /** The Drug Identification Number (DIN) */
    din?: string;
    /** The unit of measurement for the drug */
    unitType?: string;
}

/** Response returned after successfully creating a new drug record in the system. */
export interface CreateDrugCommandResponse {
    /** The unique identifier assigned to the newly created drug record. */
    id?: number;
}

/** Command to create a new drug in the system. */
export interface CreateDrugCommand {
    /** The commercial name of the drug. */
    name?: string;
    /** The generic name of the drug. */
    genericName?: string;
    /** The ID of the manufacturer that produces this drug. */
    manufacturerId?: number;
    /** The value of the storage type. */
    storageTypeValue?: string;
    /** Determines whether this is an other drug. */
    isOther?: boolean;
}

/** Command to update a drug. */
export interface UpdateDrugCommand {
    /** The ID of the drug to update. */
    id?: number;
    /** The new name of the drug. */
    name?: string;
    /** The new generic name of the drug. */
    genericName?: string;
    /** The ID of the manufacturer. */
    manufacturerId?: number;
    /** The storage type value. */
    storageTypeValue?: string;
    /** Determines whether this is an other drug. */
    isOther?: boolean;
}

/** A drug entity with its identifier, display name, and unique code. */
export interface GetDrugSelectListQueryResponse {
    /** The unique identifier of the drug. */
    id?: number;
    /** The formatted display name of the drug, which may include manufacturer information. */
    name?: string;
    /** A unique code used to identify the drug, independent of database IDs. */
    drugCode?: string;
}

export interface GetDispenseTypesForWorkflowAndDrugQueryResponse {
    id?: number;
    value?: string;
    description?: string;
    descriptionFr?: string;
}

/** Represents the response for retrieving dispense types for a specific workflow and drug. */
export interface GetDispenseTypesForWorkflowAndDrugsQueryResponse {
    /** The unique identifier of the drug. */
    drugId?: number;
    /** A collection of dispense types associated with the drug. */
    dispenseTypes?: DispenseTypeDto[];
}

/** Represents a dispense type with its details. */
export interface DispenseTypeDto {
    /** The unique identifier of the dispense type. */
    id?: number;
    /** The value of the dispense type. */
    value?: string;
    /** The description of the dispense type. */
    description?: string;
    /** The French description of the dispense type. */
    descriptionFr?: string;
}

/** Response model containing details of a drug that is not the primary drug being viewed. */
export interface GetOtherDrugDetailsSelectListQueryResponse {
    /** The unique identifier of the drug details. */
    id?: number;
    /** The name of the drug. */
    name?: string;
    /** The id of the drug. */
    drugId?: number;
    /** The Din of the drug. */
    din?: string;
}

/** Response record returned after successfully creating drug details. */
export interface CreateDrugDetailsCommandResponse {
    /** The identifier of the newly created drug details entity. */
    id?: number;
}

/** Command to create a new drug details record in the system. This links specific details like strength and DIN to a drug. */
export interface CreateDrugDetailsCommand {
    /** The ID of the parent drug this detail belongs to */
    drugId?: number;
    /** The strength or dosage of the drug (e.g., "10mg") */
    strength?: string;
    /** Drug Identification Number - unique product identifier assigned by Health Canada */
    din?: string;
    /** The unit form of the drug (e.g., "tablet", "capsule", "mL") */
    unitType?: string;
}

/** Command to update drug details. */
export interface UpdateDrugDetailsCommand {
    /** The identifier of the drug details to update. */
    id?: number;
    /** The new strength of the drug. */
    strength?: string;
    /** The new DIN of the drug. */
    din?: string;
    /** The new unit type of the drug. */
    unitType?: string;
}

/** A single enumeration entity with its display values in English and French. */
export interface GetEnumEntityQueryResponse {
    /** The unique identifier of the enumeration entity. */
    id?: number;
    /** The code or key value of the enumeration entry. */
    value?: string;
    /** The English description of the enumeration entry. */
    description?: string;
    /** The French description of the enumeration entry. */
    descriptionFr?: string;
    /** The enumeration type or category this entry belongs to. */
    type?: string;
    /** Determines if the enumeration entry represents a free good. This is an optional property that may not be present for all enum types. */
    freeGood?: boolean | undefined;
}

/** Represents a command to add a new entry to a named enumeration. */
export interface CreateEnumEntityCommand {
    /** The name of the target enumeration (e.g., "DispenseType"). */
    enumName?: string;
    /** The description for the new enum entry. Used for both English and French descriptions. */
    description?: string;
    /** Additional properties for the new enum entry. These can include any custom attributes required by specific enum types. */
    extraProperties?: { [key: string]: any; } | undefined;
}

/** Represents a command to update the description of an existing entry in a named enumeration. */
export interface UpdateEnumEntityCommand {
    /** The unique identifier of the enum entry to update. */
    id?: number;
    /** The name of the target enumeration (e.g., "DispenseType"). */
    enumName?: string;
    /** The new description for the enum entry. Applied to both English and French descriptions. */
    description?: string;
    /** Additional type-specific properties to update (e.g., FreeGood for DispenseType). */
    extraProperties?: { [key: string]: any; } | undefined;
}

/** Response wrapping the full set of feature flags. */
export interface GetFeatureFlagsResponse {
    flags?: FeatureFlagDto[];
}

/** A single feature flag exposed to the client. */
export interface FeatureFlagDto {
    /** The stable flag key. */
    key?: string;
    /** The manual on/off switch (used only when no window is set). */
    isEnabled?: boolean;
    /** Human-readable description. */
    description?: string | undefined;
    /** Inclusive start of the scheduling window, or null for none. */
    enabledFrom?: DateTime | undefined;
    /** Exclusive end of the scheduling window, or null for none. */
    enabledUntil?: DateTime | undefined;
    /** The effective on/off state right now, evaluated server-side (honours the schedule window).
This is what the UI should gate on; IsEnabled and the window are for the
admin editor. */
    isCurrentlyEnabled?: boolean;
}

/** Request body for setting a feature flag's state. Leave the window null for a manual on/off flag; set a window to schedule it (the window then governs and IsEnabled is ignored). */
export interface SetFeatureFlagRequest {
    /** The manual on/off state (used only when no window is set). */
    isEnabled?: boolean;
    /** Inclusive start of the scheduling window, or null for none. */
    enabledFrom?: DateTime | undefined;
    /** Exclusive end of the scheduling window, or null for none. */
    enabledUntil?: DateTime | undefined;
}

export interface MyDayResponse {
    /** When the precomputed parts were computed (null if no run yet). */
    snapshotAsOf?: DateTime | undefined;
    /** Per-milestone today counts vs baseline and target. */
    today?: MyDayMilestoneItem[];
    /** Total points today vs the daily target and the self baseline. */
    score?: MyDayScore;
    /** Where the self baseline comes from: 'LAST_WEEK' (same weekday last week had activity),
'AVERAGE' (last week was quiet; the average of the last 4 same-weekdays is used), or 'NONE'
(no history - a brand-new user; the UI shows onboarding copy instead of a zero to beat). */
    baselineSource?: string;
    /** Precomputed streak (null until a run completes). */
    streak?: MyDayStreak | undefined;
    /** The user's private badges (empty until a run completes). */
    badges?: MyDayBadge[];
    /** Private standing (null until a run completes). */
    standing?: MyDayStanding | undefined;
    accuracy?: MyDayAccuracy | undefined;
}

export interface MyDayMilestoneItem {
    milestoneType?: string;
    todayCount?: number;
    /** The user's own count at this time of day, same weekday last week. */
    lastWeekSameTimeCount?: number;
    dailyTarget?: number;
    pointWeight?: number;
    targetRationale?: string | undefined;
}

export interface MyDayScore {
    todayPoints?: number;
    dailyTargetPoints?: number;
    lastWeekSameTimePoints?: number;
}

export interface MyDayStreak {
    currentStreakDays?: number;
    lastStreakDate?: DateTime | undefined;
}

export interface MyDayBadge {
    badgeCode?: string;
    earnedOn?: DateTime | undefined;
    detail?: string | undefined;
}

export interface MyDayStanding {
    /** 10 | 20 | 30 - null unless the user is in the top 30% (privacy rule). */
    topPercentLabel?: number | undefined;
    trailing7DayPoints?: number;
    /** The absolute anchor: the pharmacy's configured daily point target. */
    siteStandardDailyPoints?: number;
}

/** The private quality counterweight to the volume stats: of the orders this user verified in the last 30 days, how many never bounced back with an issue raised after their verification. Framed positively (first-pass rate), shown only to the user. Null when the user verified nothing in the window (no rate to show beats a scary 0%). */
export interface MyDayAccuracy {
    verifiedLast30Days?: number;
    reworkedLast30Days?: number;
    firstPassPct?: number;
}

export interface MyDayScoreResponse {
    todayPoints?: number;
    dailyTargetPoints?: number;
}

export interface MyUnfinishedWorkResponse {
    items?: UnfinishedOrderItem[];
}

export interface UnfinishedOrderItem {
    orderId?: number;
    patientDisplayName?: string;
    orderStatusId?: number;
    statusKey?: string;
    /** 'ASSIGNED_TO_ME' | 'I_TOUCHED_LAST'. */
    reason?: string;
    lastTouchedAt?: DateTime | undefined;
    lastMilestoneType?: string | undefined;
    isUrgent?: boolean;
    /** Stable key for the next action verb (the UI translates it). */
    nextActionKey?: string;
    /** Points the next action earns under the pharmacy's KPI weights (null when it maps to no milestone). */
    nextActionPoints?: number | undefined;
    /** When the patient runs out of medication - the clinical priority signal. */
    treatmentRunOutAt?: DateTime | undefined;
}

export interface MyDayCoachResponse {
    /** The coach sentence, or null when no model is configured (Available = false). */
    hint?: string | undefined;
    /** Whether an AI model produced a hint. */
    available?: boolean;
}

/** Records whether the daily AI coach hint landed ("was this helpful?"). POC scope: the rating goes to structured logging (Serilog -> Application Insights) rather than a table - enough to tune the coach prompt from telemetry before deciding the feature earns persistence. No hint text is logged (it can reference the user's own stats); just the verdict and scope. */
export interface SubmitCoachFeedbackCommand {
    helpful?: boolean;
}

export interface KpiTargetsResponse {
    items?: KpiTargetItem[];
}

export interface KpiTargetItem {
    milestoneType?: string;
    dailyTarget?: number;
    pointWeight?: number;
    rationale?: string | undefined;
}

/** Saves the manager KPI configuration for the current pharmacy (config-lite: per milestone type, a daily target, a point weight and an optional rationale shown to the team - "tell and sell"). The pharmacy always comes from the caller's scope, never from the request. Existing rows are updated in place (temporal history keeps every prior version); new milestone rows are inserted. */
export interface UpsertKpiTargetsCommand {
    items?: KpiTargetItem[];
}

export interface TeamOverviewExplanationResponse {
    /** The explanation, or null when no model is configured (Available = false). */
    text?: string | undefined;
    available?: boolean;
}

export interface TeamOverviewResponse {
    asOf?: DateTime | undefined;
    trend?: TeamTrendPoint[];
    byMilestone?: TeamMilestoneAggregate[];
    attainmentHistogram?: AttainmentBucket[];
    mostImproved?: TeamHighlight | undefined;
}

export interface TeamTrendPoint {
    localDate?: DateTime;
    touches?: number;
    points?: number;
    completions?: number;
}

export interface TeamMilestoneAggregate {
    milestoneType?: string;
    trailing7DayTouches?: number;
    trailing7DayPoints?: number;
    dailyTarget?: number;
    attainmentPct?: number | undefined;
}

export interface AttainmentBucket {
    /** '<50%' | '50-79%' | '80-99%' | '100%+'. */
    bucket?: string;
    userCount?: number;
}

export interface TeamHighlight {
    /** First name only - shown to managers as a positive highlight, never a ranking. */
    firstName?: string;
    improvementPct?: number;
}

/** Response containing holidays grouped by year. */
export interface GetHolidaysQueryResponse {
    /** Dictionary of holidays grouped by year.
Key: Year (e.g., 2026)
Value: List of holidays for that year */
    holidaysByYear?: { [key: string]: HolidayDto[]; };
}

/** A Canadian holiday.Includes a name, the literal date of the holiday, the observed date of the holiday(ie, accommodating for weekends), and a list of regions that observe this holiday. */
export interface HolidayDto {
    id?: number;
    /** example: 2020-12-26 ISO date: the literal date of the holiday */
    date?: DateTime | undefined;
    nameEn?: string | undefined;
    nameFr?: string | undefined;
    federal?: number;
    observedDate?: DateTime | undefined;
    provinces?: HolidayProvinceDto[] | undefined;
    optional?: number | undefined;
}

export interface HolidayProvinceDto {
    id?: string;
    nameFr?: string;
    nameEn?: string;
    nextHoliday?: HolidayDto | undefined;
    sourceLink?: string;
    sourceEn?: string;
    optional?: number | undefined;
    holidays?: HolidayDto[] | undefined;
}

/** Response object returned by the GetIssueTypes query containing issue type information. */
export interface GetIssueTypesQueryResponse {
    /** The unique identifier or code for the issue type. */
    value?: string;
    /** The human-readable description of the issue type. */
    description?: string;
}

export interface StatusDwellResponse {
    /** When the read-model was computed (null if no run has completed yet). */
    asOf?: DateTime | undefined;
    /** One row per status the pharmacy has activity or backlog in. */
    items?: StatusDwellItem[];
}

export interface StatusDwellItem {
    orderStatusId?: number;
    statusKey?: string;
    avgDwellMinutes?: number | undefined;
    medianDwellMinutes?: number | undefined;
    p90DwellMinutes?: number | undefined;
    currentBacklogCount?: number;
    sampleSize?: number;
}

export interface LoadHeatmapResponse {
    asOf?: DateTime | undefined;
    cells?: LoadHeatmapCell[];
}

export interface LoadHeatmapCell {
    eventType?: string;
    dayOfWeek?: number;
    hourOfDay?: number;
    eventCount?: number;
}

export interface SlaTrendResponse {
    asOf?: DateTime | undefined;
    points?: SlaTrendPoint[];
}

export interface SlaTrendPoint {
    localDate?: DateTime;
    ordersDue?: number;
    acknowledgedWithinSlaCount?: number;
    cycleTimeP50Minutes?: number | undefined;
    cycleTimeP90Minutes?: number | undefined;
}

export interface PatientRiskResponse {
    refillGaps?: PatientRiskBucket;
    treatmentStartRisks?: PatientRiskBucket;
    urgentWaiting?: PatientRiskBucket;
    missedPickups?: PatientRiskBucket;
}

export interface PatientRiskBucket {
    /** Total orders in the bucket (the list holds only the most pressing few). */
    count?: number;
    /** The most pressing orders, earliest risk date first. */
    items?: PatientRiskItem[];
}

export interface PatientRiskItem {
    /** The at-risk order. */
    orderId?: number;
    /** The patient's name (denormalized on the order), or "Order #id" when absent. */
    patientName?: string;
    /** The date that makes the order risky (run-out, treatment start, created, expected pickup). */
    date?: DateTime | undefined;
    /** The workflow (program) the order belongs to - who the manager escalates to. */
    programName?: string;
}

export interface ProgramHealthResponse {
    items?: ProgramHealthItem[];
}

export interface ProgramHealthItem {
    workflowId?: number;
    /** The workflow (program) name, e.g. 'BeONE'. */
    programName?: string;
    /** Orders currently in a non-terminal status. */
    openOrders?: number;
    /** Of the open orders, how many are flagged urgent. */
    urgentOpen?: number;
    /** Age in days of the oldest open order (0 when none). */
    oldestOpenAgeDays?: number;
    /** Orders created in the last 7 days. */
    created7Days?: number;
    /** Orders completed in the last 7 days. */
    completed7Days?: number;
    /** Share of last-7-day orders acknowledged within their first-contact target (null when nothing was due). */
    slaAttainmentPct7Days?: number | undefined;
}

export interface ExplainChartResponse {
    chartKey?: string;
    explanation?: string | undefined;
    available?: boolean;
}

export interface InsightsResponse {
    /** When the underlying analytics were computed. */
    asOf?: DateTime | undefined;
    /** The brief, or null when no model is configured (Available = false). */
    insights?: string | undefined;
    /** Whether an AI model produced a brief. */
    available?: boolean;
}

export interface CapacityUtilizationResponse {
    asOf?: DateTime | undefined;
    days?: CapacityUtilizationDay[];
}

export interface CapacityUtilizationDay {
    dayOfWeek?: number;
    avgOrdersPerDay?: number;
    orderCapacityPerDay?: number | undefined;
    utilizationPct?: number | undefined;
}

export interface DelayReasonsResponse {
    asOf?: DateTime | undefined;
    items?: DelayReasonItem[];
}

export interface DelayReasonItem {
    /** The delay reason's stable code, e.g. "ISSUE_COVERAGE". */
    reasonKey?: string;
    /** Follow-ups recorded with that reason in the window. */
    count?: number;
}

export interface VolumeForecastResponse {
    asOf?: DateTime | undefined;
    modelTag?: string | undefined;
    points?: VolumeForecastPoint[];
}

export interface VolumeForecastPoint {
    localDate?: DateTime;
    actualCount?: number | undefined;
    forecastCount?: number | undefined;
    forecastLowerBound?: number | undefined;
    forecastUpperBound?: number | undefined;
}

/** Represents the response model for a manufacturer query operation. Contains essential information about a manufacturer. */
export interface GetManufacturerQueryResponse {
    /** The unique identifier for the manufacturer. */
    id?: number;
    /** The name of the manufacturer. */
    name?: string;
    /** The short name of the manufacturer. */
    shortName?: string | undefined;
    /** The abbreviation of the manufacturer. */
    abbreviation?: string;
}

export interface CreateManufacturerResponse {
    id?: number;
}

/** Represents a command to create a new manufacturer. */
export interface CreateManufacturerCommand {
    /** The name of the manufacturer. */
    name?: string;
    /** The short name of the manufacturer. */
    shortName?: string;
    /** The abbreviation of the manufacturer type. */
    abbreviation?: string;
}

/** Represents a command to update an existing manufacturer's details. */
export interface UpdateManufacturerCommand {
    /** The id of the manufacturer. */
    id?: number;
    /** The name of the manufacturer. */
    name?: string;
    /** The short name of the manufacturer. */
    shortName?: string;
    /** The abbreviation of the manufacturer. */
    abbreviation?: string;
}

/** Represents the response for a query to get an order by its status. */
export interface GetOrderByStatusQueryResponse {
    /** The unique identifier of the order. */
    id?: number;
    /** The unique identifier of the workflow associated with the order. */
    workflowId?: number;
    /** The name of the workflow associated with the order. */
    workflowName?: string;
    /** The first name of the patient. */
    patientFirstName?: string;
    /** The last name of the patient. */
    patientLastName?: string;
    /** The preferred name of the patient */
    patientPreferredName?: string | undefined;
    /** The date of birth of the patient. */
    dateOfBirth?: DateTime | undefined;
    /** The external identifier associated with the order's patient. */
    externalId?: string | undefined;
    /** The date and time when the order was created. */
    createdAt?: DateTime;
    /** The estimated start date and time of the treatment. */
    estTreatmentStartAt?: DateTime | undefined;
    /** Any special instructions related to the order. */
    specialInstructions?: string | undefined;
    /** The value representing the status of the order. */
    orderStatusValue?: string;
    /** The description of the order status. */
    orderStatusDescription?: string;
    /** The urgency of the order. */
    isUrgent?: boolean;
    /** The initial order */
    isInitial?: boolean;
    /** Expected First Contact date with the patient */
    estimatedFirstContactAt?: DateTime | undefined;
    /** Date treatment will run out */
    treatmentRunOutAt?: DateTime | undefined;
    /** Assigned to */
    assignedTo?: string | undefined;
    /** Most recent timestamp of the order */
    lastUpdated?: DateTime;
    /** FollowUpDtoMost recent follow up record */
    lastFollowUp?: FollowUpDto | undefined;
    /** ShipmentDtoShipment information for the order */
    shipmentData?: ShipmentDto[];
    /** Expected date the order will be picked up, rather than delivered */
    expectedPickUpDate?: DateTime | undefined;
    /** Date the order was picked up */
    actualPickUpDate?: DateTime | undefined;
    /** The user name that last updated the order. */
    lastUpdatedBy?: string | undefined;
    /** The date the prescription reception was confirmed. */
    rxReceivedConfirmedAt?: DateTime | undefined;
    /** The date coverage was confirmed. */
    coverageConfirmedAt?: DateTime | undefined;
    /** The name of who requested the order. */
    requestorName?: string | undefined;
    /** Indicates whether the order has a same day shipment. */
    hasSameDayShipment?: boolean;
    /** The earliest date the shipment can be made. */
    earliestShipDate?: DateTime | undefined;
}

/** Data transfer object for the most recent follow up. */
export interface FollowUpDto {
    followUpDate?: DateTime | undefined;
    notes?: string | undefined;
    lastUpdated?: DateTime;
    lastUpdatedBy: string;
    reasonForDelayDescription?: string | undefined;
    reasonForDelayDescriptionFr?: string | undefined;
    callAttempted?: DateTime | undefined;
}

/** Data transfer object for the shipment. */
export interface ShipmentDto {
    shipmentId?: number | undefined;
    shipDate?: DateTime | undefined;
    shipCity?: string | undefined;
    /** The courier's stable id, so a dashboard tile drill-through can filter a list to an exact
courier without matching on the display name (34755, Courier - Orders Shipping Today).
Populated only where a caller needs it; other callers leave it null. */
    courierId?: number | undefined;
    courierName?: string | undefined;
    courierValue?: string | undefined;
    courierInstruction?: string | undefined;
    courierDeliveryStatus?: string | undefined;
    trackingNumbers?: string[] | undefined;
    expectedDeliveryDate?: DateTime | undefined;
    isFinalDestination?: boolean;
    shipToAddressLine1?: string | undefined;
    shipToAddressLine2?: string | undefined;
    shipToProvince?: string | undefined;
    shipToPostalCode?: string | undefined;
    shipToAttention?: string | undefined;
    phone?: string | undefined;
    phoneExt?: string | undefined;
    email?: string | undefined;
    orderIds?: number[] | undefined;
    groupShipmentId?: number | undefined;
    lastUpdated?: DateTime;
}

/** Represents the response for the GetOrderById query. */
export interface GetOrderByIdQueryResponse {
    /** Unique identifier for the order. */
    id?: number;
    /** Name of the drug associated with the order. */
    drugName?: string | undefined;
    /** Unique identifier for the drug associated with the order. */
    drugId?: number | undefined;
    /** Date and time when the order was created. */
    createdAt?: DateTime;
    /** Estimated start date for the treatment. */
    estTreatmentStartAt?: DateTime | undefined;
    /** Type of dispense for the order. */
    dispenseType?: string | undefined;
    /** Id of the requested dispense type for the order */
    requestDispenseTypeValue?: string | undefined;
    /** Special instructions for the order. */
    specialInstructions?: string | undefined;
    /** Attention line for the shipping address. */
    shipToAttention?: string | undefined;
    /** First line of the shipping address. */
    shipToAddressLine1?: string | undefined;
    /** Second line of the shipping address. */
    shipToAddressLine2?: string | undefined;
    /** City of the shipping address. */
    shipToCity?: string | undefined;
    /** Province of the shipping address. */
    shipToProvince?: string | undefined;
    /** Postal code of the shipping address. */
    shipToPostalCode?: string | undefined;
    /** Description of the order status. */
    orderStatusDescription?: string | undefined;
    /** Value representing the order status. */
    orderStatusValue?: string | undefined;
    /** Status of the drug associated with the order. */
    onDrugStatus?: string | undefined;
    /** Indicates if the order is the initial one. */
    isInitial?: boolean;
    /** Identifier for the source system. */
    sourceSystemId?: number | undefined;
    /** Identifier for the patient associated with the order. */
    patientId?: number | undefined;
    /** Indicates if the order is marked as urgent. */
    isUrgent?: boolean;
    /** Short name of the pharmacy associated with the order. */
    pharmacyShortName?: string | undefined;
    /** Preferred name of the patient. */
    patientPreferredName?: string | undefined;
    /** First name of the patient. */
    patientFirstName?: string | undefined;
    /** Last name of the patient. */
    patientLastName?: string | undefined;
    /** External identifier for the patient. */
    externalId?: string | undefined;
    /** Date of birth of the patient. */
    patientDateOfBirth?: DateTime | undefined;
    /** Gender of the patient. */
    patientGender?: string | undefined;
    /** Gender value of the patient. */
    patientGenderValue?: string | undefined;
    /** First line of the patient's address. */
    patientAddressLine1?: string | undefined;
    /** Second line of the patient's address. */
    patientAddressLine2?: string | undefined;
    /** City of the patient's address. */
    patientCity?: string | undefined;
    /** Province of the patient's address. */
    patientProvince?: string | undefined;
    /** Postal code of the patient's address. */
    patientPostalCode?: string | undefined;
    /** Phone number of the patient. */
    patientPhone?: string | undefined;
    /** Cell phone number of the patient. */
    patientCellPhone?: string | undefined;
    /** Work phone number of the patient. */
    patientWorkPhone?: string | undefined;
    /** Email address of the patient. */
    patientEmail?: string | undefined;
    /** Preferred language of the patient. */
    patientPreferredLanguage?: string | undefined;
    /** Preferred language value of the patient. */
    patientPreferredLanguageValue?: string | undefined;
    /** Extension for the patient's work phone. */
    patientWorkPhoneExt?: string | undefined;
    /** Health card number of the patient. */
    patientPrhealthCard?: string | undefined;
    /** Pronouns of the patient. */
    patientPronouns?: string | undefined;
    /** Sets whether the pharmacy can be changed. */
    allowChangePharmacy?: boolean;
    /** Identifier for the pharmacy associated with the order. */
    workflowId?: number;
    /** Identifier for the pharmacy associated with the order. */
    pharmacyId?: number;
    /** Indicates if the patient prefers to be contacted via home phone. */
    patientHomePhonePreferred?: boolean | undefined;
    /** Indicates if the patient prefers to be contacted via cell phone. */
    patientCellPhonePreferred?: boolean | undefined;
    /** Indicates if the patient prefers to be contacted via work phone. */
    patientWorkPhonePreferred?: boolean | undefined;
    /** Every phone number Kroll holds for this patient at the order's pharmacy, each with Kroll's
own label. Empty when the patient is not linked to Kroll there, in which case the header
falls back to PatientPhone / PatientCellPhone /
PatientWorkPhone. */
    patientKrollContacts?: PatientKrollContactDto[];
    /** When this patient's data was last pulled from Kroll, or null if never pulled.
            
Carried on the order because Order Details builds its patient header from the order and
never loads the patient record, so without these the "Last refreshed from Kroll" line
cannot render there at all (#35797). */
    patientLastKrollRefreshedAt?: DateTime | undefined;
    /** Display name of the user who performed that pull, or null if never pulled. */
    patientLastKrollRefreshedBy?: string | undefined;
    /** Indicates if the pharmacy wants to default transfering patient to kroll. */
    defaultTransferToKroll?: boolean;
    /** The type of the shipment. */
    shipmentTypeValue?: string | undefined;
    /** The date of the pickup. */
    expectedPickupAt?: DateTime | undefined;
    /** The follow-up date for the next order, if applicable. */
    nextOrderFollowUpAt?: DateTime | undefined;
    /** The date when the current treatment is expected to run out for the next order. */
    nextOrderTreamentRunOutAt?: DateTime | undefined;
    /** Gets or sets the unique identifier for the patient in the Kroll system. */
    patientKrollId?: number | undefined;
    /** Gets or sets the name of the workflow. */
    workflowName?: string | undefined;
    /** Gets or sets the date when the order was manually verified. */
    manualRxVerifiedAt?: DateTime | undefined;
    /** Gets or sets the date when the order was verified */
    rxVerifiedAt?: DateTime | undefined;
    /** Gets or sets the date when the current treatment is expected to run out. */
    treatmentRunOutAt?: DateTime | undefined;
    /** Gets or sets the ID of the previous order. */
    previousOrderId?: number | undefined;
    /** Gets or sets the reason why the order was created. */
    orderCreatedReasonValue?: string | undefined;
    /** Indicates whether the order is valid. */
    isValid?: boolean;
    /** Gets the name of the requestor of the order. */
    requestorName?: string | undefined;
    /** Gets the email of the requestor of the order. */
    requestorEmail?: string | undefined;
    /** Gets the email address of the program's shared inbox, supplied per order in the Order API payload.
Null when the payload omitted it. */
    programEmail?: string | undefined;
    /** Indicates if this order was a replacement order created after a group order had an issue. */
    isReplacementOrder?: boolean;
    /** Gets or sets a value indicating whether screening is required. */
    isScreeningRequired?: boolean;
    /** Gets or sets the date and time when the prescription was confirmed. */
    rxReceivedConfirmedAt?: DateTime | undefined;
    /** Gets or sets the date and time when the coverage was confirmed. */
    coverageConfirmedAt?: DateTime | undefined;
    /** Gets or sets a value indicating whether the next order is required. */
    nextOrderRequired?: boolean;
    /** Gets or sets the reason identifier for why the next order is not required. */
    nextOrderNotRequiredReasonId?: number | undefined;
    /** Gets or sets the last follow-up date. */
    lastFollowUpDate?: DateTime | undefined;
    /** Gets or sets a value indicating whether the order is a group shipment order. */
    isGroupShipmentOrder?: boolean;
    /** Gets or sets the estimated date and time when the first contact is expected to occur. */
    estimatedFirstContactAt?: DateTime | undefined;
    /** Gets or sets the type of workflow associated with the current instance. */
    workflowType?: string | undefined;
}

/** One phone number Kroll holds for a patient, with the label Kroll carries for it. */
export interface PatientKrollContactDto {
    /** The contact row identifier, for stable list tracking in the UI. */
    id?: number;
    /** Kroll's own label for the number. Free text typed by pharmacy staff ("Home", "Office",
"iPhone"), falling back to the line type ("Telephone", "Mobile") when Kroll holds no
description. Display only — it must never be parsed or mapped onto a fixed set. */
    phoneType?: string | undefined;
    /** The phone number, digits only. */
    phoneNumber?: string;
    /** The extension for this number, if Kroll supplied one. */
    extension?: string | undefined;
}

/** Response model for the order screen query, containing order confirmation details. */
export interface GetOrderScreenQueryResponse {
    /** The unique identifier of the order. */
    orderId?: number;
    /** The date and time when prescription receipt was confirmed, if confirmed. */
    rxReceivedConfirmedAt?: DateTime | undefined;
    /** The date and time when coverage was confirmed, if confirmed. */
    coverageConfirmedAt?: DateTime | undefined;
    /** The first name of the user who confirmed prescription receipt. */
    rxReceivedConfirmedByFirstName?: string | undefined;
    /** The last name of the user who confirmed prescription receipt. */
    rxReceivedConfirmedByLastName?: string | undefined;
    /** The first name of the user who confirmed coverage. */
    coverageConfirmedByFirstName?: string | undefined;
    /** The last name of the user who confirmed coverage. */
    coverageConfirmedByLastName?: string | undefined;
    /** Optional Kroll ID of the patient associated with the order. */
    patientKrollId?: number | undefined;
    /** The short name of the pharmacy associated with the order. */
    pharmacyShortName?: string | undefined;
    /** The unique identifier of the pharmacy associated with the order. */
    pharmacyId?: number | undefined;
    /** The unique identifier of the patient associated with the order. */
    patientId?: number | undefined;
}

/** Command to update the initial status of an order. */
export interface UpdateOrderInitialStatusCommand {
    /** The identifier of the order to update. */
    id?: number;
    /** The new initial status value. */
    isInitial?: boolean;
}

/** Response returned after successfully accepting an order. */
export interface AcceptOrderCommandResponse {
    /** The unique identifier of the accepted order. */
    orderId?: number;
    /** Any warnings for failed attachment uploads. */
    attachmentWarnings?: string[];
}

/** Command to accept an order. */
export interface AcceptOrderCommand {
    /** The identifier of the order to update. */
    id?: number;
    /** Flag to indicate if the patient to be transferred to Kroll or not. */
    transferPatientToKroll?: boolean;
}

/** Command to update the order screen. */
export interface UpdateOrderScreenCommand {
    /** The ID of the order to update. */
    orderId?: number;
    /** The date and time when the Rx was received and confirmed. */
    rxReceivedConfirmedAt?: DateTime | undefined;
    /** The date and time when the coverage was confirmed. */
    coverageConfirmedAt?: DateTime | undefined;
    /** Optional Kroll ID of the patient associated with the order. */
    patientKrollId?: number | undefined;
}

/** Represents the response for creating a follow-up command. */
export interface CreateFollowupCommandResponse {
    /** The ID of the follow-up. */
    id?: number;
}

/** Command to create a follow-up for an order. */
export interface CreateFollowupCommand {
    /** The ID of the order. */
    orderId?: number;
    /** The value of the reason for the delay. */
    delayReasonValue?: string;
    /** The date and time when the call was attempted. */
    callAttemptedAtUtc?: DateTime | undefined;
    /** The date and time for the next follow-up. */
    nextFollowupAtUtc?: DateTime;
    /** The date and time for the treatment run-out */
    treatmentRunOutAtUtc?: DateTime | undefined;
    /** Additional notes for the follow-up. */
    notes?: string | undefined;
}

/** Command to assign multiple orders to a specific user. */
export interface CreateUserOrderAssignmentCommand {
    /** The ID of the user to assign the orders to. */
    userId?: number;
    /** The list of order IDs to be assigned. */
    orderIds?: number[];
}

/** Response returned after successfully creating a new order record in the system. */
export interface CreateNewPatientOrderCommandResponse {
    /** Int64The id of the newly created order record. */
    orderId?: number;
}

/** Command to create a new order with patient data in the system. */
export interface CreateNewPatientOrderCommand {
    pharmacyId?: number;
    workflowId?: number;
    /** Gets or sets the identifier of the source system associated with this patient external reference id. */
    sourceSystemId?: number | undefined;
    /** Gets or sets the external unique immutable ID of the source system sending the order.
For example, in 360 this would be the Record GUID of the patient enrollment record.
For non 360 systems, this should be a unique identifier for the patient record in the source system to ensure idempotency and proper linking of orders to patients. */
    sourceSystemExternalId?: string | undefined;
    /** Gets or sets the external reference identifier for the source system. e.g. In 360 this would be the PSP ID. */
    sourceSystemExternalReferenceId?: string | undefined;
    firstName: string;
    lastName: string;
    preferredName?: string | undefined;
    preferredLanguage?: string | undefined;
    dateOfBirth?: DateTime;
    gender: string;
    healthCardNumber?: string | undefined;
    homePhone?: string | undefined;
    cellPhone?: string | undefined;
    workPhone?: string | undefined;
    workPhoneExtension?: string | undefined;
    email?: string | undefined;
    homePhonePreferred?: boolean | undefined;
    cellPhonePreferred?: boolean | undefined;
    workPhonePreferred?: boolean | undefined;
    estimatedTreatmentStartDate?: DateTime | undefined;
    homeAddress1?: string | undefined;
    homeAddress2?: string | undefined;
    homeCity?: string | undefined;
    homeProvince: string;
    homePostalCode?: string | undefined;
    requestorName?: string | undefined;
    requestorEmail?: string | undefined;
    drugs?: InternalDrugDto[];
}

/** Drug information included in an integration order request. */
export interface DrugDto {
    /** (Required) The name of the drug or medication. */
    drugCode: string;
    /** (Optional) The dispense type code (e.g., "RX", "OTC"). For more enum, please access enum endpoint */
    dispenseType?: string | undefined;
    /** (Optional) Human-readable description of the dispense type. */
    dispenseTypeDescription?: string | undefined;
    /** (Required) The patient's current status with respect to this drug (e.g., "STARTING", "CONTINUING"). For more enum, please access enum endpoint */
    onDrugStatus: string;
}

export interface InternalDrugDto extends DrugDto {
    drugId?: number | undefined;
}

/** Command to change the pharmacy associated with an order. */
export interface UpdateOrderPharmacyCommand {
    /** The ID of the order to update. */
    id?: number;
    /** The ID of the new pharmacy to associate with the order. */
    pharmacyId?: number;
    /** Indicates whether the patient has consented to transfer their prescription history. */
    patientRxHistoryTransferConsented?: boolean;
}

/** Response for the UpdateOrderPatientCommand. */
export interface UpdateOrderPatientCommandResponse {
    /** The id of the order affected. */
    orderId?: number;
}

/** Command to update the patient associated with an order. */
export interface UpdateOrderPatientCommand {
    /** The unique identifier of the order to update. */
    id?: number;
    /** The unique identifier of the patient to associate with the order. */
    patientId?: number;
    /** Indicates if the patient association is an exact match on the PatientExternalReference.SourceSystemExternalId.
If true, a new PatientExternalReference will be created if a non-duplicate does not already exist. */
    exactMatch?: boolean;
}

/** Response model for the order follow up notes query, containing order follow up notes. */
export interface GetOrderNotesQueryResponse {
    /** The unique identifier of the follow up. */
    followUpId?: number;
    /** The unique identifier of the order. */
    orderId?: number;
    /** The date and time when the follow up was last updated (or masked representation). */
    lastUpdated?: any;
    /** The email of the user who last updated the follow up. */
    lastUpdatedBy?: string;
    /** Indicates if this is the initial counsel. */
    initialCounsel?: boolean;
    /** Indicates if sensitive information is masked. */
    isMasked?: boolean;
    /** The follow up note text. */
    notes?: string | undefined;
    /** Reason for delay */
    reasonForDelayDescription?: string | undefined;
    /** French reason for delay */
    reasonForDelayDescriptionFr?: string | undefined;
    /** Date call attempted (or masked representation). */
    callAttempted?: any | undefined;
    /** Indicates if this note is from an AdHoc order */
    isFromAdHocOrder?: boolean | undefined;
    /** The order status value (only populated when IncludePreviousOrderNotes is true) */
    orderStatusValue?: string | undefined;
    /** The order status description (only populated when IncludePreviousOrderNotes is true) */
    orderStatusDescription?: string | undefined;
    /** The short name of the pharmacy associated with the order */
    pharmacyShortName?: string | undefined;
}

export enum NoteType {
    FOLLOW_UP = 1,
    CLINICAL = 2,
    COMMERCIALIZATION = 3,
}

/** Command to update the order PickUp. */
export interface UpdateOrderPickUpCommand {
    /** The ID of the order to update. */
    orderId?: number;
    /** The date and time when the Rx was picked up. */
    pickedUpAtUtc?: DateTime | undefined;
}

/** Command to update the order when no next order is required. */
export interface UpdateOrderNoNextOrderCommand {
    /** The ID of the order to update. */
    orderId?: number;
    /** The reason next order is not required. */
    nextOrderNotRequiredReason?: NextOrderNotRequiredReason;
    /** Other reason next order is not required. */
    otherReasonNextOrderNotRequired?: string | undefined;
}

export enum NextOrderNotRequiredReason {
    TRANSFER_TO_EXTERNAL_PHARMACY = 1,
    PATIENT_THERAPY_DISCONTINUED = 2,
    OTHER = 3,
    PATIENT_THERAPY_COMPLETED = 4,
    PATIENT_THERAPY_ON_HOLD = 5,
    AWAITING_APPOINTMENT_CONFIRMATION = 6,
}

/** Command to create the next order in the system. */
export interface CreateNextOrderCommand {
    /** The ID of the current order. */
    orderId?: number;
    /** The follow-up date for the next order. */
    nextOrderFollowUpDate?: DateTime;
    /** The treatment run-out date for the next order. */
    nextOrderTreatmentRunOutDate?: DateTime;
}

/** Represents the response for the GetNextOrderDates query. */
export interface GetNextOrderDatesQueryResponse {
    /** Unique identifier for the order. */
    id?: number;
    /** Follow up date for the next order. */
    nextOrderFollowUpAtUtc?: DateTime | undefined;
    /** Date treament will run out for the next order. */
    nextOrderTreamentRunOutAtUtc?: DateTime | undefined;
    /** The user who last modified the follow-up date for the next order. */
    nextOrderFollowUpModifiedBy?: string | undefined;
    /** The UTC timestamp of when the follow-up date for the next order was last modified. */
    nextOrderFollowUpModifiedAtUtc?: DateTime | undefined;
    /** The user who last modified the treatment run-out date for the next order. */
    nextOrderTreatmentRunOutModifiedBy?: string | undefined;
    /** The UTC timestamp of when the treatment run-out date for the next order was last modified. */
    nextOrderTreatmentRunOutModifiedAtUtc?: DateTime | undefined;
}

/** Response to the command to update an order drug info. */
export interface UpdateOrderDrugInfoCommandResponse {
    /** The updated OrderId */
    orderId?: number;
}

/** Command to update the drug details of an order. */
export interface UpdateOrderDrugInfoCommand {
    /** The ID of the order to update. */
    orderId?: number;
    /** The number of days the drug supply should last. */
    daysSupply?: number;
    /** Flag to determine if this is the last refill. */
    isLastRefill?: boolean;
}

/** Command to update an order's status */
export interface UpdateOrderStatusCommand {
    /** The unique identifier of the order to update */
    orderId?: number;
    /** The new status value to assign to the order */
    orderStatus?: string;
}

/** Represents the response for updating an order shipment type. */
export interface UpdateOrderShipmentTypeCommandResponse {
    /** The unique identifier of the updated order. */
    orderId?: number;
}

/** Command to update an order's shipment type and expected pickup date */
export interface UpdateOrderShipmentTypeCommand {
    /** The ID of the order to update */
    orderId?: number;
    /** The new shipment type value */
    shipmentType?: string;
    /** The expected pickup date (optional) */
    pickUpDateUtc?: DateTime | undefined;
}

/** Command to create a new order item within an existing order drug. This associates a specific drug details record with an order drug and specifies quantity and dispense type. */
export interface CreateOrderItemCommand {
    /** The ID of the drug details that identifies the specific drug configuration. */
    drugDetailsId?: number;
    /** The quantity of the drug to be ordered. */
    quantity?: number;
    /** The value identifier for the dispense type to be used. */
    actualDispenseTypeValue?: string | undefined;
    /** The ID of the order to create the item for. */
    orderId?: number;
}

/** Command to update an existing order item with new drug details and quantity */
export interface UpdateOrderItemCommand {
    /** The ID of the order item to update */
    id?: number;
    /** The ID of the order drug */
    orderDrugId?: number | undefined;
    /** The ID of the new drug details to associate with the order item */
    drugDetailsId?: number;
    /** The new quantity for the order item */
    quantity?: number;
    /** The type of the dispense */
    actualDispenseTypeValue?: string | undefined;
    /** The id of the order */
    orderId?: number;
}

/** Command to delete an order item from the system by its ID. */
export interface DeleteOrderItemsCommand {
    /** The list of unique identifiers of the order items to delete. */
    ids?: number[];
}

/** Represents the response for creating shipment items. */
export interface CreateOrderShipmentCommandResponse {
    /** The unique identifiers of the created shipment items. */
    shipmentItemIds?: number[];
}

/** Command to create an order shipment. */
export interface CreateOrderShipmentCommand {
    /** The IDs of the shipments. */
    shipmentIds?: number[];
    /** The ID of the order. */
    orderId?: number;
}

/** Response for the ScheduleShipment operation containing IDs of all created entities. */
export interface ScheduleShipmentCommandResponse {
    /** The order ID that was scheduled. */
    orderId?: number;
    /** IDs of newly created shipments. */
    createdShipmentIds?: number[];
    /** IDs of newly created shipment-order links. */
    createdShipmentItemIds?: number[];
    /** IDs of newly created tracking numbers. */
    createdTrackNumberIds?: number[];
}

/** Composite command that atomically schedules a shipment for an order within a single database transaction. Wraps drug info update, order item CRUD, shipment type, next order follow-up, shipment CRUD, tracking numbers, notes, status update, and assignment update into one all-or-nothing operation. */
export interface ScheduleShipmentCommand {
    /** The ID of the order to schedule. */
    orderId?: number;
    /** Drug information to update (always required). */
    drugInfo?: OrderTransactionDrugInfoPayload;
    /** New order items to create. */
    createOrderItems?: OrderTransactionCreateOrderItemPayload[] | undefined;
    /** Existing order items to update. */
    updateOrderItems?: OrderTransactionUpdateOrderItemPayload[] | undefined;
    /** Order item IDs to delete. */
    deleteOrderItemIds?: number[] | undefined;
    /** The shipment type value (always required). */
    shipmentType?: string;
    /** Pickup date if shipment type is PickUp. */
    pickUpDateUtc?: DateTime | undefined;
    /** Next order follow-up information (always required). */
    nextOrderFollowup?: OrderTransactionNextOrderFollowupPayload;
    /** The order status to set (always required). */
    orderStatus?: string;
    /** New shipments to create with optional embedded tracking numbers. */
    createShipments?: OrderTransactionCreateShipmentPayload[] | undefined;
    /** Existing shipments to update. */
    updateShipments?: OrderTransactionUpdateShipmentPayload[] | undefined;
    /** Shipments to unlink and/or delete. */
    deleteShipments?: OrderTransactionDeleteShipmentsPayload | undefined;
    /** Tracking numbers to add to existing shipments. */
    createTrackNumbers?: OrderTransactionCreateTrackNumberPayload[] | undefined;
    /** Tracking number IDs to delete. */
    deleteTrackNumberIds?: number[] | undefined;
    /** Notes to create for the order. */
    notes?: OrderTransactionNotePayload[] | undefined;
    /** When set, notes are created for all orders linked to this group shipment (not just OrderId). */
    groupShipmentId?: number | undefined;
    /** When true, marks the order's DDI review as completed within the transaction. */
    ddiReviewCompleted?: boolean | undefined;
}

/** Drug information to update on the order. */
export interface OrderTransactionDrugInfoPayload {
    /** The number of days the drug supply should last. */
    daysSupply?: number;
    /** Flag to determine if this is the last refill. */
    isLastRefill?: boolean;
}

/** Payload to create a new order item. */
export interface OrderTransactionCreateOrderItemPayload {
    /** The drug details ID for the new order item. */
    drugDetailsId?: number;
    /** The quantity of the drug. */
    quantity?: number;
    /** The actual dispense type value. */
    actualDispenseTypeValue?: string | undefined;
}

/** Payload to update an existing order item. */
export interface OrderTransactionUpdateOrderItemPayload {
    /** The ID of the order item to update. */
    id?: number;
    /** The order drug ID, if known. */
    orderDrugId?: number | undefined;
    /** The drug details ID. */
    drugDetailsId?: number;
    /** The quantity of the drug. */
    quantity?: number;
    /** The actual dispense type value. */
    actualDispenseTypeValue?: string | undefined;
}

/** Next order follow-up information. */
export interface OrderTransactionNextOrderFollowupPayload {
    /** Whether the next order is required. */
    nextOrderRequired?: boolean;
    /** The next follow-up date (UTC). */
    nextOrderFollowUpAtUtc?: DateTime | undefined;
    /** The treatment run-out date (UTC). */
    nextOrderTreamentRunOutAtUtc?: DateTime | undefined;
    /** Reason ID if next order is not required. */
    nextOrderNotRequiredReasonId?: number | undefined;
}

/** Payload to create a new shipment, optionally with tracking numbers. */
export interface OrderTransactionCreateShipmentPayload {
    /** The recipient's attention or name. */
    shipToAttention?: string;
    /** The primary address line. */
    addressLine1?: string;
    /** The secondary address line. */
    addressLine2?: string | undefined;
    /** The city. */
    city?: string;
    /** The province or state. */
    province?: string;
    /** The postal code. */
    postalCode?: string;
    /** The email address. */
    email?: string | undefined;
    /** The phone number. */
    phone?: string | undefined;
    /** The phone extension. */
    phoneExt?: string | undefined;
    /** The courier service. */
    courier?: string | undefined;
    /** Special courier instructions. */
    courierInstruction?: string | undefined;
    /** Whether this is the final destination. */
    isFinalDestination?: boolean;
    /** The scheduled ship date. */
    shipOnAtUtc?: DateTime | undefined;
    /** The expected delivery date. */
    expectedDeliveryAtUtc?: DateTime | undefined;
    /** The pharmacy ID. */
    pharmacyId?: number;
    /** The optional group shipment ID. */
    groupShipmentId?: number | undefined;
    /** Tracking numbers to create for this new shipment. */
    trackingNumbers?: string[] | undefined;
}

/** Payload to update an existing shipment. */
export interface OrderTransactionUpdateShipmentPayload {
    /** The shipment ID to update. */
    id?: number;
    /** The recipient's attention or name. */
    shipToAttention?: string;
    /** The primary address line. */
    addressLine1?: string;
    /** The secondary address line. */
    addressLine2?: string | undefined;
    /** The city. */
    city?: string;
    /** The province or state. */
    province?: string;
    /** The postal code. */
    postalCode?: string;
    /** The email address. */
    email?: string | undefined;
    /** The phone number. */
    phone?: string | undefined;
    /** The phone extension. */
    phoneExt?: string | undefined;
    /** The courier service. */
    courier?: string | undefined;
    /** Special courier instructions. */
    courierInstruction?: string | undefined;
    /** Whether this is the final destination. */
    isFinalDestination?: boolean;
    /** The scheduled ship date. */
    shipOnAt?: DateTime | undefined;
    /** The expected delivery date. */
    expectedDeliveryAt?: DateTime | undefined;
}

/** Payload describing which shipments to unlink and/or hard-delete. */
export interface OrderTransactionDeleteShipmentsPayload {
    /** Shipment IDs to unlink from the order (deletes ShipmentItem records). */
    orderShipmentIds?: number[];
    /** Subset of non-group shipment IDs to hard-delete after unlinking. */
    regularShipmentIds?: number[] | undefined;
}

/** Payload to create a tracking number for an existing shipment. */
export interface OrderTransactionCreateTrackNumberPayload {
    /** The shipment ID to attach the tracking number to. */
    shipmentId?: number;
    /** The tracking number string. */
    trackingNumber?: string;
}

/** Payload to create or update an order note. When UpdateNoteId is set, the existing note is updated instead of creating a new one. */
export interface OrderTransactionNotePayload {
    /** The type of note. */
    noteType?: NoteType;
    /** The note content. */
    note?: string;
    /** Whether this is an initial counseling note. */
    initialCounsel?: boolean;
    /** Whether to check for duplicate notes before creating. */
    checkDuplicate?: boolean;
    /** A regex pattern for duplicate checking. */
    duplicateCheckPattern?: string | undefined;
    /** When set, updates the existing note with this ID instead of creating a new one. */
    updateNoteId?: number | undefined;
    /** When true and the command includes a GroupShipmentId, the note is created for every
order linked to that group shipment — not just the current order. Use this only for notes that
describe a group-level fact (e.g. expected delivery date), which is identical for all orders
sharing the shipment. Order-specific notes (e.g. next follow-up date) must leave this false.
Defaults to false so existing callers that omit the field are never affected. */
    propagateToGroupShipment?: boolean;
}

/** Response for the FollowUpRequired operation containing IDs of all created entities. */
export interface FollowUpRequiredCommandResponse {
    /** The order ID that was processed. */
    orderId?: number;
    /** IDs of newly created shipments. */
    createdShipmentIds?: number[];
    /** IDs of newly created shipment-order links. */
    createdShipmentItemIds?: number[];
    /** IDs of newly created tracking numbers. */
    createdTrackNumberIds?: number[];
}

/** Composite command that atomically processes a follow-up required action for an order within a single database transaction. Wraps an optional delay-reason status update, drug info update, order item CRUD, shipment type, next order follow-up, shipment CRUD, tracking numbers, notes (create and update), and DDI review into one all-or-nothing operation. If any sub-operation fails, all changes are rolled back. Unlike ScheduleShipmentCommand, this command does NOT unassign the user from the order and uses an optional delay reason value as the order status instead of a required status field. */
export interface FollowUpRequiredCommand {
    /** The ID of the order to process. */
    orderId?: number;
    /** Optional delay reason value to set as the order status (e.g. ISSUE_AR, ISSUE_CLINICAL). When null, no status change is made. */
    delayReasonValue?: string | undefined;
    /** Drug information to update (always required). */
    drugInfo?: OrderTransactionDrugInfoPayload;
    /** New order items to create. */
    createOrderItems?: OrderTransactionCreateOrderItemPayload[] | undefined;
    /** Existing order items to update. */
    updateOrderItems?: OrderTransactionUpdateOrderItemPayload[] | undefined;
    /** Order item IDs to delete. */
    deleteOrderItemIds?: number[] | undefined;
    /** Next order follow-up information (always required). */
    nextOrderFollowup?: OrderTransactionNextOrderFollowupPayload;
    /** The shipment type value (always required). */
    shipmentType?: string;
    /** Pickup date if shipment type is PickUp. */
    pickUpDateUtc?: DateTime | undefined;
    /** Shipments to unlink and/or delete. */
    deleteShipments?: OrderTransactionDeleteShipmentsPayload | undefined;
    /** New shipments to create with optional embedded tracking numbers. */
    createShipments?: OrderTransactionCreateShipmentPayload[] | undefined;
    /** Existing shipments to update. */
    updateShipments?: OrderTransactionUpdateShipmentPayload[] | undefined;
    /** Tracking numbers to add to existing shipments. */
    createTrackNumbers?: OrderTransactionCreateTrackNumberPayload[] | undefined;
    /** Tracking number IDs to delete. */
    deleteTrackNumberIds?: number[] | undefined;
    /** Notes to create or update for the order. Notes with UpdateNoteId set will update an existing note. */
    notes?: OrderTransactionNotePayload[] | undefined;
    /** When true, marks the order's DDI review as completed within the transaction. */
    ddiReviewCompleted?: boolean | undefined;
    /** When set, new notes are created for all orders linked to this group shipment (not just OrderId). */
    groupShipmentId?: number | undefined;
}

/** Response model containing drug information for an order. */
export interface GetOrderDrugInfoQueryResponse {
    /** The unique identifier of the order. */
    orderId?: number;
    /** The number of days the medication supply will last. */
    daysSupply?: number | undefined;
    /** Indicates whether this is the final refill for the prescription. */
    isLastRefill?: boolean;
}

/** Response record containing order item information */
export interface GetOrderItemsQueryResponse {
    /** Unique identifier for the order item */
    id?: number;
    /** Identifier of the drug details associated with this order item */
    drugDetailsId?: number;
    /** Quantity of units ordered */
    quantity?: number;
    /** Name of the drug associated with this order item, together with its strength, unit type and DIN */
    drugName?: string;
    /** The product on its own, without the strength, unit type or DIN. Usually the brand name, or the manufacturer and generic name when the drug has no brand */
    productName?: string;
    /** Indicates whether this is an 'other' drug category */
    isOtherDrug?: boolean;
    /** The type of the dispense */
    dispenseType?: string;
    /** The description of the dispense */
    dispenseTypeDescription?: string;
    /** The identifier of the order drug */
    orderDrugId?: number;
    /** The DIN of the order drug */
    din?: string;
}

/** Response object containing order shipment type information */
export interface GetOrderShipmentTypeQueryResponse {
    /** The unique identifier of the order */
    orderId?: number;
    /** The type of shipment for the order */
    shipmentType?: string;
    /** The scheduled pick-up date for the order, if applicable */
    pickUpDate?: DateTime | undefined;
}

/** Represents the response data for an order shipment. */
export interface GetOrderShipmentsQueryResponse {
    /** The unique identifier of the shipment. */
    id?: number;
    /** The unique identifier of the shipment record. */
    shipmentId?: number;
    /** The unique identifier of the associated order. */
    orderId?: number;
    /** The date and time when the shipment is scheduled to be shipped. */
    shipOnAt?: DateTime | undefined;
    /** The value of the courier handling the shipment. */
    courierValue?: string | undefined;
    /** The name or department to which the shipment is addressed. */
    shipToAttention?: string;
    /** The first line of the shipping address. */
    addressLine1?: string;
    /** The second line of the shipping address (optional). */
    addressLine2?: string | undefined;
    /** The city of the shipping address. */
    city?: string;
    /** The province or state of the shipping address. */
    province?: string;
    /** The postal or ZIP code of the shipping address. */
    postalCode?: string;
    /** Special instructions for the courier (optional). */
    courierInstruction?: string | undefined;
    /** The expected delivery date and time (optional). */
    expectedDeliveryAt?: DateTime | undefined;
    /** Indicates if this address is the final destination. */
    isFinalDestination?: boolean;
    /** The contact phone number for the shipment (optional). */
    phone?: string | undefined;
    /** The phone extension for the contact number (optional). */
    phoneExt?: string | undefined;
    /** The contact email address for the shipment (optional). */
    email?: string | undefined;
    /** The name of the courier */
    courierName?: string | undefined;
    /** The group shipment Id (optional). */
    groupShipmentId?: number | undefined;
}

/** Command to remove an order from a group shipment. */
export interface RemoveOrderFromGroupShipmentCommand {
    /** The unique identifier of the order to be deleted from a group shipment. */
    orderId?: number;
}

/** Response model containing group shipments, including the orders. */
export interface GetGroupShipmentOrdersByStatusQueryResponse {
    /** The unique identifier of the group shipment. */
    groupShipmentId?: number;
    /** The name of the group shipment. */
    groupName: string;
    /** The status of the group shipment. */
    groupShipmentStatus?: GroupShipmentStatus;
    /** The description of the group shipment status. */
    groupShipmentStatusDescription: string;
    groupShipmentStatusValue?: string | undefined;
    /** The final destination location of the group shipment. */
    finalDestinationLocation: string;
    /** Most recent timestamp of the group shipment. */
    lastUpdated?: DateTime | undefined;
    /** A list of shipments associated with the group shipment. */
    shipments?: ShipmentDto[];
    /** A list of orders associated with the group shipment. */
    orders?: OrderDto[];
    /** Indicates whether the group shipment is locked. */
    isLocked?: boolean | undefined;
    /** Timestamp when the group shipment was verified. */
    groupVerifiedAt?: DateTime | undefined;
    /** The user who verified the group shipment. */
    groupVerifiedBy?: string | undefined;
    /** The user who last updated the group shipment. */
    lastUpdatedBy?: string | undefined;
    /** Indicates whether the order has a same day group shipment. */
    hasSameDayShipment?: boolean;
    /** The earliest ship date i.e the date that pharmacy needs to ship out of the building */
    earliestShipDate?: DateTime | undefined;
}

export enum GroupShipmentStatus {
    PENDING_ORDERS = 1,
    GROUP_VERIFIED = 2,
    SHIPPED = 3,
    DELIVERED = 4,
    DELIVERY_ISSUE = 5,
}

/** Data transfer object for the order. */
export interface OrderDto {
    orderId?: number;
    workflowName: string;
    patientFirstName: string;
    patientLastName: string;
    patientPreferredName?: string | undefined;
    dateOfBirth?: DateTime | undefined;
    externalId?: string | undefined;
    orderStatusValue: string;
    orderStatusDescription: string;
    lastUpdated?: DateTime;
    lastUpdatedBy?: string | undefined;
    lastFollowUp?: FollowUpDto | undefined;
    isInitial?: boolean;
    groupShipmentId?: number | undefined;
    nextOrderRequired?: boolean;
    nextOrderNotRequiredReasonId?: number | undefined;
}

/** Command to delete shipment items associated with a specific order. */
export interface DeleteOrderShipmentsCommand {
    /** The unique identifier of the order from which to delete shipments. */
    orderId?: number;
    /** A list of shipment identifiers to be deleted from the order. */
    shipmentIds?: number[];
}

/** Command to update an order's verification status. Marks an order as verified by the current user with a timestamp. */
export interface UpdateOrderVerificationCommand {
    /** The unique identifier of the order to be verified */
    orderId?: number;
    /** Was the order verified manually */
    isManualVerification?: boolean;
}

/** Command to ship a regular order. */
export interface ShipRegularOrderCommand {
    /** The unique identifier of the order to be shipped. */
    orderId?: number;
    /** A list of shipment details, including tracking numbers. */
    shipments?: ShipmentTrackNumbersDto[];
}

/** Data transfer object representing shipment tracking numbers. */
export interface ShipmentTrackNumbersDto {
    /** Gets or sets the unique identifier of the shipment. */
    shipmentId?: number;
    /** Gets or sets the collection of tracking numbers associated with the shipment. */
    trackingNumbers?: string[];
    /** Gets or sets the estimated shipping cost for the shipment. */
    estimatedShipCost?: number | undefined;
}

/** Command to ship a group of orders. */
export interface ShipGroupOrdersCommand {
    /** The unique identifier of the group shipment to be processed. */
    groupShipmentId?: number;
    /** A list of shipment details, including tracking numbers. */
    shipments?: ShipmentTrackNumbersDto[];
}

/** Command to update the follow-up and treatment run-out dates for an order. */
export interface UpdateNextOrderFollowupCommand {
    /** The unique identifier of the order to update. */
    orderId?: number;
    /** Value indicating whether the next order is required. */
    nextOrderRequired?: boolean;
    /** The date when the order should be followed up next, or null to clear the date. */
    nextOrderFollowUpAtUtc?: DateTime | undefined;
    /** The date when the current treatment is expected to run out, or null to clear the date. */
    nextOrderTreamentRunOutAtUtc?: DateTime | undefined;
    /** The reason why the next order is not required, or null if not applicable. */
    nextOrderNotRequiredReasonId?: number | undefined;
}

/** Represents the response for the GetPatientOrderHistoryQuery query. */
export interface GetPatientOrderHistoryQueryResponse {
    /** Unique identifier for the order. */
    id?: number;
    /** Date and time when the order was delivered (or masked representation). */
    createdAt?: any;
    /** Description of the order status. */
    orderStatusDescription?: string | undefined;
    /** Value representing the order status. */
    orderStatusValue?: string | undefined;
    /** Short name of the pharmacy associated with the order. */
    pharmacyShortName?: string | undefined;
    /** Identifier for the pharmacy associated with the order. */
    workflowId?: number;
    /** Identifier for the pharmacy associated with the order. */
    pharmacyId?: number;
    /** Gets or sets the name of the workflow. */
    workflowName?: string | undefined;
    /** Gets or sets the collection of follow-up items associated with the order. */
    followUps?: FollowUpDto[] | undefined;
    /** Gets or sets the patient source system external identifier associated with the order. */
    externalId?: string | undefined;
    /** Gets or sets when the order shipped out. */
    dateShipped?: DateTime | undefined;
    /** Gets or sets the date and time when the order was delivered (or masked representation). */
    dateDelivered?: any | undefined;
    /** Gets or sets the date and time when the order was picked up (or masked representation). */
    datePickedUp?: any | undefined;
    /** Gets or sets the products associated with the order. */
    products?: ProductDto[] | undefined;
    /** Gets or sets the date and time when the prescription was received and confirmed. */
    rxReceivedConfirmedAt?: DateTime | undefined;
    /** Gets or sets when the order was accepted. */
    acceptedAt?: DateTime | undefined;
    /** Gets or sets the display name of the user who accepted the order. */
    acceptedBy?: string | undefined;
    /** Gets or sets when the order's screening was completed. */
    screeningCompletedAt?: DateTime | undefined;
    /** Gets or sets the display name of the user who completed the screening. */
    screeningCompletedBy?: string | undefined;
    /** Gets or sets when the prescription was verified (manual verification used as a fallback). */
    rxVerifiedAt?: DateTime | undefined;
    /** Gets or sets the display name of the user who verified the prescription. */
    rxVerifiedBy?: string | undefined;
    /** Gets or sets the date and time when the coverage was confirmed for the order. */
    coverageConfirmedAt?: DateTime | undefined;
    /** Gets or sets the previous order Id. */
    previousOrderId?: number | undefined;
    /** Gets or sets the reason value for why the order was created. */
    orderCreatedReasonValue?: string | undefined;
    /** Gets or sets a value indicating whether screening is required for the order. */
    isScreeningRequired?: boolean;
    /** Gets or sets the group shipment status identifier for the order. */
    groupShipmentStatusId?: number | undefined;
    /** Value representing the delivery issue resolution status. */
    deliveryIssueResolutionValue?: string | undefined;
    /** Gets or sets a value indicating whether sensitive information is masked. */
    isMasked?: boolean;
    /** Gets or sets the shipment attention for the order (or masked representation). */
    shipToAttention?: string | undefined;
    /** Gets or sets the shipment address line 1 for the order (or masked representation). */
    shipmentAddressLine1?: string | undefined;
    /** Gets or sets the shipment address line 2 for the order (or masked representation). */
    shipmentAddressLine2?: string | undefined;
    /** Gets or sets the shipment city for the order (or masked representation). */
    shipmentCity?: string | undefined;
    /** Gets or sets the shipment province for the order (or masked representation). */
    shipmentProvince?: string | undefined;
    /** Gets or sets the shipment postal code for the order (or masked representation). */
    shipmentPostalCode?: string | undefined;
    /** Gets or sets the shipment tracking numbers for the order (or masked representation). */
    shipmentTrackingNumbers?: string[] | undefined;
    /** Gets or sets the courier name for the order (or masked representation). */
    courierName?: string | undefined;
    /** Gets or sets the shipment id for the order. */
    shipmentId?: number | undefined;
    /** Gets or sets the estimated shipping cost for the order. */
    estimatedShipCost?: string | undefined;
}

export interface ProductDto {
    orderItemId?: number;
    orderId?: number;
    quantity?: string;
    drugName?: string;
    isOtherDrug?: boolean;
    dispenseType?: string | undefined;
    din?: string;
    commercialized?: boolean;
}

/** One status transition in an order's history: the status the order moved into, when it moved there, and who made the change. */
export interface GetOrderStatusHistoryQueryResponse {
    /** The status code the order moved into (e.g. RX_VERIFIED). */
    statusValue?: string;
    /** The human-readable description of the status the order moved into. */
    statusDescription?: string;
    /** When the order entered this status (UTC). */
    changedAt?: DateTime;
    /** Display name of the user who moved the order into this status. */
    changedBy?: string;
}

/** Response record for the order drugs query, containing information about drugs associated with an order. */
export interface GetOrderDrugsQueryResponse {
    /** The unique identifier for the order drug record. */
    id?: number;
    /** The identifier of the parent order. */
    orderId?: number;
    /** The optional identifier of the drug. */
    drugId?: number | undefined;
    /** The optional name of the drug. */
    drugName?: string | undefined;
    /** The optional code identifier for the drug. */
    drugCode?: string | undefined;
    /** The optional identifier for the requested dispense type description. */
    requestDispenseTypeDescription?: string | undefined;
    /** The identifier for the drug status description. */
    onDrugStatusDescription?: string | undefined;
    /** Whether the dispense type has a mismatch with the source system. */
    isDispenseTypeMismatch?: boolean;
}

/** Response data transfer object for the drug details select list query. */
export interface GetDrugDetailsSelectListQueryResponse {
    /** The unique identifier of the drug. */
    id?: number;
    /** The name of the drug. */
    name?: string;
    /** The drug identifier. */
    drugId?: number;
    /** The drug DIN. */
    din?: string;
}

/** Command to cancel an order in the system. This operation updates the order status to cancelled, associates an issue type with the cancellation, and optionally adds follow-up notes explaining the cancellation reason. */
export interface CancelOrderCommand {
    /** The unique identifier of the order to be cancelled */
    id?: number;
    /** The value string identifying the issue type for cancellation */
    issueTypeValue?: string;
    /** Optional notes providing additional context about the cancellation */
    followupNote?: string | undefined;
    /** Optional reason for order transfer if applicable */
    orderTransferReasonValue?: string | undefined;
}

export interface CreateAdhocOrderCommandResponse {
    id?: number | undefined;
}

/** Command to create an ad-hoc order. Requires Pharmacy Manager, User, or Administrator role. */
export interface CreateAdhocOrderCommand {
    /** Gets or sets the ID of the patient for whom the ad-hoc order is being created. */
    patientId?: number;
    /** Gets or sets the ID representing the reason for creating this ad-hoc order. */
    adhocOrderReasonId?: number;
}

/** Response model for orders that have been manually verified. */
export interface GetOrdersManuallyVerifiedQueryResponse {
    /** Unique identifier for the order. */
    id?: number;
    /** Name of the workflow associated with the order. */
    workflowName?: string;
    /** First name of the patient. */
    patientFirstName?: string;
    /** Last name of the patient. */
    patientLastName?: string;
    /** Optional external identifier for the order. */
    externalId?: string | undefined;
    /** Timestamp when the prescription was manually verified. */
    manualRxVerifiedAt?: DateTime | undefined;
    /** User who performed the manual verification. */
    manualRxVerifiedBy?: string | undefined;
    /** Current status value of the order. */
    orderStatusValue?: string;
    /** Description of the current order status. */
    orderStatusDescription?: string;
    /** Date the order was last updated. */
    lastUpdated?: DateTime | undefined;
    /** User who last updated the order. */
    lastUpdatedBy?: string | undefined;
}

/** Command to raise an issue on an order and optionally add follow-up details */
export interface RaiseOrderIssueCommand {
    /** The ID of the order to raise an issue on */
    orderId?: number;
    /** The value representing the type of issue being raised */
    issueTypeValue?: string;
    /** Optional notes regarding the follow-up action required */
    followUpNotes?: string;
    /** The date and time when the follow-up should occur (in UTC) */
    followUpDateUtc?: DateTime;
    /** Flag indicating whether the issue is urgent */
    isUrgent?: boolean;
    /** The order status(es) the caller's screen was showing when they clicked Issue (for example the
regular Order Verification list shows READY_TO_BE_VERIFIED and Ready to Ship shows RX_VERIFIED).
When supplied, we hold the order to that set so a screen that has gone out of date is blocked.
Optional: callers that don't send it fall back to the full set of statuses raising an issue is
allowed from. Use this OR ExpectedGroupStatusValue, not both. */
    expectedOrderStatusValues?: string[] | undefined;
    /** The group shipment status the caller's screen was showing, for a group-driven list where the row
is valid as long as its group is still shown (the group Order Verification list shows every order
in a still-pending group, so any of them - already verified, another issue - can be re-issued).
When supplied, freshness is judged by the group's status instead of the order's. */
    expectedGroupStatusValue?: string | undefined;
}

/** Command to reschedule an order, which marks it as urgent, updates the order status, clears scheduled shipment dates, and optionally adds a follow-up note. */
export interface RescheduleOrderCommand {
    /** The ID of the order to be rescheduled */
    orderId?: number;
    /** Optional notes to be added as a follow-up record for the order */
    followUpNotes?: string;
}

/** Command to create a new follow-up note for an order. */
export interface CreateNoteCommand {
    /** The ID of the order to which the note belongs. */
    orderId?: number;
    /** The Id of the note type from the EnumNoteType. */
    noteType?: NoteType;
    /** The content of the note. */
    note?: string;
    /** Indicates if this is the initial counseling note. */
    initialCounsel?: boolean;
    /** Indicates if duplicate notes should be checked before creation. */
    checkDuplicate?: boolean;
    /** A string pattern to use to check for duplicates. */
    duplicateCheckPattern?: string | undefined;
}

/** Command to update a note on a followup */
export interface UpdateNoteCommand {
    /** The unique identifier of the followup to update */
    id?: number;
    /** The new note content to set */
    note?: string;
}

/** Represents the response for the GetNextFollowupDateQuery, containing the next follow-up date in UTC. */
export interface GetNextFollowupDateQueryResponse {
    /** Next follow-up date in UTC */
    nextFollowupDateUtc?: DateTime | undefined;
}

/** Command to reschedule a group shipment order by marking it as urgent, changing its status to ISSUE_RESCHEDULE, and removing the associated shipment items */
export interface RescheduleGroupShipmentOrderCommand {
    /** The ID of the order to be rescheduled */
    orderId?: number;
    /** Optional notes for follow-up actions */
    followUpNotes?: string;
}

/** Command to update the user assignment for an order. When a user ID is provided, the order is assigned to that user. When no user ID is provided (null), the order is unassigned. */
export interface UpdateUserOrderAssignmentCommand {
    /** The ID of the order to update the assignment for */
    orderId?: number;
    /** The ID of the user to assign to the order, or null to remove assignment */
    userId?: number | undefined;
}

/** Parent response record at the patient + workflow level. */
export interface GetOrdersForCommercializationParentResponse {
    /** The unique identifier of the patient. */
    patientId?: number;
    /** The identifier of the workflow. */
    workflowId?: number;
    /** The name of the workflow. */
    workflowName?: string;
    /** The first name of the patient. */
    patientFirstName?: string;
    /** The last name of the patient. */
    patientLastName?: string;
    /** The most recent fill date across all child order items, where each child fill date is itself the earliest KrollTransaction fill date for that order item. */
    lastFillDate?: DateTime | undefined;
    /** The most recent modification date across all child order items/commercialization notes. */
    dateLastUpdated?: DateTime;
    /** The full name of the user who made the most recent update across child order items/commercialization notes. */
    lastUpdatedBy?: string | undefined;
    /** Comma-separated active external reference IDs from the PatientExternalReference table. */
    externalId?: string | undefined;
    /** The child order item records. */
    items?: GetOrdersForCommercializationChildResponse[];
}

/** Child response record at the order item level. */
export interface GetOrdersForCommercializationChildResponse {
    /** The unique identifier of the order. */
    orderId?: number;
    /** The unique identifier of the order item. */
    orderItemId?: number;
    /** The most recent fill date of the order item, sourced from the KrollTransaction entity. */
    fillDate?: DateTime | undefined;
    /** The drug details display name. */
    product?: string;
    /** The value code of the commercialization status. */
    commercializationStatusValue?: string | undefined;
    /** The description of the commercialization status. */
    commercializationStatusDescription?: string | undefined;
    /** The value code of the AR status. */
    arStatusValue?: string | undefined;
    /** The description of the AR status. */
    arStatusDescription?: string | undefined;
    /** The AR follow-up date. */
    arFollowUpDate?: DateTime | undefined;
    /** The value code of the order status. */
    orderStatusValue?: string;
    /** The description of the order status. */
    orderStatusDescription?: string;
    /** The most recent modification date of the order item. */
    dateLastUpdated?: DateTime;
    /** The full name of the user who last updated the order item. */
    lastUpdatedBy?: string | undefined;
}

/** Selects which commercialization list tab to return. Placement is driven solely by the order item's commercialization status category: no status yet routes to Open, a status that is not marked closed routes to Pending, and a status marked closed routes to Closed. */
export enum CommercializationTab {
    Open = 0,
    Pending = 1,
    Closed = 2,
}

/** Determines which date field the from/to range filters are applied against on the commercialization orders list. */
export enum CommercializationDateFilterField {
    LastFillDate = 0,
    ArFollowUpDate = 1,
}

/** Represents the response data structure for followup orders queries. */
export interface GetFollowupOrdersQueryResponse {
    /** The unique identifier of the order. */
    id?: number;
    /** The name of the workflow associated with this order. */
    workflowName?: string;
    /** The first name of the patient. */
    patientFirstName?: string;
    /** The last name of the patient. */
    patientLastName?: string;
    /** The preferred name of the patient, if any. */
    patientPreferredName?: string | undefined;
    /** The date of birth of the patient. */
    dateOfBirth?: DateTime | undefined;
    /** An external identifier for the order. */
    externalId?: string | undefined;
    /** The estimated date and time when the treatment is expected to start. */
    estTreatmentStartAt?: DateTime | undefined;
    /** The current status value of the order. */
    orderStatusValue?: string;
    /** The description of the current order status. */
    orderStatusDescription?: string;
    /** Indicates whether the order is marked as urgent. */
    isUrgent?: boolean;
    /** Indicates whether this is an initial order. */
    isInitial?: boolean;
    /** The estimated date and time for the first contact with the patient. */
    estimatedFirstContactAt?: DateTime | undefined;
    /** The date and time when the current treatment is expected to run out. */
    treatmentRunOutAt?: DateTime | undefined;
    /** The name or identifier of the person this order is assigned to. */
    assignedTo?: string | undefined;
    /** The date and time when the order was last updated. */
    lastUpdated?: DateTime;
    /** Information about the most recent follow-up for this order. */
    lastFollowUp?: FollowUpDto | undefined;
    /** The name or identifier of the person who last updated this order. */
    lastUpdatedBy?: string | undefined;
    /** The date and time when receipt of the prescription was confirmed. */
    rxReceivedConfirmedAt?: DateTime | undefined;
    /** The date and time when insurance coverage was confirmed. */
    coverageConfirmedAt?: DateTime | undefined;
    /** The date and time when the order was created. */
    createdAt?: DateTime;
    /** Determines if screening is required for this order. */
    isScreeningRequired?: boolean;
    /** The preferred language of the patient. */
    patientPreferredLanguageValue?: string | undefined;
    /** The unique identifier of the workflow associated with this order. */
    workflowId?: number;
}

/** Response model for requested orders query containing order and patient information */
export interface GetRequestedOrdersQueryResponse {
    /** The unique identifier of the order */
    id?: number;
    /** The name of the workflow associated with the order */
    workflowName?: string;
    /** The first name of the patient */
    patientFirstName?: string;
    /** The last name of the patient */
    patientLastName?: string;
    /** The preferred name of the patient, if specified */
    patientPreferredName?: string | undefined;
    /** The patient's date of birth */
    dateOfBirth?: DateTime | undefined;
    /** External identifier for the order or patient */
    externalId?: string | undefined;
    /** The date and time when the order was created */
    createdAt?: DateTime;
    /** The estimated treatment start date and time */
    estTreatmentStartAt?: DateTime | undefined;
    /** Any special instructions for the order */
    specialInstructions?: string | undefined;
    /** The current status value of the order */
    orderStatusValue?: string;
    /** A description of the order's current status */
    orderStatusDescription?: string;
    /** Indicates if the order is marked as urgent */
    isUrgent?: boolean;
    /** Indicates if this is an initial order */
    isInitial?: boolean;
    /** The date and time when the order was last updated */
    lastUpdated?: DateTime;
    /** The user who last updated the order */
    lastUpdatedBy?: string | undefined;
    /** The name of the person who requested the order */
    requestorName?: string | undefined;
    /** The estimated date and time for first patient contact */
    estimatedFirstContactAt?: DateTime | undefined;
    /** The date and time when the treatment is expected to run out */
    treatmentRunOutAt?: DateTime | undefined;
    /** Information about the most recent follow-up for this order */
    lastFollowUp?: FollowUpDto | undefined;
    /** The name or identifier of the person this order is assigned to */
    assignedTo?: string | undefined;
    /** Whether this order's service-level deadline (request date plus two business days, brought
forward to the treatment start date if that comes sooner) has already passed, in the pharmacy's
local time. Mirrors RequestsToBeAcknowledgedCardProvider.CountWaiting so the Requests to be
Acknowledged tile's Overdue / Pending counts and this list's Overdue / Pending filter agree on the
same split. False (never overdue) when the pharmacy has no province to place a deadline in. */
    isOverdue?: boolean;
}

/** Response record for the RX verification orders query */
export interface GetRxVerificationOrdersQueryResponse {
    /** The unique identifier of the order */
    id?: number;
    /** Name of the workflow associated with the order */
    workflowName?: string;
    /** Patient's first name */
    patientFirstName?: string;
    /** Patient's last name */
    patientLastName?: string;
    /** Patient's preferred name if available */
    patientPreferredName?: string | undefined;
    /** Patient's date of birth */
    dateOfBirth?: DateTime | undefined;
    /** External identifier for the order */
    externalId?: string | undefined;
    /** Current status value of the order */
    orderStatusValue?: string;
    /** Description of the current order status */
    orderStatusDescription?: string;
    /** Indicates whether this is an initial order */
    isInitial?: boolean;
    /** Timestamp of when the order was last updated */
    lastUpdated?: DateTime;
    /** List of shipment details associated with the order */
    shipmentData?: ShipmentDto[];
    /** Expected date for order pickup */
    expectedPickUpDate?: DateTime | undefined;
    /** User who last updated the order */
    lastUpdatedBy?: string | undefined;
    /** Indicates whether the order has same-day shipment */
    hasSameDayShipment?: boolean;
    /** Ship date of the first leg out of the pharmacy (final-destination date for a non-relay order) */
    earliestShipDate?: DateTime | undefined;
    /** Courier of the first leg out of the pharmacy (final-destination courier for a non-relay order) */
    firstLegCourierName?: string | undefined;
    /** Delivery city of the first leg out of the pharmacy (final-destination city for a non-relay order) */
    firstLegShipCity?: string | undefined;
}

/** Response for the GetReadyToShipOrders query containing orders that are ready to ship */
export interface GetReadyToShipOrdersQueryResponse {
    /** The unique identifier of the order */
    id?: number;
    /** The name of the workflow the order belongs to */
    workflowName?: string;
    /** The first name of the patient */
    patientFirstName?: string;
    /** The last name of the patient */
    patientLastName?: string;
    /** The preferred name of the patient, if available */
    patientPreferredName?: string | undefined;
    /** The patient's date of birth, if available */
    dateOfBirth?: DateTime | undefined;
    /** The external identifier for the order, if available */
    externalId?: string | undefined;
    /** Indicates whether this is the initial order */
    isInitial?: boolean;
    /** The date and time when the order was last updated */
    lastUpdated?: DateTime;
    /** Collection of shipment information associated with the order */
    shipmentData?: ShipmentDto[];
    /** The user who last updated the order, if available */
    lastUpdatedBy?: string | undefined;
    /** Indicates whether the order has same-day shipment */
    hasSameDayShipment?: boolean;
    /** The earliest ship date i.e the date that pharmacy needs to ship out of the building */
    earliestShipDate?: DateTime | undefined;
    /** When a patient-pickup order (no shipment) was actually picked up. Exposed alongside
ExpectedPickupAt so the list can fall back to the same due date the dashboard
tile uses for a shipment-less order: EarliestShipDate, then ActualPickupAt, then ExpectedPickupAt. */
    actualPickupAt?: DateTime | undefined;
    /** When a patient-pickup order (no shipment) is scheduled to be picked up. */
    expectedPickupAt?: DateTime | undefined;
    /** The courier of the leg that leaves the pharmacy first (same selection as the Courier - Orders
Shipping Today tile), so a click on that tile's courier row can filter this list to the exact
same orders it counted. Null for a patient-pickup order with no shipment. */
    firstLegCourierId?: number | undefined;
}

/** Response model containing data for pending delivery orders */
export interface GetPendingDeliveryOrdersQueryResponse {
    /** The unique identifier of the order */
    id?: number;
    /** The identifier of the workflow associated with this order */
    workflowId?: number;
    /** The name of the workflow associated with this order */
    workflowName?: string;
    /** The patient's first name */
    patientFirstName?: string;
    /** The patient's last name */
    patientLastName?: string;
    /** The patient's preferred name, if available */
    patientPreferredName?: string | undefined;
    /** The patient's date of birth, if available */
    dateOfBirth?: DateTime | undefined;
    /** An external identifier for the order, if available */
    externalId?: string | undefined;
    /** Indicates whether this is an initial order */
    isInitial?: boolean;
    /** The timestamp when the order was last updated */
    lastUpdated?: DateTime;
    /** Collection of shipment information associated with this order */
    shipmentData?: ShipmentDto[];
    /** The user who last updated the order, if available */
    lastUpdatedBy?: string | undefined;
    /** Indicates whether the order has a same-day shipment option */
    hasSameDayShipment?: boolean;
    /** The earliest date when the shipment can occur, if available */
    earliestShipDate?: DateTime | undefined;
}

/** Response record for pickup orders query containing essential order and patient information. */
export interface GetPickupOrdersQueryResponse {
    /** The unique identifier of the pickup order. */
    id?: number;
    /** The identifier of the associated workflow. */
    workflowId?: number;
    /** The name of the workflow this order belongs to. */
    workflowName?: string;
    /** The patient's first name. */
    patientFirstName?: string;
    /** The patient's last name. */
    patientLastName?: string;
    /** The patient's preferred name, if available. */
    patientPreferredName?: string | undefined;
    /** The patient's date of birth. */
    dateOfBirth?: DateTime | undefined;
    /** An external identifier for the order, if available. */
    externalId?: string | undefined;
    /** Indicates whether this is an initial pickup order. */
    isInitial?: boolean;
    /** The date and time when the order was last updated. */
    lastUpdated?: DateTime;
    /** The expected date for order pickup, if scheduled. */
    expectedPickUpDate?: DateTime | undefined;
    /** The user who last updated the order information. */
    lastUpdatedBy?: string | undefined;
}

/** Represents the response model for delivery issue orders query containing order details and shipment information. */
export interface GetDeliveryIssueOrdersQueryResponse {
    /** The unique identifier of the order */
    id?: number;
    /** The identifier of the workflow associated with the order */
    workflowId?: number;
    /** The name of the workflow associated with the order */
    workflowName?: string;
    /** The first name of the patient */
    patientFirstName?: string;
    /** The last name of the patient */
    patientLastName?: string;
    /** The preferred name of the patient, if specified */
    patientPreferredName?: string | undefined;
    /** The date of birth of the patient */
    dateOfBirth?: DateTime | undefined;
    /** The external identifier for the order, if available */
    externalId?: string | undefined;
    /** Indicates whether this is an initial order */
    isInitial?: boolean;
    /** The date and time when the order was last updated */
    lastUpdated?: DateTime;
    /** The list of shipment information related to the order */
    shipmentData?: ShipmentDto[];
    /** The identifier of the user who last updated the order */
    lastUpdatedBy?: string | undefined;
    /** Indicates whether the order has same-day shipment */
    hasSameDayShipment?: boolean;
    /** The earliest date the shipment can be made. */
    earliestShipDate?: DateTime | undefined;
}

/** Command to report a delivery issue for an order and create a replacement order. */
export interface ReportOrderDeliveryIssueCommand {
    /** The ID of the order with the delivery issue */
    orderId?: number;
    /** The type of delivery issue encountered */
    issueTypeValue?: string;
    /** Optional notes for follow-up actions */
    followUpNotes?: string;
    /** Indicates whether to create a replacement order */
    createReplacementOrder?: boolean;
    /** Optional notes for the replacement order follow-up */
    replacementOrderFollowUpNotes?: string | undefined;
}

/** Response model for group shipment replacement orders query containing order and patient details. */
export interface GetRelatedGroupReplacementOrdersQueryResponse {
    /** The unique identifier for the order. */
    id?: number;
    /** The identifier for the associated workflow. */
    workflowId?: number;
    /** The name of the associated workflow. */
    workflowName?: string;
    /** The first name of the patient. */
    patientFirstName?: string;
    /** The last name of the patient. */
    patientLastName?: string;
    /** The preferred name of the patient. */
    patientPreferredName?: string | undefined;
    /** The patient's date of birth. */
    dateOfBirth?: DateTime | undefined;
    /** External identifier for the order, if available. */
    externalId?: string | undefined;
    /** Indicates whether this is an initial order. */
    isInitial?: boolean;
    /** Timestamp of the last update to the order. */
    lastUpdated?: DateTime;
    /** Username or identifier of the person who last updated the order. */
    lastUpdatedBy?: string | undefined;
    /** The current status value of the order. */
    orderStatusValue?: string;
    /** Description of the current order status. */
    orderStatusDescription?: string;
}

/** Command to schedule selected orders to be filled and add a follow-up note. */
export interface ScheduleRelatedOrdersCommand {
    /** List of order IDs to be scheduled */
    orderIds?: number[];
    /** Follow-up note to be added to each order */
    note?: string | undefined;
}

/** Command to create Kroll transaction records for order items. This command links Kroll prescription data with order items in the system. */
export interface CreateOrderItemKrollTransactionsCommand {
    /** A list of Kroll transaction DTOs containing the prescription data to be linked. */
    krollTransactions?: KrollTransactionDto[];
}

/** Data Transfer Object for Kroll transactions. */
export interface KrollTransactionDto {
    /** Gets or sets the Kroll Transaction Id. */
    krollTransactionId?: number;
    /** Gets or sets the unique identifier for the order item. */
    orderItemId?: number;
    /** Gets or sets the Rx number. */
    rxNumber?: string | undefined;
    /** Gets or sets the transaction number. */
    txNumber?: string | undefined;
    /** Gets or sets the dispense type */
    dispenseTypeValue?: string | undefined;
    /** Gets or sets the fill date of the transaction. */
    fillDate?: DateTime | undefined;
    /** Gets or sets the days supply for the transaction. */
    daysSupply?: number | undefined;
    /** Gets or sets the quantity for the transaction. */
    qty?: number | undefined;
}

/** Command to resolve Kroll transactions by deleting removed transactions and creating new ones. */
export interface ResolveKrollTransactionCommand {
    /** The list of Kroll transaction DTOs to create. */
    krollTransactions?: KrollTransactionDto[];
    /** The list of Kroll transaction IDs to delete. */
    deletedKrollTransactionIds?: number[];
}

/** Command to resolve a delivery issue for an order by applying a resolution value and recording a note */
export interface ResolveDeliveryIssueCommand {
    /** The ID of the order with the delivery issue to resolve */
    orderId?: number;
    /** The value identifier for the resolution type to apply */
    deliveryIssueResolutionValue?: string;
    /** Additional notes about the resolution action */
    note?: string | undefined;
}

/** Command to update the date the Drug-Drug Interaction Review of an order was completed. */
export interface UpdateOrderDateDdiReviewCompletedCommand {
    /** The identifier of the order to update. */
    id?: number;
}

export interface CreateManualOrderCommandResponse {
    id?: number | undefined;
}

/** Command to create a manual order. Requires Pharmacy Manager, User, or Administrator role. */
export interface CreateManualOrderCommand {
    /** Gets or sets the ID of the patient for whom the order is being created. */
    patientId?: number;
    /** Gets or sets the ID of the workflow for which the order is being created. */
    workflowId?: number;
    /** Gets or sets the external patient reference associated with the order. */
    patientExternalReferenceId?: number | undefined;
}

/** Command to reject an order by associating it with an issue type and optionally adding a follow-up note. */
export interface RejectOrderCommand {
    /** The unique identifier of the order to reject. */
    id?: number;
    /** The value of the issue type that describes the reason for rejection. */
    issueTypeValue?: string;
    /** An optional follow-up note providing additional context for the rejection. */
    followupNote?: string | undefined;
}

/** Response model for retrieving order status by order ID. */
export interface GetOrderStatusQueryResponse {
    /** Unique identifier for the order. */
    id?: number;
    /** Value representing the order status. */
    orderStatusValue: string;
    /** Description of the order status. */
    orderStatusDescription: string;
    /** When the order was Rx-verified, or null if it has not been verified yet. The
re-verification screen uses this to catch an order that another user has already
verified while the list sat open. */
    rxVerifiedAt?: DateTime | undefined;
}

/** Response describing whether an order is still an open delivery issue. */
export interface GetDeliveryIssueOrderStateQueryResponse {
    /** True only while the order is still in a delivery issue and has not been resolved; false if it is
missing, outside the current pharmacy, no longer in a delivery issue, or already resolved. */
    isUnresolvedDeliveryIssue?: boolean;
}

/** Response returned after successfully creating a patient and accepting the linked order. */
export interface CreatePatientAndAcceptOrderCommandResponse {
    /** The unique identifier of the newly created patient. */
    patientId?: number;
    /** The unique identifier of the accepted order. */
    orderId?: number;
    /** Any warnings for failed attachment uploads. */
    attachmentWarnings?: string[];
}

/** Command that atomically creates a new patient and accepts the linked order within a single transaction. If either operation fails, all changes are rolled back. */
export interface CreatePatientAndAcceptOrderCommand {
    /** The identifier of the order to accept after the patient is created. */
    orderId?: number;
    /** Flag to indicate if the patient should be transferred to Kroll. */
    transferPatientToKroll?: boolean;
    /** External identifier for the patient in the source system. */
    sourceSystemExternalReferenceId?: string | undefined;
    /** Patient's first name. */
    firstName?: string;
    /** Patient's last name. */
    lastName?: string;
    /** Patient's date of birth. */
    dateOfBirth?: DateTime;
    /** Patient's home phone number. */
    homePhone?: string | undefined;
    /** Patient's email address. */
    email?: string | undefined;
    /** Patient's work phone number. */
    workPhone?: string | undefined;
    /** Extension for the patient's work phone. */
    workPhoneExt?: string | undefined;
    /** Patient's cell phone number. */
    cellPhone?: string | undefined;
    /** Patient's gender. */
    gender?: string;
    /** Patient's preferred name or nickname. */
    preferredName?: string | undefined;
    /** Patient's preferred language for communication. */
    preferredLanguage?: string | undefined;
    /** Patient's health card number. */
    prHealthCard?: string | undefined;
    /** Indicates if home phone is the preferred contact method. */
    homePhonePreferred?: boolean;
    /** Indicates if cell phone is the preferred contact method. */
    cellPhonePreferred?: boolean;
    /** Indicates if work phone is the preferred contact method. */
    workPhonePreferred?: boolean;
    /** First line of patient's home address. */
    homeAddressLine1?: string | undefined;
    /** Second line of patient's home address. */
    homeAddressLine2?: string | undefined;
    /** City of patient's home address. */
    homeCity?: string | undefined;
    /** Province of patient's home address. */
    homeProvince?: string;
    /** Postal code of patient's home address. */
    homePostalCode?: string | undefined;
    /** Patient's preferred pronouns. */
    pronouns?: string | undefined;
    /** Identifier for the source system where this patient record originated. */
    sourceSystemId?: number | undefined;
}

/** Represents the response for the GetPatientByOrderId query. */
export interface GetPatientByOrderIdQueryResponse {
    /** The preferred name of the patient. */
    patientPreferredName?: string | undefined;
    /** The first name of the patient. */
    patientFirstName?: string | undefined;
    /** The last name of the patient. */
    patientLastName?: string | undefined;
    /** The date of birth of the patient. */
    patientDateOfBirth?: DateTime | undefined;
    /** The gender of the patient. */
    patientGender?: string | undefined;
    /** The gender value of the patient. */
    patientGenderValue?: string | undefined;
    /** The pronouns of the patient. */
    patientPronouns?: string | undefined;
}

/** Command to update commercialization status on order items across multiple orders for a given patient and workflow. For commercialized items, creates Kroll transaction records with Rx/Tx data. For non-commercial items, only updates the status on the OrderItem — no KrollTransaction rows are created. Persists CommercializationStatusId, ArStatusId, SubmissionTypeId on each OrderItem. Items explicitly marked with Unlink = true will have their active Kroll transactions soft-deleted. All operations execute within a single database transaction — any failure rolls back all changes. */
export interface UpdateOrderItemsForCommercializationCommand {
    /** The patient whose orders are being updated. */
    patientId?: number;
    /** The workflow to scope the operation to. */
    workflowId?: number;
    /** Optional commercialization note (currently unused — reserved for future use). */
    notes?: string | undefined;
    /** One or more order items with commercialization status and optional Kroll transaction data. */
    orderItems?: UpdateOrderItemForCommercializePayload[];
}

/** Payload representing a single order item to be commercialized. */
export interface UpdateOrderItemForCommercializePayload {
    /** The ID of the order item linked to this transaction. */
    orderItemId?: number;
    /** The ID representing the commercialization status. */
    commercializationStatusId?: number;
    /** The Kroll prescription number. */
    rxNum?: string | undefined;
    /** The Kroll transaction number. */
    txNum?: string | undefined;
    /** The fill date of the transaction. */
    fillDate?: DateTime | undefined;
    /** The days supply for the transaction. */
    daysSupply?: number | undefined;
    /** The quantity for the transaction. */
    qty?: number | undefined;
    /** The ID representing the AR status (optional). */
    arStatusId?: number | undefined;
    /** The follow-up date for the AR status (optional). */
    arFollowUpDate?: DateTime | undefined;
    /** The ID representing the submission type. */
    submissionTypeId?: number | undefined;
    /** When true, any active commercialized Kroll transaction matching this item's
(OrderItemId, RxNum, TxNum) will be soft-deleted (UnlinkedAt / UnlinkedByUserId set).
The front end sets this flag explicitly; no implicit unlinking occurs. */
    unlink?: boolean;
}

/** Top-level response for the GetCommercializedDispensesWithKrollRx query. */
export interface GetCommercializedDispensesWithKrollRxResponse {
    /** Gets or sets the order items with their linked Kroll prescription transactions. */
    orderItems?: GetCommercializedDispensesWithKrollRxQueryResponse[];
    /** Gets or sets a value indicating whether the Kroll connection was unavailable.
When true, Kroll API enrichment fields (FillDate, DispensedQty, DaysSupply) will be null. */
    krollConnectionUnavailable?: boolean;
}

/** Represents an order item with its commercialized Kroll prescription transactions. */
export interface GetCommercializedDispensesWithKrollRxQueryResponse {
    /** Unique identifier for the order item. */
    orderItemId?: number;
    /** The unique identifier of the order. */
    orderId?: number;
    /** Identifier of the drug details associated with this order item. */
    drugDetailsId?: number;
    /** Quantity of units ordered. */
    quantity?: number;
    /** Name of the drug associated with this order item. */
    drugName?: string;
    /** Indicates whether this is an 'other' drug category. */
    isOtherDrug?: boolean;
    /** The type of the dispense. */
    dispenseType?: string;
    /** The description of the dispense type. */
    dispenseTypeDescription?: string;
    /** The identifier of the order drug. */
    orderDrugId?: number;
    /** The DIN of the order drug. */
    din?: string;
    /** The value code of the AR status. */
    arStatusValue?: string | undefined;
    /** The description of the AR status. */
    arStatusDescription?: string | undefined;
    /** The AR follow-up date. */
    arFollowUpDate?: DateTime | undefined;
    /** The value code of the submission type. */
    submissionTypeValue?: string | undefined;
    /** The description of the submission type. */
    submissionTypeDescription?: string | undefined;
    /** The date the order item was last updated (ModifiedAt or CreatedAt). */
    lastUpdatedDate?: DateTime;
    /** The full name of the user who last updated the order item. */
    lastUpdatedBy?: string;
    /** The Kroll ID of the patient associated with this order item. */
    patientKrollId?: number | undefined;
    /** The linked Kroll prescription transactions for this order item. */
    krollTransactions?: LinkedKrollTransactionDto[];
}

/** Represents a linked Kroll prescription transaction for an order item, enriched with data from the Kroll API. */
export interface LinkedKrollTransactionDto {
    /** The unique identifier of the KrollTransaction record that is in the Luminav Link system. */
    id?: number;
    /** The unique identifier of the Kroll prescription in the Kroll system. */
    krollRxId?: number;
    /** The prescription number stored in the database. */
    rxNum?: string | undefined;
    /** The transaction number used to match against the Kroll API response. */
    txNum?: string | undefined;
    /** The dispense type value associated with the transaction. */
    dispenseType?: string;
    /** The human-readable description of the dispense type. */
    dispenseTypeDescription?: string;
    /** The date and time the transaction was linked to the order item. */
    linkedAt?: DateTime | undefined;
    /** Whether the transaction has been commercialized. */
    commercialized?: boolean;
    /** The display type of the transaction: "Commercialized" or "Free Good". */
    type?: string;
    /** The date the prescription was filled, sourced from the Kroll API. Null if Kroll is unavailable. */
    fillDate?: DateTime | undefined;
    /** The dispensed quantity, sourced from the Kroll API. Null if Kroll is unavailable. */
    dispensedQty?: number | undefined;
    /** The days supply, sourced from the Kroll API. Null if Kroll is unavailable. */
    daysSupply?: number | undefined;
    /** The date the transaction was cancelled, if applicable. */
    dateCancelled?: DateTime | undefined;
    /** The name of the drug associated with the transaction. */
    drugName?: string | undefined;
}

/** Wrapper response containing the list of order items and a flag indicating Kroll connection availability. */
export interface GetNonCommercializedDispensesWithKrollRxResponse {
    /** The non-commercialized order items with their Kroll transaction child records. */
    orderItems?: GetNonCommercializedDispensesWithKrollRxOrderItemResponse[];
    /** When true, the Kroll API was unreachable and Kroll enrichment fields (FillDate, DrugName, DispensedQty, DaysSupply) will be null. */
    krollConnectionUnavailable?: boolean;
}

/** Parent response record at the order item level. */
export interface GetNonCommercializedDispensesWithKrollRxOrderItemResponse {
    /** The unique identifier of the order. */
    orderId?: number;
    /** The unique identifier of the order item. */
    orderItemId?: number;
    /** The drug details display name. */
    product?: string;
    /** The drug DIN. */
    din?: string;
    /** The order item quantity. */
    qty?: number;
    /** The value code of the actual dispense type. */
    dispenseType?: string;
    /** The description of the actual dispense type. */
    dispenseTypeDescription?: string;
    /** The value code of the commercialization status. */
    commercializationStatusValue?: string | undefined;
    /** The description of the commercialization status. */
    commercializationStatusDescription?: string | undefined;
    /** The date the order item was last updated (ModifiedAt or CreatedAt). */
    lastUpdatedDate?: DateTime;
    /** The full name of the user who last updated the order item. */
    lastUpdatedBy?: string;
    /** The unique identifier of the patient in the Kroll system. */
    patientKrollId?: number | undefined;
    /** The child Kroll transaction records enriched with Kroll API data. */
    krollTransactions?: NonCommercializedKrollTransactionDto[];
}

/** Child record representing a non-commercialized Kroll transaction enriched with Kroll API data. */
export interface NonCommercializedKrollTransactionDto {
    /** The unique identifier of the Kroll transaction record that is in the Luminav Link system. */
    id?: number;
    /** The unique identifier of the Kroll prescription in the Kroll system. */
    krollRxId?: number;
    /** The Kroll prescription number. */
    rxNum?: string | undefined;
    /** The Kroll transaction number. */
    txNum?: string | undefined;
    /** The fill date from the Kroll API. */
    fillDate?: DateTime | undefined;
    /** The drug name from the Kroll API. */
    drugName?: string | undefined;
    /** The dispensed quantity from the Kroll API. */
    dispensedQty?: number | undefined;
    /** The days supply from the Kroll API. */
    daysSupply?: number | undefined;
    /** The drug DIN from the Kroll API. */
    din?: string | undefined;
    /** The date when the prescription was cancelled, if applicable. */
    dateCancelled?: DateTime | undefined;
}

/** Represents the result of a query for orders with mismatched patient information between the order and patient records. */
export interface GetMismatchedOrdersQueryResponse {
    /** The unique identifier of the order with a potential mismatch. */
    orderId?: number;
    /** The unique identifier of the patient associated with the order, if available; otherwise, null. */
    patientId?: number | undefined;
    /** The external reference identifier for the order from the source system, if available. */
    sourceSystemExternalReferenceId?: string | undefined;
    /** The first name of the patient as recorded on the order, if available. */
    orderPatientFirstName?: string | undefined;
    /** The last name of the patient as recorded on the order, if available. */
    orderPatientLastName?: string | undefined;
    /** The first name of the patient as recorded in the patient record, if available. */
    patientFirstName?: string | undefined;
    /** The last name of the patient as recorded in the patient record, if available. */
    patientLastName?: string | undefined;
}

/** Represents the response containing detailed information about an order and its associated patient when a mismatch is detected between order and patient records. */
export interface GetMismatchedOrderDetailsQueryResponse {
    /** The unique identifier of the order for which mismatched details are being returned. */
    orderId?: number;
    /** The unique identifier of the patient record matched to the order, or null if no patient is
            matched. */
    patientId?: number | undefined;
    /** The first name of the patient as recorded on the order. */
    orderPatientFirstName?: string | undefined;
    /** The last name of the patient as recorded on the order. */
    orderPatientLastName?: string | undefined;
    /** The preferred name of the patient as recorded on the order, if available. */
    orderPatientPreferredName?: string | undefined;
    /** The date of birth of the patient as recorded on the order, or null if not specified. */
    orderPatientDateOfBirth?: DateTime | undefined;
    /** The gender of the patient as recorded on the order, if available. */
    orderPatientGender?: string | undefined;
    /** The personal health number (PHN) of the patient as recorded on the order, if available. */
    orderPatientPhn?: string | undefined;
    /** The first line of the patient's address as recorded on the order. */
    orderPatientAddressLine1?: string | undefined;
    /** The second line of the patient's address as recorded on the order, if available. */
    orderPatientAddressLine2?: string | undefined;
    /** The city of the patient's address as recorded on the order. */
    orderPatientCity?: string | undefined;
    /** The province of the patient's address as recorded on the order. */
    orderPatientProvince?: string | undefined;
    /** The postal code of the patient's address as recorded on the order. */
    orderPatientPostalCode?: string | undefined;
    /** A list of external references associated with the patient as recorded on the order. */
    orderPatientExternalIds?: PatientExternalReferenceDto[];
    /** The first name of the matched patient record, if available. */
    patientFirstName?: string | undefined;
    /** The last name of the matched patient record, if available. */
    patientLastName?: string | undefined;
    /** The preferred name of the matched patient record, if available. */
    patientPreferredName?: string | undefined;
    /** The date of birth of the matched patient record, or null if not specified. */
    patientDateOfBirth?: DateTime | undefined;
    /** The gender of the matched patient record, if available. */
    patientGender?: string | undefined;
    /** The personal health number (PHN) of the matched patient record, if available. */
    patientPhn?: string | undefined;
    /** The first line of the matched patient's address. */
    patientAddressLine1?: string | undefined;
    /** The second line of the matched patient's address, if available. */
    patientAddressLine2?: string | undefined;
    /** The city of the matched patient's address. */
    patientCity?: string | undefined;
    /** The province of the matched patient's address. */
    patientProvince?: string | undefined;
    /** The postal code of the matched patient's address. */
    patientPostalCode?: string | undefined;
    /** A list of Kroll links associated with the matched patient record. */
    patientKrollLinks?: PatientKrollLinkDto[];
    /** A list of external references associated with the matched patient record. */
    patientExternalIds?: PatientExternalReferenceDto[];
    /** Name of the pharmacy */
    orderPharmacyName?: string | undefined;
    /** Id of the pharmacy */
    orderPharmacyId?: number | undefined;
}

/** Represents an external reference for a patient. */
export interface PatientExternalReferenceDto {
    /** The external reference identifier. */
    externalId?: string;
    /** The source system identifier. */
    sourceSystemId?: number;
    /** The workflow identifier. */
    workflowId?: number;
}

/** Represents a data transfer object that links a patient to a corresponding Kroll patient record and pharmacy. */
export interface PatientKrollLinkDto {
    /** The unique identifier of the patient in the local system. */
    patientId?: number;
    /** The unique identifier of the patient in the Kroll pharmacy system. */
    patientKrollId?: number | undefined;
    /** The pharmacy this Kroll link belongs to. A patient can be linked at several
            pharmacies with a different Kroll ID at each, so callers acting on a link must match it to the
            pharmacy whose Kroll credentials they will use. */
    pharmacyId?: number;
    /** The name of the pharmacy associated with the Kroll patient record. */
    pharmacyName?: string | undefined;
}

/** Response returned after resolving an order mismatch, containing the associated patient ID. */
export interface ResolveOrderMismatchCommandResponse {
    /** The unique identifier of the patient involved in the resolution. */
    patientId?: number;
    /** Indicates whether the patient has matching program IDs. */
    hasMatchingProgramIds?: boolean;
}

/** Command to resolve a mismatch for a specific order by creating a new patient and updating the order. */
export interface ResolveOrderMismatchCommand {
    /** The unique identifier of the order to resolve the mismatch for. */
    orderId?: number;
    /** The unique identifier of the patient kroll record. */
    patientKrollId?: number;
}

/** Command to dismiss a mismatch for a specific order by marking it as resolved. */
export interface DismissOrderMismatchCommand {
    /** The unique identifier of the order to dismiss the mismatch for. */
    orderId?: number;
}

/** Response containing Kroll transaction DTOs and connection status. */
export interface GetOrderItemKrollRxDispensesResponse {
    /** Gets or sets the list of order item Kroll transactions. */
    orderItemKrollTransactions?: OrderItemKrollTransactionDto[];
    /** When true, the Kroll API was unreachable */
    krollConnectionUnavailable?: boolean;
}

/** Data transfer object representing a Kroll transaction. */
export interface OrderItemKrollTransactionDto {
    /** The unique identifier of the kroll transaction. */
    id?: number;
    /** The unique identifier of the order item. */
    orderItemId?: number;
    /** The Kroll Rx identifier, if available. */
    krollRxId?: number | undefined;
    /** Indicates if the transaction is commercialized. */
    commercialized?: boolean;
    /** The Rx number. */
    rxNum?: string | undefined;
    /** The transaction number. */
    txNum?: string | undefined;
    /** The fill date of the prescription. */
    fillDate?: DateTime | undefined;
    /** The name of the drug. */
    drugName?: string | undefined;
    /** The quantity dispensed. */
    dispensedQty?: number | undefined;
    /** The number of days supplied. */
    daysSupply?: number | undefined;
    /** The Drug Identification Number. */
    din?: string | undefined;
    /** The date the prescription was cancelled, if applicable. */
    dateCancelled?: DateTime | undefined;
}

/** Response object for the GetMissingDispensesWithKrollRx query. Contains a list of completed dispenses without any uncancelled Kroll transactions, and a flag indicating if the Kroll connection was unavailable. */
export interface GetMissingDispensesWithKrollRxResponse {
    /** The list of completed order items that do not have any uncancelled Kroll transactions. */
    orderItems?: GetMissingDispensesWithKrollRxQueryResponse[];
    /** Pagination metadata for the current result set. */
    page?: GetMissingDispensesWithKrollRxPageMetadata;
    /** Indicates whether the Kroll connection was unavailable during the query. */
    krollConnectionUnavailable?: boolean;
    /** Machine-readable reason for Kroll unavailability when KrollConnectionUnavailable is true.
Values:
- credentials_not_configured: pharmacy is not configured for Kroll integration.
- upstream_unavailable: Kroll API was unreachable or throttled (e.g., 500/429). */
    krollUnavailabilityReason?: string | undefined;
}

/** Represents a completed dispense that does not have any uncancelled Kroll transactions. */
export interface GetMissingDispensesWithKrollRxQueryResponse {
    /** The unique identifier of the order item. */
    orderItemId?: number;
    /** The unique identifier of the order. */
    orderId?: number;
    /** The unique identifier of the drug details. */
    drugDetailsId?: number;
    /** The dispensed quantity. */
    quantity?: number;
    /** The name of the drug. */
    drugName?: string;
    /** Indicates if the drug is classified as 'other'. */
    isOtherDrug?: boolean;
    /** The type of dispense. */
    dispenseType?: string;
    /** A description of the dispense type. */
    dispenseTypeDescription?: string;
    /** The unique identifier of the order drug. */
    orderDrugId?: number;
    /** The Drug Identification Number (DIN). */
    din?: string;
    /** The unique identifier of the workflow. */
    workflowId?: number;
    /** The name of the workflow. */
    workflowName?: string;
    /** The first name of the patient. */
    patientFirstName?: string;
    /** The last name of the patient. */
    patientLastName?: string;
    /** The patient external reference of the order. */
    externalId?: string | undefined;
    /** The Kroll identifier for the patient, if available. */
    patientKrollId?: number | undefined;
    /** A list of linked Kroll transactions for this order item. */
    krollTransactions?: LinkedKrollTransactionDto[];
}

/** Pagination metadata for missing dispenses results. */
export interface GetMissingDispensesWithKrollRxPageMetadata {
    /** Total number of discovered rows for this request path.
When Kroll-filtered paging is bounded for performance, this can be a lower bound while HasNextPage is true. */
    totalCount?: number;
    /** Current 1-based page number. */
    pageNumber?: number;
    /** Requested page size. */
    pageSize?: number;
    /** Total number of pages derived from TotalCount and PageSize. */
    totalPages?: number;
    /** Indicates whether another page exists after the current page. */
    hasNextPage?: boolean;
    /** Indicates whether a page exists before the current page. */
    hasPreviousPage?: boolean;
}

/** Response containing the current lock state of an order. */
export interface GetOrderLockQueryResponse {
    /** The order ID. */
    orderId?: number;
    /** Whether the order is currently locked. */
    isLocked?: boolean;
    /** The user ID of the lock holder, or null if not locked. */
    lockedBy?: number | undefined;
    /** The display name of the lock holder, or null if not locked. */
    lockedByName?: string | undefined;
    /** When the lock was acquired, or null if not locked. */
    lockedAt?: DateTime | undefined;
    /** When the lock expires, or null if not locked. */
    expiresAt?: DateTime | undefined;
    /** Whether there is a pending lock request. */
    hasPendingRequest?: boolean;
    /** The user ID of the requester, or null. */
    requestedBy?: number | undefined;
    /** The display name of the requester, or null. */
    requestedByName?: string | undefined;
}

/** Response returned from a try-acquire lock attempt. The frontend compares LockedBy with the current user to determine if the lock was acquired. */
export interface TryAcquireLockCommandResponse {
    orderId?: number;
    lockedBy?: number;
    lockedByName?: string;
    lockedAt?: DateTime;
    expiresAt?: DateTime;
    lockStealTimeoutSeconds?: number;
    isNewLock?: boolean;
}

/** Request body for trying to acquire a lock on an order. */
export interface TryAcquireLockBody {
    /** Optional device information for the lock holder. */
    deviceInfo?: string | undefined;
    /** The SignalR connection ID of the lock holder. */
    connectionId?: string;
}

/** Response returned after successfully requesting an order lock. */
export interface RequestLockCommandResponse {
    /** The UTC timestamp when the request expires. */
    requestExpiresAt?: DateTime;
    /** The number of seconds before the request can be auto-stolen. */
    timeoutSeconds?: number;
}

/** Shared request body for operations that only require a SignalR connection ID. */
export interface ConnectionIdBody {
    /** The SignalR connection ID. */
    connectionId?: string;
}

/** Response returned after successfully stealing an order lock. */
export interface StealLockCommandResponse {
    /** The UTC timestamp when the stolen lock expires. */
    expiresAt?: DateTime;
}

/** Represents the response for the GetPatientByIdQueryResponse query. */
export interface GetPatientByIdQueryResponse {
    /** The unique identifier of the patient. */
    id?: number;
    /** The preferred name of the patient. */
    preferredName?: string | undefined;
    /** The first name of the patient. */
    firstName?: string;
    /** The last name of the patient. */
    lastName?: string;
    /** The list of external reference ids for the patient. */
    externalIds?: PatientExternalReferenceDto[];
    /** The date of birth of the patient. */
    dateOfBirth?: DateTime;
    /** The gender of the patient. */
    gender?: string;
    /** The first line of the patient's address. */
    addressLine1?: string | undefined;
    /** The second line of the patient's address. */
    addressLine2?: string | undefined;
    /** The city of the patient's address. */
    city?: string | undefined;
    /** The province of the patient's address. */
    province?: string | undefined;
    /** The postal code of the patient's address. */
    postalCode?: string | undefined;
    /** The phone number of the patient. */
    phone?: string | undefined;
    /** The cell phone number of the patient. */
    cellPhone?: string | undefined;
    /** The work phone number of the patient. */
    workPhone?: string | undefined;
    /** The email address of the patient. */
    email?: string | undefined;
    /** The preferred language of the patient. */
    preferredLanguage?: string | undefined;
    /** The work phone extension of the patient. */
    workPhoneExt?: string | undefined;
    /** The health card number of the patient. */
    prhealthCard?: string | undefined;
    /** The pronouns of the patient. */
    pronouns?: string | undefined;
    /** The age of the patient. */
    age?: number | undefined;
    /** The list of Kroll links for the patient. */
    krollLinks?: PatientKrollLinkDto[];
    /** The date/time the patient record was created. */
    createdAt?: DateTime;
    /** Whether the home phone is the patient's preferred number. */
    homePhonePreferred?: boolean;
    /** Whether the cell phone is the patient's preferred number. */
    cellPhonePreferred?: boolean;
    /** Whether the work phone is the patient's preferred number. */
    workPhonePreferred?: boolean;
    /** When the patient consented to SMS, or null if not consented. */
    consentToSmsAt?: DateTime | undefined;
    /** The phone number the patient consented to receive SMS on. */
    smsPhone?: string | undefined;
    /** When the patient consented to email, or null if not consented. */
    consentToEmailAt?: DateTime | undefined;
    /** Whether the patient consented to Rx-history transfer for the current pharmacy. */
    rxHistoryTransferConsented?: boolean;
    /** When the patient consented to Rx-history transfer for the current pharmacy. */
    rxHistoryTransferConsentedAt?: DateTime | undefined;
    /** When this patient's data was last pulled from Kroll, or null if never pulled. */
    lastKrollRefreshedAt?: DateTime | undefined;
    /** Display name of the user who performed that pull, or null if never pulled. */
    lastKrollRefreshedBy?: string | undefined;
    /** Every phone number Kroll holds for this patient at the current pharmacy, each with Kroll's own
label. Empty when the patient is not linked to Kroll here, in which case the header falls back
to Phone / CellPhone / WorkPhone. */
    krollContacts?: PatientKrollContactDto[];
}

/** Represents the response data structure for a patient matching query. Contains both exact match (if found) and a list of potential matches. */
export interface GetPatientMatchesQueryResponse {
    /** The exact patient match if found, otherwise null. */
    exactMatch?: PatientDto | undefined;
    /** A list of potential patient matches based on similar criteria. */
    potentialMatches?: PatientDto[];
}

export interface PatientDto {
    id?: number;
    preferredName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    sourceSystemExternalId?: string | undefined;
    sourceSystemExternalReferenceId?: string | undefined;
    sourceSystemId?: number | undefined;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    postalCode?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    workPhone?: string | undefined;
    email?: string | undefined;
    preferredLanguage?: string | undefined;
    workPhoneExt?: string | undefined;
    prhealthCard?: string | undefined;
    pronouns?: string | undefined;
    /** Every Kroll-sourced number on file for this patient at the current pharmacy, digits only.
Empty when the patient has never been synced with Kroll, in which case the three fields
above are the full set.
            
Numbers only, no labels: this exists so the patient header can tell whether an incoming
order's number is one already on file, and Kroll's labels are free text that cannot be
matched on (#35423). Comparing numbers rather than fields also stops the header flagging
a mismatch merely because the same number sits under a different label on each side. */
    contactNumbers?: string[];
}

/** Response returned after successfully creating a patient record */
export interface CreatePatientCommandResponse {
    /** The unique identifier of the newly created patient */
    id?: number;
}

/** Command to create a new patient in the system */
export interface CreatePatientCommand {
    /** Order Id */
    orderId?: number;
    /** External identifier for the patient in the source system */
    sourceSystemExternalReferenceId?: string | undefined;
    /** Patient's first name */
    firstName?: string;
    /** Patient's last name */
    lastName?: string;
    /** Patient's date of birth */
    dateOfBirth?: DateTime;
    /** Patient's home phone number */
    homePhone?: string | undefined;
    /** Patient's email address */
    email?: string | undefined;
    /** Patient's work phone number */
    workPhone?: string | undefined;
    /** Extension for the patient's work phone */
    workPhoneExt?: string | undefined;
    /** Patient's cell phone number */
    cellPhone?: string | undefined;
    /** Patient's gender */
    gender?: string;
    /** Patient's preferred name or nickname */
    preferredName?: string | undefined;
    /** Patient's preferred language for communication */
    preferredLanguage?: string | undefined;
    /** Patient's health card number */
    prHealthCard?: string | undefined;
    /** Indicates if home phone is the preferred contact method */
    homePhonePreferred?: boolean;
    /** Indicates if cell phone is the preferred contact method */
    cellPhonePreferred?: boolean;
    /** Indicates if work phone is the preferred contact method */
    workPhonePreferred?: boolean;
    /** First line of patient's home address */
    homeAddressLine1?: string | undefined;
    /** Second line of patient's home address */
    homeAddressLine2?: string | undefined;
    /** City of patient's home address */
    homeCity?: string | undefined;
    /** Province of patient's home address */
    homeProvince?: string;
    /** Postal code of patient's home address */
    homePostalCode?: string | undefined;
    /** Patient's preferred pronouns */
    pronouns?: string | undefined;
    /** Identifier for the source system where this patient record originated */
    sourceSystemId?: number | undefined;
}

/** Represents the response for a patient search query. */
export interface PatientSearchQueryResponse {
    /** The unique identifier of the patient. */
    id?: number;
    /** The preferred name of the patient. */
    preferredName?: string | undefined;
    /** The first name of the patient. */
    firstName?: string;
    /** The last name of the patient. */
    lastName?: string;
    /** A list of external identifiers associated with the patient. */
    externalIds?: string[] | undefined;
    /** The date of birth of the patient. */
    dateOfBirth?: DateTime | undefined;
    /** The first line of the patient's address. */
    addressLine1?: string | undefined;
    /** The second line of the patient's address. */
    addressLine2?: string | undefined;
    /** The city of the patient's address. */
    city?: string | undefined;
    /** The province of the patient's address. */
    province?: string | undefined;
    /** The postal code of the patient's address. */
    postalCode?: string | undefined;
    /** The primary phone number of the patient. */
    phone?: string | undefined;
    /** The cell phone number of the patient. */
    cellPhone?: string | undefined;
    /** The work phone number of the patient. */
    workPhone?: string | undefined;
    /** The email address of the patient. */
    email?: string | undefined;
    /** The extension for the work phone number. */
    workPhoneExt?: string | undefined;
    /** The provincial health card number of the patient. */
    prhealthCard?: string | undefined;
    /** The short name of the pharmacy associated with the patient. */
    pharmacyShortName?: string | undefined;
    /** The unique identifier of the pharmacy associated with the patient. */
    pharmacyId?: number | undefined;
    /** The Kroll identifier of the patient. */
    patientKrollId?: number | undefined;
    /** The name of the workflow associated with the patient. */
    workflowName?: string | undefined;
    /** The patient's Kroll phone contacts for the pharmacy. */
    krollContacts?: PatientKrollContactDto[];
}

/** Represents the response for the GetPatientNotesQuery, containing details about follow-up notes for a patient. */
export interface GetPatientNotesQueryResponse {
    /** The unique identifier of the follow-up note. */
    followUpId?: number;
    /** The unique identifier of the associated order. */
    orderId?: number;
    /** The date and time when the note was last updated. */
    lastUpdated?: DateTime;
    /** The email of the user who last updated the note. */
    lastUpdatedBy?: string;
    /** Indicates if this is the initial counsel. */
    initialCounsel?: boolean;
    /** The content of the follow-up note. */
    notes?: string | undefined;
    /** The description of the reason for delay, if applicable. */
    reasonForDelayDescription?: string | undefined;
    /** The French description of the reason for delay, if applicable. */
    reasonForDelayDescriptionFr?: string | undefined;
    /** The date and time when a call was attempted, if applicable. */
    callAttempted?: DateTime | undefined;
    /** The unique identifier of the associated workflow, if applicable. */
    workflowId?: number | undefined;
}

/** Represents the response for retrieving a Kroll patient by their ID. */
export interface GetKrollPatientByIdQueryResponse {
    /** Gets or sets the Kroll patient information. */
    krollPatient?: KrollPatientDto | undefined;
    /** Gets or sets a value indicating whether the Kroll connection is unavailable. */
    krollConnectionUnavailable?: boolean;
    /** Gets or sets what a refresh would change about the patient's stored Kroll numbers.
Null when the request did not name a patient. Numbers present on both sides are omitted
entirely — the confirm dialog shows differences only. */
    krollContactChanges?: KrollContactChanges | undefined;
}

/** Represents a patient retrieved from the Kroll system. */
export interface KrollPatientDto {
    /** Gets the unique identifier for the patient in Kroll. */
    patientKrollId?: number;
    /** Gets the patient's preferred name. */
    preferredName?: string | undefined;
    /** Gets the patient's first name. */
    firstName?: string;
    /** Gets the patient's last name. */
    lastName?: string;
    /** Gets the patient's date of birth. */
    dateOfBirth?: DateTime | undefined;
    /** Gets the patient's gender. */
    gender?: string | undefined;
    /** Gets the first line of the patient's address. */
    addressLine1?: string | undefined;
    /** Gets the second line of the patient's address. */
    addressLine2?: string | undefined;
    /** Gets the patient's city. */
    city?: string | undefined;
    /** Gets the patient's province/state. */
    province?: string | undefined;
    /** Gets the patient's postal code. */
    postalCode?: string | undefined;
    /** Gets the patient's email address. */
    email?: string | undefined;
    /** Gets the patient's preferred language. */
    preferredLanguage?: string | undefined;
    /** Gets the patient's health card number. */
    prhealthCard?: string | undefined;
    /** Gets the patient's preferred pronouns. */
    pronouns?: string | undefined;
    /** Gets or sets the list of phone numbers for the patient. */
    phoneNumbers?: KrollPatientPhoneNumber[];
    /** Gets or sets the list of addresses associated with the patient. */
    addresses?: KrollPatientAddress[];
}

/** Represents a phone number associated with a Kroll patient. */
export interface KrollPatientPhoneNumber {
    /** Gets the phone number. */
    phoneNumber: string;
    /** Gets the phone number type (e.g., Home, Cell, Work). */
    phoneType: string;
    extension?: string | undefined;
}

/** Represents an address associated with a Kroll patient. */
export interface KrollPatientAddress {
    /** Gets the type of the address. */
    type?: string | undefined;
    /** Gets the first line of the address. */
    address1?: string | undefined;
    /** Gets the second line of the address, if any. */
    address2?: string | undefined;
    /** Gets the city of the address. */
    city?: string | undefined;
    /** Gets the province or state of the address. */
    prov?: string | undefined;
    /** Gets the postal or ZIP code of the address. */
    postal?: string | undefined;
    /** Gets the country of the address. */
    country?: string | undefined;
}

/** The patient's contacts as they stand on each side, for the confirm dialog to show side by side. Presented as two whole sets rather than a per-contact diff: Kroll's labels are free text, so pairing individual contacts across the two sides invents relationships the data does not carry, and a refresh replaces the set anyway.            Whether the sets differ is decided by KrollContactReconciler, the same helper the save runs through, so the dialog appears exactly when the refresh would change something. */
export interface KrollContactChanges {
    /** Every contact Kroll now holds. */
    kroll?: KrollContactChangeDto[];
    /** Every contact Link holds: the stored Kroll list, or the three profile fields when the
patient has never been synced. */
    current?: KrollContactChangeDto[];
    /** True when the two sets differ, so there is something to confirm. */
    hasChanges?: boolean;
}

/** One contact on either side of the comparison. */
export interface KrollContactChangeDto {
    /** The number, digits only. */
    phoneNumber?: string;
    /** Kroll's free text label, or Link's stored label. */
    phoneType?: string | undefined;
    /** The extension, if there is one. */
    extension?: string | undefined;
}

export interface UpdatePatientFromKrollCommandResponse {
    patientId?: number;
}

/** Command to update a patient's information from Kroll. */
export interface UpdatePatientFromKrollCommand {
    /** The ID of the patient to update. */
    patientId?: number;
    /** The Kroll ID of the patient. */
    patientKrollId?: number;
    /** Whether to overwrite the patient's home address from Kroll.
            Defaults to true so the existing link / re-link callers keep their behaviour; the patient-header
            refresh (#34547) sends false because address is out of scope for that pull. */
    includeHomeAddress?: boolean;
    /** Whether a value Kroll no longer holds should be cleared
            rather than left as it is. Defaults to false so the existing link / re-link callers keep merging;
            the patient-header refresh (#34547) sends true, treating Kroll as authoritative. */
    clearValuesMissingInKroll?: boolean;
}

/** Represents the response for retrieving a Kroll patient Rx by their patient ID. */
export interface GetKrollPatientRxByIdQueryResponse {
    /** Gets or sets the Kroll patient prescription information. */
    krollPatientRx?: KrollPatientRxDto[] | undefined;
    /** Gets or sets a value indicating whether the Kroll connection is unavailable. */
    krollConnectionUnavailable?: boolean;
}

export interface KrollPatientRxDto {
    /** Gets the unique identifier of the prescription record. */
    id?: number;
    /** Gets the patient ID associated with this prescription. */
    patientKrollId?: number;
    /** Gets the drug ID associated with this prescription. */
    krollDrugId?: number;
    /** Gets the prescription number. */
    rxNum?: number | undefined;
    /** Gets the prescription transaction number. */
    txNum?: number | undefined;
    /** Gets the date when the prescription was filled. */
    fillDate?: DateTime | undefined;
    /** Gets the dispensed quantity of the prescription. */
    dispensedQty?: number | undefined;
    /** Gets the days supply for the prescription. */
    daysSupply?: number | undefined;
    /** Gets the name of the drug associated with this prescription. */
    drugName?: string | undefined;
    /** Gets the DIN (Drug Identification Number) of the drug associated with this prescription. */
    din?: string | undefined;
    /** Gets or sets the date and time when the cancellation occurred. */
    cancelDate?: DateTime | undefined;
    /** Gets or sets the form associated with the drug e.g. CAP (Capsule), SYR (Prefilled Syr) etc. */
    form?: string | undefined;
    /** Gets or sets the strength of the drug. */
    strength?: string | undefined;
    /** Gets or sets the brand name of the drug. */
    brandName?: string | undefined;
}

/** Response model for retrieving patient notes. */
export interface GetPatientInfoNotesQueryResponse {
    /** The unique identifier of the patient. */
    patientId?: number;
    /** The textual notes associated with the patient. */
    notes?: string | undefined;
}

/** Command to create or update a patient's notes. */
export interface CreatePatientInfoNoteCommand {
    /** The unique identifier of the patient whose notes are being created or updated. */
    patientId?: number;
    /** The text content of the notes to be saved for the patient. */
    notes?: string;
}

/** Updates a patient's communication-consent preferences (SMS and email). Granting a consent stamps the consent date if not already set; revoking clears the date (and the SMS number). */
export interface UpdatePatientCommunicationConsentCommand {
    /** The ID of the patient whose consent is being updated. */
    patientId?: number;
    /** Whether the patient consents to SMS. */
    consentToSms?: boolean;
    /** The number to receive SMS on (required when SMS consent is granted). */
    smsPhone?: string | undefined;
    /** Whether the patient consents to email. */
    consentToEmail?: boolean;
}

/** Represents the response for a patient's external ID record. */
export interface GetPatientExternalIdsQueryResponse {
    /** Gets or sets the unique identifier of the external ID record. */
    id: number;
    /** Gets or sets the unique identifier of the patient. */
    patientId: number;
    /** Gets or sets the external ID assigned to the patient by the source system. */
    sourceSystemExternalId: string;
    /** Gets or sets the unique identifier of the source system. */
    sourceSystemId: number;
    /** Gets or sets the unique identifier of the workflow associated with this external ID. */
    workflowId: number;
    /** Gets or sets the human-readable name of the workflow. */
    workflowName: string;
    /** Gets or sets the external reference ID used by the source system to uniquely identify the record. */
    sourceSystemExternalReferenceId: string;
    /** Gets or sets the human-readable description of the source system. */
    sourceSystemDescription: string;
    /** Gets or sets a value indicating whether the external ID is in use. */
    isInUse: boolean;
}

/** Represents the response for the GetAllPatientMatches query, containing all detected duplicate patient groups. */
export interface GetAllPatientMatchesQueryResponse {
    /** The list of duplicate patient match groups, each containing a primary patient and their associated potential duplicates. */
    duplicatePatientMatches?: DuplicatePatientMatchGroupDto[];
}

/** Represents a group of patients identified as potential duplicates, including the primary patient and associated duplicate matches. */
export interface DuplicatePatientMatchGroupDto {
    /** Gets or sets the primary patient associated with this record. */
    primaryPatient: DuplicatePatientDto;
    /** Gets or sets the list of detected duplicate patient matches. */
    duplicatePatients: DuplicatePatientMatchDto[];
}

/** Represents a patient identified as a potential duplicate. */
export interface DuplicatePatientDto {
    /** Gets or sets the unique identifier of the patient. */
    id?: number;
    /** Gets or sets the first name of the patient. */
    firstName?: string | undefined;
    /** Gets or sets the last name of the patient. */
    lastName?: string | undefined;
    /** Gets or sets the date and time when the duplicate review was completed. */
    duplicateReviewedAt?: DateTime | undefined;
}

/** Represents a potential duplicate patient match, including the matched patient and the fields that were identified as matching. */
export interface DuplicatePatientMatchDto {
    /** Gets or sets the patient associated with this record. */
    patient: DuplicatePatientDto;
    /** Gets or sets the collection of field names that matched the search criteria. */
    matchingFields: string[];
}

/** Represents a command to merge two patient records by reassigning all orders from the destination patient to the source patient, then soft-deleting the destination patient. */
export interface MergePatientsCommand {
    /** The ID of the patient to keep and receive the merged data. */
    sourcePatientId?: number;
    /** The ID of the patient to be merged into the source and subsequently deleted. */
    destinationPatientId?: number;
}

/** Represents a command to mark a patient record as reviewed for duplicate detection. */
export interface DuplicatePatientReviewedCommand {
    /** The ID of the patient to mark as reviewed. */
    patientId?: number;
}

/** Response model for retrieving patient commercialization notes. */
export interface GetPatientCommercializationNotesQueryResponse {
    /** The unique identifier of the patient commercialization note. */
    patientCommercializationNoteId?: number;
    /** The date and time when the note was last updated (or masked representation). */
    lastUpdated?: any;
    /** The name of the user who last updated the note (or masked representation). */
    lastUpdatedBy?: string;
    /** Indicates if the note data is masked due to pharmacy consent settings; cross-pharmacy notes remain visible but masked when required. */
    isMasked?: boolean;
    /** The commercialization note associated with the patient and workflow (or masked representation). */
    note?: string;
    /** The workflow associated with the commercialization note (or masked representation). */
    workflow?: string;
}

/** Command to create an external identifier linking a patient to a source system program. */
export interface CreatePatientExternalIdCommand {
    /** The unique identifier of the patient. */
    patientId?: number;
    /** The unique identifier of the workflow associated with the external reference. */
    workflowId?: number;
    /** The unique identifier of the source system providing the external reference. */
    sourceSystemId?: number;
    /** The external program identifier assigned by the source system. */
    programId?: string;
}

/** Represents a command to delete a patient external reference by its unique identifier. */
export interface DeletePatientExternalIdCommand {
    /** The unique identifier of the patient external reference to delete. */
    patientExternalReferenceId?: number;
}

/** A single entry in a user's recently-viewed-patients list. Display fields are resolved at read time; only PatientId and PharmacyId are persisted. */
export interface RecentPatientResponse {
    /** The patient's unique identifier. */
    patientId?: number;
    /** The pharmacy context the patient was viewed in. */
    pharmacyId?: number;
    /** The short name of the pharmacy, for the display prefix. */
    pharmacyShortName?: string | undefined;
    /** The patient's first name. */
    firstName?: string;
    /** The patient's last name. */
    lastName?: string;
    /** The patient's preferred name, if any. */
    preferredName?: string | undefined;
}

/** Records that the current user viewed a patient, maintaining a per-user, most-recent-first list capped at MaxRecentPatients (FILO: re-viewing bumps to the top; the oldest beyond the cap is evicted). Invalidates the user's cached recent list; callers re-read via GetRecentPatientsQuery. */
export interface RecordRecentPatientCommand {
    /** The patient that was viewed (Patient Search path; pair with PharmacyId). */
    patientId?: number | undefined;
    /** The pharmacy the patient was viewed in (Patient Search path; pair with PatientId). */
    pharmacyId?: number | undefined;
    /** An order the patient was opened from (order-bucket path); the patient and pharmacy are resolved from the order. */
    orderId?: number | undefined;
}

/** Response containing the current lock state of a patient workflow resource. */
export interface GetPatientWorkflowLockQueryResponse {
    /** The patient ID. */
    patientId?: number;
    /** The workflow ID. */
    workflowId?: number;
    /** The pharmacy ID. */
    pharmacyId?: number;
    /** The resource type. */
    resourceType?: string;
    /** Whether the resource is currently locked. */
    isLocked?: boolean;
    /** The user ID of the lock holder, or null if not locked. */
    lockedBy?: number | undefined;
    /** The display name of the lock holder, or null if not locked. */
    lockedByName?: string | undefined;
    /** When the lock was acquired, or null if not locked. */
    lockedAt?: DateTime | undefined;
    /** When the lock expires, or null if not locked. */
    expiresAt?: DateTime | undefined;
    /** Whether there is a pending lock request. */
    hasPendingRequest?: boolean;
    /** The user ID of the requester, or null. */
    requestedBy?: number | undefined;
    /** The display name of the requester, or null. */
    requestedByName?: string | undefined;
}

/** Response returned from a try-acquire lock attempt. The frontend compares LockedBy with the current user to determine if the lock was acquired. */
export interface TryAcquirePatientWorkflowLockCommandResponse {
    patientId?: number;
    workflowId?: number;
    resourceType?: string;
    lockedBy?: number;
    lockedByName?: string;
    lockedAt?: DateTime;
    expiresAt?: DateTime;
    lockStealTimeoutSeconds?: number;
    isNewLock?: boolean;
}

/** Request body for trying to acquire a lock on a patient workflow resource. */
export interface TryAcquirePatientWorkflowLockBody {
    /** Optional device information for the lock holder. */
    deviceInfo?: string | undefined;
    /** The SignalR connection ID of the lock holder. */
    connectionId?: string;
}

/** Response returned after successfully requesting a patient workflow lock. */
export interface RequestPatientWorkflowLockCommandResponse {
    /** The UTC timestamp when the request expires. */
    requestExpiresAt?: DateTime;
    /** The number of seconds before the request can be auto-stolen. */
    timeoutSeconds?: number;
}

/** Shared request body for patient workflow lock operations that only require a SignalR connection ID. */
export interface PatientWorkflowLockConnectionIdBody {
    /** The SignalR connection ID. */
    connectionId?: string;
}

/** Response returned after successfully stealing a patient workflow lock. */
export interface StealPatientWorkflowLockCommandResponse {
    /** The UTC timestamp when the stolen lock expires. */
    expiresAt?: DateTime;
}

/** Query to retrieve a list of GetPharmacySelectListQueryResponse. */
export interface GetPharmacySelectListQueryResponse {
    id?: number;
    name?: string;
    shortName?: string | undefined;
}

/** Represents the response for a query to retrieve pharmacy details. */
export interface GetPharmacyQueryResponse {
    /** The Id of the pharmacy. */
    pharmacyId?: number;
    /** The full name of the pharmacy. */
    name?: string;
    /** A short or abbreviated name for the pharmacy. */
    shortName?: string | undefined;
    /** The primary address line of the pharmacy. */
    addressLine1?: string;
    /** A secondary address line. */
    addressLine2?: string | undefined;
    /** The city where the pharmacy is located. */
    city?: string;
    /** The value code of the province where the pharmacy is located. */
    province?: string;
    /** The postal code of the pharmacy's location. */
    postalCode?: string;
    /** The primary contact telephone number. */
    tel?: string;
    /** A secondary contact telephone number. */
    secondaryTel?: string | undefined;
    /** The fax number for the pharmacy. */
    fax?: string;
    /** The email address of the pharmacy. */
    email?: string;
    /** The first name of the pharmacy manager. */
    pharmacyManagerFirstName?: string;
    /** The last name of the pharmacy manager. */
    pharmacyManagerLastName?: string;
    /** The Id of the pharmacy manager. */
    pharmacyManagerId?: number;
    /** The hours of operation of the pharmacy. */
    hoursOfOperation?: string | undefined;
    /** Indicates whether the pharmacy uses default transfer to Kroll. */
    defaultTransferToKroll?: boolean;
    /** Indicates whether the Sentrex driver is enabled for the pharmacy. */
    enableSentrexDriver?: boolean;
    /** The number of business days until the next order, if applicable. */
    nextOrderBusinessDays?: number | undefined;
    /** Optional client ID for Nexus integration. */
    nexusClientId?: string | undefined;
    /** Optional secret for Nexus integration. */
    nexusSecret?: string | undefined;
    /** Flag to indicate if Nexus connection is active or not. */
    nexusActive?: boolean;
    /** Indicates whether to validate the driver's schedule. */
    validateDriverSchedule?: boolean;
    /** The number of seconds before a lock can be stolen, if applicable. */
    lockStealTimeoutSeconds?: number | undefined;
}

/** Represents the response from the GetPharmacyAssociatedUsersQuery. */
export interface GetPharmacyAssociatedUsersQueryResponse {
    id?: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    role?: UserRole;
    allowAssignOrders?: boolean;
    excludeFromAssignmentList?: boolean;
    allowPerformClinicalValidation?: boolean;
    commercializationAccess?: boolean;
    dateAssociated?: DateTime | undefined;
    dateRevoked?: DateTime | undefined;
}

/** association of a user with a pharmacy, updating existing record or creating new one. */
export interface AssociateUserToPharmacyCommand {
    pharmacyId?: number;
    userId?: number;
    /** The role to assign to the user for this pharmacy */
    role?: UserRole;
    /** Whether the user can be assigned orders */
    allowAssignOrders?: boolean;
    /** Whether to exclude the user from assignment lists */
    excludeFromAssignmentList?: boolean;
    /** Whether the user can perform clinical validation */
    allowPerformClinicalValidation?: boolean;
    /** Whether the user has commercialization access */
    commercializationAccess?: boolean;
}

/** Command to remove the association between a user and a pharmacy. */
export interface UnassociatePharmacyUserCommand {
    /** The unique identifier of the pharmacy to unassociate from the user. */
    pharmacyId?: number;
    /** The unique identifier of the user to unassociate from the pharmacy. */
    userId?: number;
}

/** Represents a response record for pharmacy courier query results containing courier information associated with a pharmacy. */
export interface GetPharmacyCouriersQueryResponse {
    /** The unique identifier for the pharmacy-courier association. */
    pharmacyCourierId?: number;
    /** The unique identifier of the pharmacy. */
    pharmacyId?: number;
    /** The unique identifier of the courier. */
    courierId?: number;
    /** The value code representing the courier. */
    courierValueCode?: string;
    /** The descriptive name or details of the courier. */
    courierDescription?: string;
}

/** Response model returned after successfully creating a pharmacy courier association. */
export interface CreatePharmacyCourierCommandResponse {
    /** The unique identifier for the newly created pharmacy courier relationship. */
    pharmacyCourierId?: number;
}

/** Command to create a new association between a pharmacy and a courier service. */
export interface CreatePharmacyCourierCommand {
    /** The unique identifier of the pharmacy. */
    pharmacyId?: number;
    /** The unique identifier of the courier service. */
    courierId?: number;
}

/** A response to a command to update the pharmacy */
export interface UpdatePharmacyResponse {
    /** The Id of the pharmacy */
    id?: number;
}

/** Represents a command to update an existing pharmacy's details. */
export interface UpdatePharmacyCommand {
    /** The Id of the pharmacy. */
    id?: number;
    /** The full name of the pharmacy. */
    name?: string;
    /** A short or abbreviated name for the pharmacy. */
    shortName?: string | undefined;
    /** The primary address of the pharmacy. */
    addressLine1?: string;
    /** A secondary address line. */
    addressLine2?: string | undefined;
    /** The city where the pharmacy is located. */
    city?: string;
    /** The value code of the province where the pharmacy is located. */
    province?: string;
    /** The postal code of the pharmacy. */
    postalCode?: string;
    /** The primary contact telephone number. */
    tel?: string;
    /** A secondary contact telephone number. */
    secondaryTel?: string | undefined;
    /** The fax number for the pharmacy. */
    fax?: string;
    /** The email address of the pharmacy. */
    email?: string;
    /** The Id of the pharmacy manager. */
    pharmacyManagerId?: number;
    /** The hours of operation of the pharmacy. */
    hoursOfOperation?: string | undefined;
    /** Indicates whether the pharmacy uses default transfer to Kroll. */
    defaultTransferToKroll?: boolean;
    /** Indicates whether the Sentrex driver is enabled for the pharmacy. */
    enableSentrexDriver?: boolean;
    /** Indicates whether to validate the driver's schedule. */
    validateDriverSchedule?: boolean;
    /** The number of business days until the next order, if applicable. */
    nextOrderBusinessDays?: number | undefined;
    /** The number of seconds before a lock can be stolen, if applicable. */
    lockStealTimeoutSeconds?: number | undefined;
}

/** Represents the response for querying the daily capacity of a pharmacy. */
export interface GetPharmacyDailyCapacityQueryResponse {
    /** The unique identifier for the daily capacity record. */
    id?: number;
    /** The unique identifier for the pharmacy. */
    pharmacyId?: number;
    /** The type of daily capacity (e.g., appointments, prescriptions). */
    dailyCapacityType?: string;
    /** The daily capacity for Sunday. */
    sun?: number;
    /** The daily capacity for Monday. */
    mon?: number;
    /** The daily capacity for Tuesday. */
    tue?: number;
    /** The daily capacity for Wednesday. */
    wed?: number;
    /** The daily capacity for Thursday. */
    thu?: number;
    /** The daily capacity for Friday. */
    fri?: number;
    /** The daily capacity for Friday. */
    sat?: number;
}

/** Represents the response for creating a pharmacy daily capacity. */
export interface CreatePharmacyDailyCapacityCommandResponse {
    /** The unique identifier of the created pharmacy daily capacity. */
    pharmacyDailyCapacityId?: number;
}

/** Command to create a pharmacy's daily capacity. */
export interface CreatePharmacyDailyCapacityCommand {
    /** The unique identifier for the pharmacy daily capacity record. */
    id?: number;
    /** The unique identifier of the pharmacy. */
    pharmacyId?: number;
    /** The type of daily capacity (e.g., delivery, pickup). */
    dailyCapacityType?: string;
    /** The daily capacity for Sunday. */
    sun?: number;
    /** The daily capacity for Monday. */
    mon?: number;
    /** The daily capacity for Tuesday. */
    tue?: number;
    /** The daily capacity for Wednesday. */
    wed?: number;
    /** The daily capacity for Thursday. */
    thu?: number;
    /** The daily capacity for Friday. */
    fri?: number;
    /** The daily capacity for Saturday. */
    sat?: number;
}

/** Represents the response for updating the daily capacity of a pharmacy. */
export interface UpdatePharmacyDailyCapacityCommandResponse {
    /** The unique identifier of the updated pharmacy daily capacity. */
    pharmacyDailyCapacityId?: number;
}

/** Command to update the daily capacity of a pharmacy. */
export interface UpdatePharmacyDailyCapacityCommand {
    /** The unique identifier of the pharmacy daily capacity record. */
    id?: number;
    /** The unique identifier of the pharmacy. */
    pharmacyId?: number;
    /** The type of daily capacity (e.g., delivery, pickup). */
    dailyCapacityType?: string;
    /** The daily capacity for Sunday. */
    sun?: number;
    /** The daily capacity for Monday. */
    mon?: number;
    /** The daily capacity for Tuesday. */
    tue?: number;
    /** The daily capacity for Wednesday. */
    wed?: number;
    /** The daily capacity for Thursday. */
    thu?: number;
    /** The daily capacity for Friday. */
    fri?: number;
    /** The daily capacity for Saturday. */
    sat?: number;
}

/** Response model representing an entry in the pharmacy address book. Contains location and contact information for a pharmacy. */
export interface GetPharmacyAddressBookQueryResponse {
    /** The unique identifier for the address entry. */
    id?: number;
    /** The name or description of the pharmacy location. */
    location?: string;
    /** The primary address line. */
    addressLine1?: string;
    /** The secondary address line, if available. */
    addressLine2?: string | undefined;
    /** The city where the pharmacy is located. */
    city?: string;
    /** The province or state where the pharmacy is located. */
    province?: string;
    /** The postal code for the pharmacy address. */
    postalCode?: string;
    /** The contact phone number for the pharmacy, if available. */
    phone?: string;
    /** The phone extension, if available. */
    phoneExt?: string | undefined;
    /** The unique identifier of the parent pharmacy. */
    pharmacyId?: number;
    /** The type of address (optional). */
    addressType?: AddressType | undefined;
    /** The email address, if available. */
    email?: string | undefined;
    /** The delivery instructions, if available. */
    deliveryInstructions?: string | undefined;
}

export enum AddressType {
    HOME = 1,
    RELAY = 2,
}

/** Response record returned after successfully creating an address book entry */
export interface CreatePharmacyAddressBookCommandResponse {
    /** The unique identifier of the created address book entry */
    id?: number;
}

/** Command to create a new address book entry for a pharmacy. */
export interface CreatePharmacyAddressBookCommand {
    /** The location name or identifier for this address. */
    location?: string;
    /** The primary address line. */
    addressLine1?: string;
    /** The secondary address line (optional). */
    addressLine2?: string | undefined;
    /** The city name. */
    city?: string;
    /** The province code or name. */
    province?: string;
    /** The postal code. */
    postalCode?: string;
    /** The primary phone number. */
    phone?: string;
    /** The phone extension (optional). */
    phoneExt?: string | undefined;
    /** The ID of the pharmacy to associate with this address. */
    pharmacyId?: number;
    /** The type of address (optional). */
    addressType?: AddressType | undefined;
    /** The email address (optional). */
    email?: string | undefined;
    /** The delivery instructions for the address (optional). */
    deliveryInstructions?: string | undefined;
}

/** Response object returned after updating a pharmacy address book. */
export interface UpdatePharmacyAddressBookCommandResponse {
    /** The identifier of the updated pharmacy address book. */
    id?: number;
}

/** Command to update an existing pharmacy address book entry */
export interface UpdatePharmacyAddressBookCommand {
    /** The unique identifier of the address book entry to update */
    id?: number;
    /** The location name for the address */
    location?: string;
    /** The primary address line */
    addressLine1?: string;
    /** Optional secondary address line */
    addressLine2?: string | undefined;
    /** The city name */
    city?: string;
    /** The province or state */
    province?: string;
    /** The postal or ZIP code */
    postalCode?: string;
    /** The contact phone number */
    phone?: string;
    /** Optional phone extension */
    phoneExt?: string | undefined;
    /** The unique identifier of the associated pharmacy */
    pharmacyId?: number;
    /** Optional type of address */
    addressType?: AddressType | undefined;
    /** Optional email address */
    email?: string | undefined;
    /** Optional delivery instructions */
    deliveryInstructions?: string | undefined;
}

/** Command to delete a pharmacy address book entry by its ID. */
export interface DeletePharmacyAddressBookCommand {
    /** The unique identifier of the address book entry to delete. */
    id?: number;
}

/** Represents the count of items grouped by date. */
export interface ItemCountByDateDto {
    date?: DateTime;
    count?: number;
}

export interface UpdatePharmacyNexusIntegrationCommandResponse {
    nexusClientId?: string | undefined;
}

/** Command to update the Nexus integration settings for a pharmacy. */
export interface UpdatePharmacyNexusIntegrationCommand {
    /** The unique identifier of the pharmacy. */
    pharmacyId?: number;
    /** The Nexus client ID for the pharmacy. */
    nexusClientId?: string;
    /** The Nexus secret for the pharmacy. */
    nexusSecret?: string;
    /** Flag to indicate if the connection to Nexus is active or not. */
    nexusActive?: boolean;
}

/** Command to update the Nexus connection setting for a pharmacy. */
export interface UpdatePharmacyNexusConnectionCommand {
    /** The unique identifier of the pharmacy. */
    pharmacyId?: number;
    /** Flag to indicate if the connection to Nexus is active or not. */
    nexusActive?: boolean;
}

/** Response for testing the Nexus connection. */
export interface TestPharmacyNexusConnectionQueryResponse {
    /** The message indicating the connection status. */
    message?: string;
}

/** Response record returned after successfully creating a driver schedule */
export interface CreateSentrexDriverScheduleCommandResponse {
    /** The unique identifier of the newly created driver schedule */
    id?: number;
}

/** Command to create a new Sentrex driver schedule with specified availability and capacity. */
export interface CreateSentrexDriverScheduleCommand {
    /** The Forward Sortation Area (postal code prefix) for the driver's delivery area. */
    fsa?: string;
    /** The city where the driver operates. */
    city?: string;
    /** Indicates whether the driver is available on Monday. */
    mon?: boolean;
    /** Indicates whether the driver is available on Tuesday. */
    tue?: boolean;
    /** Indicates whether the driver is available on Wednesday. */
    wed?: boolean;
    /** Indicates whether the driver is available on Thursday. */
    thu?: boolean;
    /** Indicates whether the driver is available on Friday. */
    fri?: boolean;
    /** The time slot or delivery window for the driver's schedule. */
    time?: string | undefined;
    /** The id of the Route. */
    routeId?: number;
    /** Details about the relay. */
    relayInfo?: string | undefined;
}

/** Command to update an existing Sentrex driver schedule with modified details */
export interface UpdateSentrexDriverScheduleCommand {
    /** The unique identifier of the driver schedule to update */
    id?: number;
    /** The Forward Sortation Area (first three characters of postal code) for the delivery area */
    fsa?: string;
    /** The city name where the driver operates */
    city?: string;
    /** Indicates whether the driver is available on Monday */
    mon?: boolean;
    /** Indicates whether the driver is available on Tuesday */
    tue?: boolean;
    /** Indicates whether the driver is available on Wednesday */
    wed?: boolean;
    /** Indicates whether the driver is available on Thursday */
    thu?: boolean;
    /** Indicates whether the driver is available on Friday */
    fri?: boolean;
    /** The time window or schedule for the driver's deliveries */
    time?: string | undefined;
    /** The id of the Route. */
    routeId?: number;
    /** Details about the relay. */
    relayInfo?: string | undefined;
}

/** Response object containing driver schedule information for the GetSentrexDriverSchedules query. */
export interface GetSentrexDriverSchedulesQueryResponse {
    /** Unique identifier for the driver schedule. */
    id?: number;
    /** Forward Sortation Area (first three characters of postal code). */
    fsa?: string;
    /** City name where the schedule applies. */
    city?: string;
    /** Indicates if the driver is available on Monday. */
    mon?: boolean;
    /** Indicates if the driver is available on Tuesday. */
    tue?: boolean;
    /** Indicates if the driver is available on Wednesday. */
    wed?: boolean;
    /** Indicates if the driver is available on Thursday. */
    thu?: boolean;
    /** Indicates if the driver is available on Friday. */
    fri?: boolean;
    /** Delivery time or time window for the schedule. */
    time?: string | undefined;
    /** The value code of the Route. */
    routeId?: number | undefined;
    /** Details about the relay. */
    relayInfo?: string | undefined;
}

/** Command to delete a Sentrex driver schedule by its ID. */
export interface DeleteSentrexDriverScheduleCommand {
    /** The unique identifier of the Sentrex driver schedule to delete. */
    id?: number;
}

/** Response record for the Sentrex driver availability query containing availability, capacity status, and time information. */
export interface GetSentrexDriverAvailabilityQueryResponse {
    /** Indicates whether the driver is available at the specified location. */
    isAvilableAtLocation?: boolean;
    /** Indicates whether the driver is available on the day of the week. */
    isAvailableOnDayOfWeek?: boolean;
    /** Indicates whether the driver has remaining capacity for deliveries. */
    hasCapacity?: boolean;
    /** Represents the time slot or period for the availability. */
    time?: string | undefined;
    /** Represents the relay info for the availability. */
    relayInfo?: string | undefined;
    /** The date of the next availiable delivery. */
    nextAvailableDeliveryDate?: DateTime | undefined;
    /** Indicates whether a delivery limit has been set for the requested weekday. False means the route has not been set up for that day, which is different from the day being full. */
    isCapacityConfigured?: boolean;
}

/** Response model for retrieving Sentrex driver route schedules. */
export interface GetSentrexDriverRouteQueryResponse {
    /** The unique identifier of the route. */
    id?: number;
    /** The route type value/code. */
    routeTypeValue?: string;
    /** The description of the route type. */
    routeTypeDescription?: string;
    /** The capacity for Monday deliveries. */
    monCapacity?: number;
    /** The capacity for Tuesday deliveries. */
    tueCapacity?: number;
    /** The capacity for Wednesday deliveries. */
    wedCapacity?: number;
    /** The capacity for Thursday deliveries. */
    thuCapacity?: number;
    /** The capacity for Friday deliveries. */
    friCapacity?: number;
    /** The driver schedule details for this route. */
    schedules?: SentrexDriverScheduleDTO[];
}

export interface SentrexDriverScheduleDTO {
    id?: number;
    fsa?: string | undefined;
    city?: string | undefined;
    mon?: boolean;
    tue?: boolean;
    wed?: boolean;
    thu?: boolean;
    fri?: boolean;
    time?: string | undefined;
    routeId?: number | undefined;
    relayInfo?: string | undefined;
}

/** Response containing the identifier of the newly created Sentrex driver route. */
export interface CreateSentrexDriverRouteCommandResponse {
    /** The unique identifier of the created driver route. */
    id?: number;
}

/** Command to create a new Sentrex driver route with weekly capacity settings. */
export interface CreateSentrexDriverRouteCommand {
    /** The route type identifier value. */
    routeTypeValue?: string;
    /** The capacity for Monday deliveries. */
    monCapacity?: number;
    /** The capacity for Tuesday deliveries. */
    tueCapacity?: number;
    /** The capacity for Wednesday deliveries. */
    wedCapacity?: number;
    /** The capacity for Thursday deliveries. */
    thuCapacity?: number;
    /** The capacity for Friday deliveries. */
    friCapacity?: number;
}

/** Command to update a Sentrex driver route with new capacity values and route type. */
export interface UpdateSentrexDriverRouteCommand {
    /** The unique identifier of the route to update. */
    routeId?: number;
    /** The route type value from the EnumRouteType enumeration. */
    routeTypeValue?: string;
    /** The capacity for Monday deliveries. */
    monCapacity?: number;
    /** The capacity for Tuesday deliveries. */
    tueCapacity?: number;
    /** The capacity for Wednesday deliveries. */
    wedCapacity?: number;
    /** The capacity for Thursday deliveries. */
    thuCapacity?: number;
    /** The capacity for Friday deliveries. */
    friCapacity?: number;
}

/** Command to delete a Sentrex driver route by its identifier. */
export interface DeleteSentrexDriverRouteCommand {
    /** The unique identifier of the route to delete. */
    id?: number;
}

/** Response to the command to create a new shipment. */
export interface CreateShipmentCommandResponse {
    /** The shipment Id */
    id?: number;
}

/** Command to create a new shipment with all necessary details. */
export interface CreateShipmentCommand {
    /** The recipient's attention or name. */
    shipToAttention?: string;
    /** The primary address line for the shipment. */
    addressLine1?: string;
    /** The secondary address line for the shipment (optional). */
    addressLine2?: string | undefined;
    /** The city where the shipment is being sent. */
    city?: string;
    /** The province or state of the shipment destination. */
    province?: string;
    /** The postal code of the shipment destination. */
    postalCode?: string;
    /** The email address of the recipient (optional). */
    email?: string | undefined;
    /** The phone number of the recipient (optional). */
    phone?: string | undefined;
    /** The phone extension of the recipient (optional). */
    phoneExt?: string | undefined;
    /** The courier service to be used for the shipment (optional). */
    courier?: string | undefined;
    /** Special instructions for the courier (optional). */
    courierInstruction?: string | undefined;
    /** Indicates if this is the final destination for the shipment. */
    isFinalDestination?: boolean;
    /** The date the shipment is scheduled to be sent (optional). */
    shipOnAtUtc?: DateTime | undefined;
    /** The estimated delivery date of the shipment (optional). */
    expectedDeliveryAtUtc?: DateTime | undefined;
    /** The Pharmacy Id. */
    pharmacyId?: number;
    /** The optional group shipment ID if this shipment is part of a group. */
    groupShipmentId?: number | undefined;
}

/** Response returned after a shipment update operation has been processed */
export interface UpdateShipmentCommandResponse {
    /** The unique identifier of the updated shipment */
    id?: number;
}

/** Command to update an existing shipment's details including address, contact information, courier details, and shipping dates. */
export interface UpdateShipmentCommand {
    /** The unique identifier of the shipment to update */
    id?: number;
    /** The name of the recipient or department */
    shipToAttention?: string;
    /** The primary address line */
    addressLine1?: string;
    /** The secondary address line (optional) */
    addressLine2?: string | undefined;
    /** The city name */
    city?: string;
    /** The province or state */
    province?: string;
    /** The postal or zip code */
    postalCode?: string;
    /** Contact email address (optional) */
    email?: string | undefined;
    /** Contact phone number (optional) */
    phone?: string | undefined;
    /** Phone extension (optional) */
    phoneExt?: string | undefined;
    /** The courier service name */
    courier?: string | undefined;
    /** Special instructions for the courier (optional) */
    courierInstruction?: string | undefined;
    /** Whether this is the final destination for the shipment */
    isFinalDestination?: boolean;
    /** The scheduled shipping date (optional) */
    shipOnAt?: DateTime | undefined;
    /** The expected delivery date (optional) */
    expectedDeliveryAt?: DateTime | undefined;
}

/** Represents the response for creating a shipment track number. */
export interface CreateShipmentTrackNumberCommandResponse {
    /** The unique identifier of the created shipment track number. */
    shipmentTrackNumberId?: number;
}

/** Command to create a shipment tracking number. */
export interface CreateShipmentTrackNumberCommand {
    /** The ID of the shipment. */
    shipmentId?: number;
    /** The tracking number to associate with the shipment. */
    trackingNumber?: string;
}

/** Response model containing tracking number information for a shipment. */
export interface GetShipmentTrackNumbersQueryResponse {
    /** The unique identifier of the tracking record. */
    id?: number;
    /** The identifier of the associated shipment. */
    shipmentId?: number;
    /** The tracking number used to track the shipment. */
    trackingNumber?: string;
}

/** Command to delete multiple shipment tracking numbers by their IDs. */
export interface DeleteShipmentTrackNumbersCommand {
    /** List of tracking number IDs to be deleted from the system. */
    ids?: number[];
}

/** Command to delete shipments from the system. */
export interface DeleteShipmentsCommand {
    /** The unique identifiers of the shipments to delete. */
    ids?: number[];
}

/** Command to update one or more shipments' expected delivery date, and sets the actual delivery date to the expected delivery date. Command to update one or more shipments' tracking number(s). */
export interface UpdateShipmentsDeliveryDatesTrackingNumbersCommand {
    /** List of shipments to update */
    shipments?: ShipmentDeliveryDatesTrackNumbersDto[];
}

export interface ShipmentDeliveryDatesTrackNumbersDto {
    shipmentId?: number;
    expectedDeliveryAtUtc?: DateTime;
    trackingNumbers?: string[];
}

/** Command to update one or more shipments' tracking number(s). */
export interface UpdateShipmentTrackNumbersCommand {
    /** List of shipments with their tracking numbers to update. */
    shipments?: ShipmentTrackNumbersDto[];
}

/** Response model containing details about a group shipment, including its status, destination, and associated shipments. */
export interface GetGroupShipmentsQueryResponse {
    /** The unique identifier of the group shipment. */
    groupShipmentId?: number;
    /** The status of the group shipment. */
    groupShipmentStatus?: GroupShipmentStatus;
    /** Gets the status value representing the shipment status for a group. */
    groupShipmentStatusValue: string;
    /** A textual description of the group shipment's status. */
    groupShipmentStatusDescription: string;
    /** The final destination location of the group shipment. */
    finalDestinationLocation: string;
    /** The name of the group shipment. */
    groupName: string;
    /** The most recent timestamp when the group shipment was updated. */
    lastUpdated?: DateTime | undefined;
    /** The user who last updated the group shipment. */
    lastUpdatedBy?: string | undefined;
    /** A list of shipments associated with the group shipment. */
    shipments?: ShipmentDto[];
    /** Indicates whether the group shipment is locked. */
    isLocked?: boolean | undefined;
    /** The timestamp when the group shipment was verified. */
    groupVerifiedAt?: DateTime | undefined;
    /** The user who verified the group shipment. */
    groupVerifiedBy?: string | undefined;
}

/** Response model describing an existing group shipment whose final destination leg matches the delivery address, expected delivery date, and courier of the shipment being scheduled. Carries only what the booker needs to identify and choose between candidate groups: the destination, its receiving contact, and the terms the parcel travels under. Deliberately no patient identifiers — the contact details belong to the ship-to address, not to a patient. */
export interface GetMatchingGroupShipmentsQueryResponse {
    /** The unique identifier of the matching group shipment. */
    groupShipmentId?: number;
    /** The name of the matching group shipment. */
    groupName: string;
    /** The status value of the matching group shipment. */
    groupShipmentStatusValue: string;
    /** A textual description of the matching group shipment's status. */
    groupShipmentStatusDescription: string;
    /** The recipient (ship-to attention) on the group's final destination leg. */
    finalDestinationLocation: string;
    /** The primary address line of the group's final destination leg. */
    addressLine1: string;
    /** The secondary address line of the group's final destination leg. */
    addressLine2?: string | undefined;
    /** The city of the group's final destination leg. */
    city: string;
    /** The province of the group's final destination leg. */
    province: string;
    /** The postal code of the group's final destination leg. */
    postalCode: string;
    /** The ship date on the group's final destination leg. */
    shipOnAt?: DateTime | undefined;
    /** The expected delivery date on the group's final destination leg — the date that was matched. */
    expectedDeliveryAt?: DateTime | undefined;
    /** The courier value on the group's final destination leg. */
    courierValue?: string | undefined;
    /** The courier display name on the group's final destination leg. */
    courierName?: string | undefined;
    /** The receiving contact's phone number on the group's final destination leg. */
    phone?: string | undefined;
    /** The extension for Phone, if one was recorded. */
    phoneExt?: string | undefined;
    /** The receiving contact's email address on the group's final destination leg. */
    email?: string | undefined;
    /** The courier instruction on the group's final destination leg. An order joining the group
is delivered under these instructions, so the booker is shown them before agreeing. */
    courierInstruction?: string | undefined;
    /** The number of distinct orders already linked to the group shipment. */
    orderCount?: number;
    /** The group's relay legs, in shipping order. An order joining the group adopts these legs, so a
non-empty list means the booker's own relay legs would be discarded — the booker needs to see
where the group actually routes before agreeing to that. */
    relayLegs: MatchingGroupShipmentRelayLegResponse[];
}

/** A relay stop on a matching group shipment. Relay legs route to the pharmacy's own relay locations rather than to a patient, so like its parent this carries no patient identifiers. */
export interface MatchingGroupShipmentRelayLegResponse {
    /** The relay location (ship-to attention) on the leg. */
    location: string;
    /** The primary address line of the relay leg. */
    addressLine1: string;
    /** The secondary address line of the relay leg. */
    addressLine2?: string | undefined;
    /** The city of the relay leg. */
    city: string;
    /** The province of the relay leg. */
    province: string;
    /** The postal code of the relay leg. */
    postalCode: string;
    /** The ship date on the relay leg. */
    shipOnAt?: DateTime | undefined;
    /** The expected delivery date on the relay leg. */
    expectedDeliveryAt?: DateTime | undefined;
    /** The courier display name on the relay leg. */
    courierName?: string | undefined;
    /** The receiving contact's phone number at the relay stop. */
    phone?: string | undefined;
    /** The extension for Phone, if one was recorded. */
    phoneExt?: string | undefined;
    /** The receiving contact's email address at the relay stop. */
    email?: string | undefined;
    /** The courier instruction on the relay leg. */
    courierInstruction?: string | undefined;
}

/** Query to find existing group shipments that the order being scheduled could join. A group qualifies when it is unlocked, still accepting orders, and its final destination leg goes to the same delivery address and ship-to name, on the same ship date and expected delivery date, with the same courier. All five keys must match. Patient is deliberately not part of the match — a group is defined by destination, dates, and courier. */
export interface GetMatchingGroupShipmentsQuery {
    /** The order being scheduled. Groups this order already belongs to are excluded. */
    orderId?: number;
    /** The primary address line of the shipment being scheduled. */
    addressLine1?: string;
    /** The secondary address line of the shipment being scheduled. */
    addressLine2?: string | undefined;
    /** The city of the shipment being scheduled. */
    city?: string;
    /** The province of the shipment being scheduled. */
    province?: string;
    /** The postal code of the shipment being scheduled. */
    postalCode?: string;
    /** The ship-to name of the shipment being scheduled. */
    shipToAttention?: string | undefined;
    /** The courier value selected for the shipment being scheduled. */
    courier?: string | undefined;
    /** The ship date of the shipment being scheduled. */
    shipOnAtUtc?: DateTime;
    /** The expected delivery date of the shipment being scheduled. */
    expectedDeliveryAtUtc?: DateTime;
}

/** Response for the JoinGroupShipment operation. */
export interface JoinGroupShipmentCommandResponse {
    /** The order that joined the group. */
    orderId?: number;
    /** The group shipment joined. */
    groupShipmentId?: number;
    /** IDs of the order-shipment links created for the group's legs. */
    createdShipmentItemIds?: number[];
}

/** Adds an order to an existing group shipment: the order adopts the group's shipment legs, gives up its own, and is typed as a group delivery. */
export interface JoinGroupShipmentCommand {
    /** The order joining the group. */
    orderId?: number;
    /** The group shipment to join. */
    groupShipmentId?: number;
}

/** Represents the response for a query to get orders by group shipment id. */
export interface GetOrdersByGroupShipmentIdQueryResponse {
    /** The unique identifier of the order. */
    orderId?: number;
    /** The name of the workflow associated with the order. */
    workflowName?: string;
    /** The first name of the patient. */
    patientFirstName?: string;
    /** The last name of the patient. */
    patientLastName?: string;
    /** The preferred name of the patient */
    patientPreferredName?: string | undefined;
    /** The date of birth of the patient. */
    dateOfBirth?: DateTime | undefined;
    /** The external identifier associated with the order's patient. */
    externalId?: string | undefined;
    /** The value representing the status of the order. */
    orderStatusValue?: string;
    /** The description of the order status. */
    orderStatusDescription?: string;
    /** Most recent timestamp of the order */
    lastUpdated?: DateTime;
    /** FollowUpDtoMost recent follow up record */
    lastFollowUp?: FollowUpDto | undefined;
    /** The unique identifier(s) of the shipment items. */
    shipmentItemIds?: number[];
    /** The initial order */
    isInitial?: boolean;
    /** The user who last updated the shipment. */
    lastUpdatedBy?: string | undefined;
}

/** Response object returned after successfully creating a group shipment. */
export interface CreateGroupShipmentCommandResponse {
    /** The unique identifier of the newly created group shipment. */
    id?: number;
}

/** Command to create a new group shipment with shipping details. */
export interface CreateGroupShipmentCommand {
    /** The group name. */
    groupName?: string;
}

/** Response object containing a group shipment and its associated shipments. */
export interface GetGroupShipmentByIdQueryResponse {
    /** The unique identifier of the group shipment. */
    id?: number;
    /** The name of the group shipment. */
    groupName?: string;
    /** The value of the group shipment status. */
    groupStatusValue?: string | undefined;
    /** The description of the group shipment status. */
    groupStatusDescription?: string | undefined;
    /** List of shipments associated with the group shipment. */
    shipments?: ShipmentDto[];
}

/** Response returned after successfully updating a group shipment. */
export interface UpdateGroupShipmentCommandResponse {
    /** The identifier of the updated group shipment. */
    id?: number;
}

/** Command to update the name of an existing group shipment. */
export interface UpdateGroupShipmentCommand {
    /** The unique identifier of the group shipment to update. */
    id?: number;
    /** The new name to assign to the group shipment. */
    groupName?: string;
    /** The new status to assign to the group shipment. */
    groupStatusValue?: string;
}

/** Command to toggle the lock status of a group shipment. */
export interface ToggleLockGroupShipmentCommand {
    /** The unique identifier of the group shipment. */
    id?: number;
    /** The desired lock status of the group shipment. */
    lock?: boolean;
}

/** Command to verify a group shipment. */
export interface VerifyGroupShipmentCommand {
    /** The unique identifier of the group shipment to verify. */
    id?: number;
}

/** Command to report a delivery issue for a group shipment. */
export interface ReportGroupShipmentDeliveryIssueCommand {
    /** The unique identifier of the group shipment for which to report the delivery issue. */
    groupShipmentId?: number;
    /** The type of delivery issue being reported (corresponds to IssueType values). */
    issueTypeValue?: string;
    /** Additional notes or information about the delivery issue for follow-up purposes. */
    followUpNotes?: string;
    /** Indicates whether a replacement order should be created for the affected orders in the group shipment. */
    createReplacementOrder?: boolean;
    /** Optional notes for the replacement order follow-up. */
    replacementOrderFollowUpNotes?: string | undefined;
}

/** Command to raise an issue for a group shipment and update affected orders */
export interface RaiseGroupShipmentIssueCommand {
    /** The ID of the group shipment where the issue occurred */
    groupShipmentId?: number;
    /** The type of issue that occurred with the shipment */
    issueTypeValue?: string;
    /** Notes regarding the follow-up action for this issue */
    followUpNotes?: string;
    /** The date when the issue follow-up is scheduled in UTC */
    followUpDateUtc?: DateTime;
    /** Indicates whether this issue requires urgent attention */
    isUrgent?: boolean;
}

/** Command to reschedule a group shipment. This sets orders to urgent status, marks them as requiring rescheduling, and optionally adds follow-up notes. Note: Rescheduling group shipments moves orders to the Follow Up Orders list (ISSUE_RESCHEDULE status), which triggers automatic soft deletion of related tracking numbers from ShipmentTrackNumbers. */
export interface RescheduleGroupShipmentCommand {
    /** The ID of the group shipment to reschedule */
    groupShipmentId?: number;
}

/** Command to deliver a group shipment by updating its status to DELIVERED and marking all associated orders as delivered. */
export interface DeliverGroupShipmentCommand {
    /** The unique identifier of the group shipment to deliver. */
    groupShipmentId?: number;
}

/** Command to update the group shipment status and order status for all orders associated with a group shipment. */
export interface UpdateGroupShipmentStatusCommand {
    /** The unique identifier of the group shipment. */
    groupShipmentId?: number;
    /** The value of the group shipment status to set. */
    groupShipmentStatusValue?: string;
    /** The value of the order status to set for all associated orders. */
    orderStatusValue?: string;
}

/** Response object containing a group shipment status. */
export interface GetGroupShipmentStatusQueryResponse {
    /** The unique identifier of the group shipment. */
    id?: number;
    /** The value of the group shipment status. */
    groupStatusValue?: string;
    /** The description of the group shipment status. */
    groupStatusDescription?: string;
}

/** Represents a response to the GetUsersQuery. */
export interface GetUsersQueryResponse {
    id?: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    isAdmin?: boolean;
    tenantId?: string | undefined;
    currentPharmacy?: PharmacyAccessResponse | undefined;
    pharmacyAccessList?: PharmacyAccessResponse[] | undefined;
}

/** Represents a query to get all users. */
export interface GetUsersQuery {
}

/** Represents a response to the GetUserByIdQuery. */
export interface GetUserByIdQueryResponse {
    userId?: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    isAdmin?: boolean;
    tenantId?: string | undefined;
    /** The user's current pharmacy access */
    currentPharmacy?: PharmacyAccessResponse | undefined;
    /** Array of all pharmacy roles for the user */
    roles?: PharmacyAccessResponse[] | undefined;
}

/** Represents a command to update a user. */
export interface UpdateUserCommand {
    /** User's unique identifier */
    id?: number;
    /** User's first name */
    firstName?: string;
    /** User's last name */
    lastName?: string;
    /** Whether the user has admin privileges */
    isAdmin?: boolean;
    /** Array of role-pharmacy associations for the user */
    roles?: RolePharmacyRequest[];
}

/** Represents a pair of a role and a pharmacy. */
export interface RolePharmacyRequest {
    roleId?: UserRole;
    pharmacyId?: number;
}

export interface CreateUserCommandResponse {
    id?: number;
}

/** Represents a command to create a new user. */
export interface CreateUserCommand {
    /** User's first name */
    firstName?: string;
    /** User's last name */
    lastName?: string;
    /** User's email address */
    email?: string;
    /** Whether the user has admin privileges */
    isAdmin?: boolean;
    /** External Active Directory ID */
    externalADId?: string | undefined;
    /** Array of role-pharmacy associations for the user */
    roles?: RolePharmacyRequest[];
    /** User's time zone preference */
    timeZone?: SystemTimeZone | undefined;
}

export enum SystemTimeZone {
    MOUNTAIN_STANDARD_TIME = 1,
    PACIFIC_STANDARD_TIME = 2,
    CENTRAL_STANDARD_TIME = 3,
    ATLANTIC_STANDARD_TIME = 4,
    EASTERN_STANDARD_TIME = 5,
    NEWFOUNDLAND_STANDARD_TIME = 6,
    UTC = 7,
}

export interface GetADUserResponse {
    id?: string | undefined;
    email?: string | undefined;
    accountEnabled?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

/** Response model representing a user who can be assigned to tasks or resources */
export interface GetAssignableUsersQueryResponse {
    /** The unique identifier of the user */
    id?: number;
    /** The user's first name */
    firstName?: string;
    /** The user's last name */
    lastName?: string;
}

/** Query to get assignable users. */
export interface GetAssignableUsersQuery {
}

/** Represents the response for a query to retrieve workflow details. */
export interface GetWorkflowQueryResponse {
    /** The Id of the workflow. */
    workflowId?: number;
    /** The name of the workflow. */
    name?: string;
    /** A description for the workflow. */
    description?: string;
    /** The Id of the workflow type. */
    workflowTypeId?: WorkflowType;
    /** Flag to indicate if this workflow allows pharmacy to create new patients. */
    allowChangePharmacy?: boolean;
    /** Flag to indicate if this workflow allows pharmacy to change the pharmacy location of the incoming order. */
    allowNewPatientCreation?: boolean;
    /** The date this workflow is going to be retired (e.g. not used anymore). */
    dateRetired?: DateTime | undefined;
    /** The date this workflow was created. */
    dateCreated?: DateTime;
    /** The date this workflow was modified. */
    dateModified?: DateTime | undefined;
}

export enum WorkflowType {
    PSP = 1,
    CS = 2,
    PHARMACY = 3,
}

/** Represents a command to update an existing workflow's details. */
export interface UpdateWorkflowCommand {
    /** The Id of the workflow. */
    id?: number;
    /** The name of the workflow. */
    name?: string;
    /** A description for the workflow. */
    description?: string;
    /** The Id of the workflow type. */
    workflowTypeId?: WorkflowType;
    /** Flag to indicate if this workflow allows pharmacy to create new patients. */
    allowChangePharmacy?: boolean;
    /** Flag to indicate if this workflow allows pharmacy to change the pharmacy location of the incoming order. */
    allowNewPatientCreation?: boolean;
    /** The date this workflow is going to be retired (e.g. not used anymore). */
    dateRetired?: DateTime | undefined;
}

export interface CreateWorkflowResponse {
    id?: number;
}

/** Represents a command to create a new workflow. */
export interface CreateWorkflowCommand {
    /** The name of the workflow. */
    name?: string;
    /** A description for the workflow. */
    description?: string;
    /** The Id of the workflow type. */
    workflowTypeId?: WorkflowType;
    /** Flag to indicate if this workflow allows pharmacy to create new patients. */
    allowChangePharmacy?: boolean;
    /** Flag to indicate if this workflow allows pharmacy to change the pharmacy location of the incoming order. */
    allowNewPatientCreation?: boolean;
    /** The date this workflow is going to be retired (e.g. not used anymore). */
    dateRetired?: DateTime | undefined;
}

/** Represents a response record for client api key query results containing api key information associated with a workflow. */
export interface GetWorkflowApiKeysQueryResponse {
    /** The unique identifier for the client api key. */
    clientApiKeyId?: number;
    /** The unique identifier of the workflow. */
    workflowId?: number;
    /** The unique identifier of the source system. */
    sourceSystemId?: SourceSystem;
    /** The description of the source system. */
    sourceSystemDescription?: string;
    /** The unique identifier of the user. */
    tenantId?: string | undefined;
    /** Date and time when the api key expires. */
    expiresAt?: DateTime;
    /** The name associated with the client api key. */
    name?: string;
    /** The descriptive name or details of the api key. */
    clientApiKeyDescription?: string;
}

export enum SourceSystem {
    LUMINAV360 = 1,
    PRO = 2,
    LUMINAVNEXT = 3,
}

/** Response model returned after successfully creating a workflow client api key association. */
export interface CreateWorkflowApiKeyCommandResponse {
    /** The unique identifier for the newly created workflow client api key relationship. */
    clientApiKeyId?: number;
    /** The tenant identifier. */
    tenantId?: string;
    /** The generated API key. */
    apiKey?: string;
}

/** Command to create a new client api key for a workflow. */
export interface CreateWorkflowApiKeyCommand {
    /** The unique identifier of the workflow. */
    workflowId?: number;
    /** The unique identifier of the source system. */
    sourceSystemId?: SourceSystem;
    /** The name associated with the client api key. */
    name?: string;
    /** The date and time the client api key expires. */
    expiresAt?: DateTime;
    /** The user class type identifier. */
    userClassTypeId?: UserClassType;
}

export enum UserClassType {
    SYSTEM_USER = 1,
    THIRD_PARTY = 2,
}

/** Represents a command to update an existing client api key. */
export interface UpdateWorkflowApiKeyCommand {
    /** The Id of the client api key. */
    id?: number;
    /** The name associated with the client api key. */
    name?: string;
    /** The date this client api key expires. */
    expiresAt?: DateTime;
}

/** Represents a response record for pharmacy query results containing pharmacy information associated with a workflow. */
export interface GetWorkflowPharmaciesQueryResponse {
    /** The unique identifier for the pharmacy-workflow association. */
    id?: number;
    /** The unique identifier of the workflow. */
    workflowId?: number;
    /** The unique identifier of the pharmacy. */
    pharmacyId?: number;
    /** The name of the pharmacy. */
    pharmacyName?: string;
    /** The short name of the pharmacy. */
    pharmacyShortName?: string | undefined;
}

/** Response model returned after successfully creating a workflow pharmacy association. */
export interface CreateWorkflowPharmacyCommandResponse {
    /** The unique identifier for the newly created workflow pharmacy relationship. */
    id?: number;
}

/** Command to create a new association between a pharmacy and a workflow. */
export interface CreateWorkflowPharmacyCommand {
    /** The unique identifier of the workflow. */
    workflowId?: number;
    /** The unique identifier of the pharmacy. */
    pharmacyId?: number;
}

/** Response record for the GetWorkflowDrugs query, containing drug information associated with a workflow. */
export interface GetWorkflowDrugsQueryResponse {
    /** The unique identifier of the workflow-drug association. */
    id?: number;
    /** The unique identifier of the drug. */
    drugId?: number;
    /** The name of the drug's manufacturer. */
    manufacturerName?: string;
    /** The name of the drug. */
    name?: string;
    /** The generic name of the drug. */
    genericName?: string;
    /** The date when the drug was associated with the workflow. */
    dateAssociated?: DateTime;
    /** The description of the storage type. */
    storageTypeDescription?: string;
}

/** Command to associate multiple drugs with a workflow. */
export interface CreateWorkflowDrugsCommand {
    /** The ID of the workflow to associate drugs with. */
    workflowId?: number;
    /** List of drug IDs to associate with the workflow. */
    drugIds?: number[];
}

/** Response record representing a workflow drug dispense type */
export interface GetWorkflowDrugDispenseTypesQueryResponse {
    /** The unique identifier for the workflow drug */
    workflowDrugId?: number;
    /** The unique identifier for the dispense type */
    id?: number;
    /** The unique identifier for the dispense type */
    dispenseTypeId?: number;
    /** The description of the dispense type */
    description?: string;
    /** Whether orders for this workflow drug on this dispense type are handled in the Commercialization workflow */
    commercialize?: boolean;
}

/** Response record returned after successfully creating a workflow drug dispense type. */
export interface CreateWorkflowDrugDispenseTypeCommandResponse {
    /** The unique identifier of the newly created workflow drug dispense type. */
    id?: number;
}

/** Command to create a new workflow drug dispense type association. */
export interface CreateWorkflowDrugDispenseTypeCommand {
    /** The identifier of the workflow drug. */
    workflowDrugId?: number;
    /** The identifier of the dispense type. */
    dispenseTypeId?: number;
    /** Whether orders for this workflow drug on this dispense type are handled in the Commercialization
workflow (#34653). Defaults to false, so a newly added dispense type is never commercializable
until an admin sets it. */
    commercialize?: boolean;
}

/** Command to set the Commercialize flag on an existing workflow drug dispense type (#34653). */
export interface UpdateWorkflowDrugDispenseTypeCommand {
    /** The identifier of the workflow drug dispense type. */
    id?: number;
    /** True if orders for this workflow drug on this dispense type should be handled in the
Commercialization workflow; false to exclude them. */
    commercialize?: boolean;
}

/** Query to retrieve a list of GetWorkflowSelectListQueryResponse. */
export interface GetWorkflowSelectListQueryResponse {
    id?: number;
    name?: string;
    /** True when the workflow's retirement date has arrived. Only ever true for callers that asked for
retired workflows, since the others are filtered out before this point. */
    isRetired?: boolean;
}

/** Kroll patient data payload for linking a Kroll Patient ID with a Luminav Link patient. */
export interface NexusSetKrollPatientIdDto {
    /** (Required) The unique identifier for the patient link request. */
    requestedUniqueId: string;
    /** (Required) The Kroll patient ID to associate. Must be greater than 0. */
    patId: number;
    /** (Optional) Patient's first name. */
    patFirstName?: string | undefined;
    /** (Optional) Patient's last name. */
    patLastName?: string | undefined;
    /** (Optional) Patient's address line 1. */
    patAddress1?: string | undefined;
    /** (Optional) Patient's address line 2. */
    patAddress2?: string | undefined;
    /** (Optional) Patient's city. */
    patCity?: string | undefined;
    /** (Optional) Patient's province (2 uppercase letters). */
    patProv?: string | undefined;
    /** (Optional) Patient's postal code. */
    patPostal?: string | undefined;
    /** (Optional) Patient's country. */
    patCountry?: string | undefined;
}

/** Response returned after successfully creating an order through the integration API. */
export interface OrderIntegrationCommandResponse {
    /** The external reference identifier from the source system (e.g., Patient Program Identifier in 360). */
    sourceSystemExternalReferenceId: string;
    /** The external unique identifier from the source system (e.g., Record GUID in 360). */
    sourceSystemExternalId: string;
    /** The order ID as provided by the source system. */
    sourceSystemOrderID: string;
    /** The unique order identifier assigned by Luminav Link. */
    linkOrderID?: number;
    /** The current status of the order (e.g., "Waiting to be Accepted"). */
    orderStatus: string;
}

/** Request payload to create a patient order from an external source system. Includes patient demographics, drug information, shipping details, and optional attachments. */
export interface OrderIntegrationCommand {
    /** (Required) The unique identifier (GUID) of the target pharmacy. It should have a mapping in your application to the target pharmacy. For more pharmacies access Pharmacies/Allowed */
    pharmacyRecordGuid: string;
    /** (Required) The external unique immutable ID of the source system sending the order.
For example, in 360 this would be the Record GUID of the patient enrollment record.
For non 360 systems, this should be a unique identifier for the patient record in the source system to ensure idempotency and proper linking of orders to patients. */
    sourceSystemExternalId: string;
    /** (Required) The external reference identifier for the source system.
For example, in 360 this would be the Patient Program Identifier of the patient enrollment record. */
    sourceSystemExternalReferenceId: string;
    /** (Required) The order identifier from the source system. */
    orderId: string;
    /** (Required) Patient's first name. */
    firstName: string;
    /** (Required) Patient's last name. */
    lastName: string;
    /** (Optional) Patient's preferred name, if different from first name. */
    preferredName?: string | undefined;
    /** (Required) Patient's preferred language (e.g., "english"). For more enum, please access enum endpoint */
    preferredLanguage: string;
    /** (Required) Patient's date of birth. */
    dateOfBirth: DateTime;
    /** (Required) Patient's gender. For more enum, please access enum endpoint */
    gender: string;
    /** (Optional) Patient's health card number. */
    healthCardNumber?: string | undefined;
    /** (Optional) Patient's home phone number. */
    homePhone?: string | undefined;
    /** (Optional) Patient's cell phone number. */
    cellPhone?: string | undefined;
    /** (Optional) Patient's work phone number. */
    workPhone?: string | undefined;
    /** (Optional) Extension for the work phone number. */
    workPhoneExtension?: string | undefined;
    /** (Optional) Patient's email address. */
    email?: string | undefined;
    /** (Optional) Whether the home phone is the preferred contact number. */
    homePhonePreferred?: boolean | undefined;
    /** (Optional) Whether the cell phone is the preferred contact number. */
    cellPhonePreferred?: boolean | undefined;
    /** (Optional) Whether the work phone is the preferred contact number. */
    workPhonePreferred?: boolean | undefined;
    /** (Required) List of drugs prescribed for this order. At least one drug must be provided. */
    drugs: DrugDto[];
    /** (Optional) Estimated treatment start date in UTC. */
    estimatedTreatmentStartDateUtc?: DateTime | undefined;
    /** (Required) Patient's home address line 1. */
    homeAddress1: string;
    /** (Optional) Patient's home address line 2. */
    homeAddress2?: string | undefined;
    /** (Required) Patient's home city. */
    homeCity: string;
    /** (Required) Patient's home province (2-letter code). */
    homeProvince: string;
    /** (Required) Patient's home postal code. */
    homePostalCode: string;
    /** (Optional) Recipient name for shipping. */
    shipToName?: string | undefined;
    /** (Required) Shipping address line 1. */
    shippingAddress1: string;
    /** (Optional) Shipping address line 2. */
    shippingAddress2?: string | undefined;
    /** (Required) Shipping city. */
    shipCity: string;
    /** (Required) Shipping province (2-letter code). */
    shipProvince: string;
    /** (Required) Shipping postal code. */
    shipPostalCode: string;
    /** (Optional) Any special delivery or handling instructions. */
    specialInstructions?: string | undefined;
    /** (Required) Name of the person requesting the order. */
    requestorName: string;
    /** (Optional) Email of the person requesting the order. */
    requestorEmail?: string | undefined;
    /** (Optional) Email address of the program's shared inbox, shown alongside the requestor so staff can contact the program rather than the individual. */
    programEmail?: string | undefined;
    /** (Optional) List of file attachments (e.g., prescriptions) encoded in Base64. Max 5 attachments per document type. */
    attachments?: OrderAttachmentDto[] | undefined;
}

/** File attachment included with an integration order (e.g., prescriptions, lab results). */
export interface OrderAttachmentDto {
    /** (Required) Unique identifier for the attachment. */
    id: string;
    /** (Required) The type of document (e.g., "RX", "PERSONALIZED_LETTER", "COVERAGE_INFO"...). For more enum, please access enum endpoint */
    documentType: string;
    /** (Required) The original file name including extension. */
    fileName: string;
    /** (Required) The MIME type or file extension (e.g., "pdf", "png", "jpg", "txt"). */
    fileType: string;
    /** (Required) The file content encoded as a Base64 string. Max file size: 10MB. */
    file: string;
}

/** Detailed order information including shipping, status, drug details, and delivery tracking. */
export interface GetOrderDetailsQueryResponse {
    /** The external ID from the source system. */
    sourceSystemExternalId?: string | undefined;
    /** The unique identifier for the order in the Link system. */
    linkOrderId?: number;
    /** The current status of the order. */
    orderStatus?: string | undefined;
    /** The pharmacy record GUID associated with the order. */
    pharmacyRecordGuid?: string | undefined;
    /** The date the order was accepted. */
    dateAccepted?: DateTime | undefined;
    /** The date the order was verified. */
    dateVerified?: DateTime | undefined;
    /** The date the order's coverage was verified. */
    dateCoverageVerified?: DateTime | undefined;
    /** The name or attention line for the requested shipping address. */
    shipToAttention?: string | undefined;
    /** The first line of the requested shipping address. */
    shipToAddressLine1?: string | undefined;
    /** The second line of the requested shipping address. */
    shipToAddressLine2?: string | undefined;
    /** The city for the requested shipping address. */
    shipToCity?: string | undefined;
    /** The province for the requested shipping address. */
    shipToProvince?: string | undefined;
    /** The postal code for the requested shipping address. */
    shipToPostalCode?: string | undefined;
    /** The phone number for the requested shipping address. */
    shipToPhone?: string | undefined;
    /** The phone extension for the requested shipping address. */
    shipToPhoneExtension?: string | undefined;
    /** The email address for the requested shipping address. */
    shipToEmail?: string | undefined;
    /** The date the order was picked up by the courier. */
    datePickedUp?: DateTime | undefined;
    /** The date the order was delivered. */
    dateDelivered?: DateTime | undefined;
    /** The name of the courier used for delivery. */
    courierName?: string | undefined;
    /** The tracking number for the shipment. */
    trackingNumber?: string | undefined;
    /** The list of dispensed drugs for this order. */
    drugs?: OrderDetailsDrugDTO[] | undefined;
    /** The list of originally requested drugs for this order. */
    requestedDrugs?: OrderDetailsDrugDTO[] | undefined;
    /** The date and time when the order was rejected, if applicable. */
    dateRequestRejected?: DateTime | undefined;
    /** The reason why the order was rejected. */
    reasonForRejection?: string | undefined;
    /** Special delivery or handling instructions. */
    specialInstructions?: string | undefined;
    /** The estimated treatment start date, if available. */
    estimatedTreatmentStart?: DateTime | undefined;
    /** The name of the pharmacy associated with the order. */
    pharmacyName?: string | undefined;
    /** The name or attention line for the actual shipping address used. */
    actualShipToAttention?: string | undefined;
    /** The first line of the actual shipping address used. */
    actualShipToAddressLine1?: string | undefined;
    /** The second line of the actual shipping address used. */
    actualShipToAddressLine2?: string | undefined;
    /** The city for the actual shipping address used. */
    actualShipToCity?: string | undefined;
    /** The province for the actual shipping address used. */
    actualShipToProvince?: string | undefined;
    /** The postal code for the actual shipping address used. */
    actualShipToPostalCode?: string | undefined;
    /** The phone number for the actual shipping address used. */
    actualShipToPhone?: string | undefined;
    /** The phone extension for the actual shipping address used. */
    actualShipToPhoneExtension?: string | undefined;
    /** The email address for the actual shipping address used. */
    actualShipToEmail?: string | undefined;
    /** The expected delivery date for the order, if available. */
    expectedDeliveryDate?: DateTime | undefined;
    /** Gets a value indicating whether the order is currently in progress. */
    inProgress?: boolean;
}

/** Drug details for an order, including the drug name, quantity dispensed, and dispense type. */
export interface OrderDetailsDrugDTO {
    /** The name of the drug. */
    drugName?: string | undefined;
    /** The quantity dispensed. */
    quantity?: number;
    /** The dispense type (e.g., "RX", "OTC"). */
    dispenseType?: string | undefined;
}

/** Summary information for a patient order, used in order listing queries. */
export interface GetPatientOrdersQueryResponse {
    /** The external ID from the source system. */
    sourceSystemExternalId?: string | undefined;
    /** The unique identifier for the order in the Link system. */
    linkOrderID?: number;
    /** The machine-readable status value of the order (e.g., "SHIPPED"). */
    orderStatusValue?: string;
    /** The human-readable status of the order (e.g., "Shipped"). */
    orderStatus?: string;
    /** The date and time when the request was rejected, if applicable. */
    dateRequestRejected?: DateTime | undefined;
    /** The reason for rejection, if the request was rejected. */
    reasonForRejection?: string | undefined;
    /** The date and time when the order was created. */
    created?: DateTime | undefined;
    /** The name of the pharmacy associated with the order. */
    pharmacyName?: string | undefined;
    /** The user who created the order. */
    createdByUser?: string | undefined;
    /** The expected delivery date for the order, if available. */
    expectedDeliveryDate?: DateTime | undefined;
    /** The date the order was delivered. */
    dateDelivered?: DateTime | undefined;
    /** The date the order was picked up by the courier. */
    datePickedUp?: DateTime | undefined;
    /** The expected pickup date for the order, if available. */
    expectedPickupDate?: DateTime | undefined;
    /** Gets a value indicating whether the order is currently in progress. */
    inProgress?: boolean;
}

/** Response containing order information filtered by status or criteria. */
export interface GetOrdersQueryResponse {
    /** The unique identifier for the order in the Link system. */
    linkOrderId?: number;
    /** The date and time when the issue occurred. */
    issueAt?: DateTime | undefined;
    /** The issue value or code. */
    issueValue?: string;
    /** The detailed description of the issue. */
    issueDescription?: string;
    /** The current status of the order. */
    orderStatus?: string;
    /** The current status value (code) of the order. */
    orderStatusValue?: string;
}

/** Request to filter orders by a list of Link order identifiers. */
export interface OrderFilterRequest {
    /** (Required) A list of Link order identifiers to filter by. */
    orderIds: number[];
}

/** Per-order result of the deliver orders operation. */
export interface DeliverOrdersQueryResponse {
    /** The order ID that was processed. */
    orderId?: number;
    /** True if the order was processed successfully. */
    success?: boolean;
    /** Message describing the outcome (skip reason or error reason). */
    message?: string | undefined;
}

export interface GetOrderDispenseQueryResponse {
    /** Gets or sets the external identifier from the source system. */
    sourceSystemExternalId?: string | undefined;
    /** Gets or sets the Link order identifier. */
    orderItemId?: number;
    /** Gets or sets the current status of the order. */
    orderStatus?: string | undefined;
    /** Gets or sets the pharmacy record unique identifier. */
    pharmacyRecordGuid?: string | undefined;
    /** Gets or sets the date when the order was accepted. */
    dateAccepted?: DateTime | undefined;
    /** Gets or sets the province where the order will be shipped. */
    shipToProvince?: string | undefined;
    /** Gets or sets the date when the order was delivered. */
    dateDelivered?: DateTime | undefined;
    /** Gets or sets the name of the courier service. */
    courierName?: string | undefined;
    /** Gets or sets the tracking number for the shipment. */
    trackingNumber?: string | undefined;
    /** Gets or sets the name of the drug. */
    drugName?: string | undefined;
    /** Gets or sets the quantity of the drug dispensed. */
    drugQuantity?: number;
    /** Gets or sets the drug dispense type code. */
    drugDispenseTypeCode?: string | undefined;
    /** Gets or sets the Drug Identification Number (DIN). */
    drugDin?: string | undefined;
    /** Gets or sets the date when the drug record was created. */
    drugDateCreated?: DateTime;
    /** Gets or sets the date when the order was created. */
    dateCreated?: DateTime | undefined;
    /** Gets or sets the date when the order was shipped. */
    dateShipped?: DateTime | undefined;
    /** Gets or sets the date when the order was picked up. */
    datePickedUp?: DateTime | undefined;
    /** Gets or sets the name of the pharmacy. */
    pharmacyName?: string | undefined;
    /** Gets or sets the phone number of the pharmacy. */
    pharmacyPhone?: string | undefined;
    /** Gets or sets the fax number of the pharmacy. */
    pharmacyFax?: string | undefined;
    /** Gets or sets the first line of the pharmacy address. */
    pharmacyAddressLine1?: string | undefined;
    /** Gets or sets the second line of the pharmacy address. */
    pharmacyAddressLine2?: string | undefined;
    /** Gets or sets the city of the pharmacy address. */
    pharmacyAddressCity?: string | undefined;
    /** Gets or sets the province of the pharmacy address. */
    pharmacyAddressProvince?: string | undefined;
    /** Gets or sets the postal code of the pharmacy address. */
    pharmacyAddressPostalCode?: string | undefined;
    /** Gets or sets the unique identifier assigned to the transaction. */
    transactionNumber?: string | undefined;
    /** Gets or sets the pharmacy identifier. */
    pharmacyId?: number;
    /** Gets or sets the unique identifier for the pharmacy's email address. */
    pharmacyEmail?: string | undefined;
    /** Gets or sets the unique Kroll system identifier for the patient. */
    patientKrollId?: number | undefined;
    /** The fill date of the medication. */
    fillDate?: DateTime | undefined;
}

export interface DispenseDetailsFilterRequest {
    /** Gets or sets the list of order item identifiers to filter dispense details. */
    orderItemIds?: number[];
    /** Gets or sets the start date of the range to filter results. */
    fromDate?: DateTime | undefined;
    /** Gets or sets the end date of the range to filter results. */
    toDate?: DateTime | undefined;
    /** Gets or sets the type of action to be performed for the order dispense operation. */
    actionType?: OrderDispenseActionType | undefined;
}

export enum OrderDispenseActionType {
    COMPLETED = 0,
    CREATED = 1,
}

/** Patient coverage data (the actual payload) */
export interface PatientCoverageDto {
    /** Informational message explaining why coverage data could not be retrieved,
without indicating a technical error (e.g. no linked source system record found). */
    Message?: string | undefined;
    CoverageInsurances?: PatientCoverageInsuranceViewModel[] | undefined;
    ElectronicFinancialAssistances?: PatientElectronicFinancialAssistanceViewModel[] | undefined;
    ManualFinancialAssistances?: PatientManualFinancialAssistanceViewModel[] | undefined;
    NoChargeDrugs?: PatientNoChargeDrugViewModel[] | undefined;
}

export interface PatientCoverageInsuranceViewModel {
    CoverageInvestigationId?: string | undefined;
    CoverageStatusDescription?: string | undefined;
    DeductibleAmount?: number | undefined;
    DeductibleUnitValueCode?: string | undefined;
    DeductibleFrequencyDescription?: string | undefined;
    DeductiblePaymentFrequencyDescription?: string | undefined;
    DeductibleCalculationStartDate?: DateTime | undefined;
    DeductiblePaymentStartDate?: DateTime | undefined;
    DeductiblePersonalFamilyDescription?: string | undefined;
    AnnualMaxValueCode?: string | undefined;
    AnnualMaxValue?: number | undefined;
    LifetimeMaxValueCode?: string | undefined;
    LifetimeMaxValue?: number | undefined;
    OkRxDrugBrandCode?: string | undefined;
    DrugName?: string | undefined;
    InsurerName?: string | undefined;
    PriorAuth?: PatientPriorAuthViewModel | undefined;
    CarrierNumber?: string | undefined;
    GroupNumber?: string | undefined;
    CertificateNumber?: string | undefined;
    PlanHolderFirstName?: string | undefined;
    PlanHolderLastName?: string | undefined;
    PlanHolderRelationshipToPatient?: string | undefined;
    PlanHolderRelationshipToPatientDescription?: string | undefined;
    DateOfBirth?: DateTime | undefined;
}

export interface PatientPriorAuthViewModel {
    InsurerOutcomeDescription?: string | undefined;
    DateApprovalStarts?: DateTime | undefined;
    DateApprovalExpires?: DateTime | undefined;
}

export interface PatientElectronicFinancialAssistanceViewModel {
    CopayCardProvider?: string | undefined;
    CarrierNumber?: string | undefined;
    GroupNumber?: string | undefined;
    CertificateNumber?: string | undefined;
    OkRxDrugBrandCode?: string | undefined;
    DrugName?: string | undefined;
    Status?: string | undefined;
    Copay?: string | undefined;
    AnnualMax?: string | undefined;
    ElectronicExpiryDate?: DateTime | undefined;
}

export interface PatientManualFinancialAssistanceViewModel {
    SubmitToName?: string | undefined;
    SubmitToEmail?: string | undefined;
    SubmitToFax?: string | undefined;
    OkRxDrugBrandCode?: string | undefined;
    DrugName?: string | undefined;
    Status?: string | undefined;
    Copay?: string | undefined;
    AnnualMax?: string | undefined;
    ExpiryDate?: DateTime | undefined;
}

export interface PatientNoChargeDrugViewModel {
    ApprovedQuantityUnlimited?: boolean;
    DrugCommercialTypeDescription?: string | undefined;
    DrugCommercialFreeSubTypeDescription?: string | undefined;
    ApprovedQuantity?: number | undefined;
    OkRxDrugBrandCode?: string | undefined;
    DrugName?: string | undefined;
    Status?: string | undefined;
    ApprovalStartDate?: DateTime | undefined;
    ApprovalEndDate?: DateTime | undefined;
    ApprovalExpiryDate?: DateTime | undefined;
}

/** Response for GetAllowedPharmaciesQuery. */
export interface GetAllowedPharmaciesQueryResponse {
    /** The unique GUID identifier of the pharmacy. */
    id?: string;
    /** The pharmacy short name. */
    name?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}